/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "api/customer/service.proto" (package "rd.api.customer", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Tag } from "../../tag/models_pb";
import { Summary as Summary$ } from "../../bubv2/models_pb";
import { Summary } from "../../bub/models_pb";
import { Contacts_Contact_EmailFrequency } from "../../customer/models_pb";
import { BankPaymentMethod } from "../../payments/models_pb";
import { Card } from "../../payments/models_pb";
import { StatementInvoicesFormatType } from "../../statement/models_pb";
import { StatementType } from "../../statement/models_pb";
import { TimestampRange } from "../../proto/timestamprange/models_pb";
import { Statement } from "../../statement/models_pb";
import { StatementRun } from "../../statement/models_pb";
import { Customer_StatementType } from "../../customer/models_pb";
import { Customer_StatementInvoicesFormatType } from "../../customer/models_pb";
import { Customer_SignatureRequirement } from "../../customer/models_pb";
import { Interaction } from "../../customer/models_pb";
import { PurchaseOrder } from "../../customer/models_pb";
import { Customer_Type } from "../../customer/models_pb";
import { Address } from "../../proto/address/models_pb";
import { FinanceChargeSetting } from "../../company/models_pb";
import { CustomerSalesAnalytics } from "../../txn/models_pb";
import { Staff } from "../../company/models_pb";
import { Contacts } from "../../customer/models_pb";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
import { Money } from "../../proto/money/models_pb";
import { CustomerBalance } from "../../txn/models_pb";
import { FinancingTerms_Term } from "../../company/models_pb";
import { PricingTiers_Tier } from "../../company/models_pb";
import { Customer } from "../../customer/models_pb";
import { UUID } from "../../proto/uuid/models_pb";
// Customer 

/**
 * @generated from protobuf message rd.api.customer.GetCustomerReq
 */
export interface GetCustomerReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 2
     */
    locationId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.GetCustomerRes
 */
export interface GetCustomerRes {
    /**
     * @generated from protobuf field: rd.customer.Customer customer = 1
     */
    customer?: Customer;
    /**
     * @generated from protobuf field: rd.company.PricingTiers.Tier pricing_tier = 2
     */
    pricingTier?: PricingTiers_Tier;
    /**
     * @generated from protobuf field: rd.company.FinancingTerms.Term financing_term = 3
     */
    financingTerm?: FinancingTerms_Term;
    /**
     * @generated from protobuf field: string financing_term_name = 6
     */
    financingTermName: string;
    /**
     * @generated from protobuf field: rd.txn.CustomerBalance balance = 7
     */
    balance?: CustomerBalance;
    /**
     * @generated from protobuf field: rd.proto.money.Money total_balance = 8
     */
    totalBalance?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money max_charge_account_sale_total = 10
     */
    maxChargeAccountSaleTotal?: Money;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sale_today_due_at = 11
     */
    saleTodayDueAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.customer.Contacts contacts = 12
     */
    contacts?: Contacts;
    /**
     * @generated from protobuf field: bool is_charge_account = 14
     */
    isChargeAccount: boolean;
    /**
     * @generated from protobuf field: rd.company.Staff representative_staff = 15
     */
    representativeStaff?: Staff;
    /**
     * @generated from protobuf field: rd.txn.CustomerBalance last_statement_balance = 16
     */
    lastStatementBalance?: CustomerBalance;
    /**
     * @generated from protobuf field: rd.proto.money.Money last_statement_total_balance = 17
     */
    lastStatementTotalBalance?: Money;
    /**
     * @generated from protobuf field: rd.txn.CustomerSalesAnalytics analytics = 18
     */
    analytics?: CustomerSalesAnalytics;
    /**
     * @generated from protobuf field: rd.company.FinanceChargeSetting finance_charge_setting = 19
     */
    financeChargeSetting?: FinanceChargeSetting;
    /**
     * @generated from protobuf field: int32 custom_price_count = 20
     */
    customPriceCount: number;
    /**
     * @generated from protobuf field: float margin_ytd = 21
     */
    marginYtd: number;
    /**
     * @generated from protobuf field: rd.proto.money.Money remaining_statement_balance = 22
     */
    remainingStatementBalance?: Money;
}
/**
 * @generated from protobuf message rd.api.customer.CreateCustomerReq
 */
export interface CreateCustomerReq {
    /**
     * @generated from protobuf field: string pricing_tier_id_string = 1
     */
    pricingTierIdString: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string phone = 3
     */
    phone: string;
    /**
     * @generated from protobuf field: string email = 4
     */
    email: string;
    /**
     * @generated from protobuf field: string notes = 5
     */
    notes: string;
    /**
     * @generated from protobuf field: string sales_reminder = 6
     */
    salesReminder: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 7
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: bool sms_consent = 8
     */
    smsConsent: boolean;
    /**
     * @generated from protobuf field: rd.proto.address.Address address = 9
     */
    address?: Address;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tag_ids = 10
     */
    tagIds: UUID[];
    /**
     * @generated from protobuf field: rd.customer.Customer.Type type = 11
     */
    type: Customer_Type;
}
/**
 * @generated from protobuf message rd.api.customer.CreateCustomerRes
 */
export interface CreateCustomerRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.DuplicateCustomerReq
 */
export interface DuplicateCustomerReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.DuplicateCustomerRes
 */
export interface DuplicateCustomerRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.CreateCustomerInteractionReq
 */
export interface CreateCustomerInteractionReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string notes = 2
     */
    notes: string;
}
/**
 * @generated from protobuf message rd.api.customer.CreateCustomerInteractionRes
 */
export interface CreateCustomerInteractionRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerGeneralInformationReq
 */
export interface UpdateCustomerGeneralInformationReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string pricing_tier_id_string = 2
     */
    pricingTierIdString: string; // will be deprecated
    /**
     * @generated from protobuf field: string identifier = 3
     */
    identifier: string;
    /**
     * @generated from protobuf field: string name = 4
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.address.Address address = 5
     */
    address?: Address;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID primary_location_id = 6
     */
    primaryLocationId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerGeneralInformationRes
 */
export interface UpdateCustomerGeneralInformationRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerGeneralInfoMobileReq
 */
export interface UpdateCustomerGeneralInfoMobileReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string pricing_tier_id_string = 2
     */
    pricingTierIdString: string;
    /**
     * @generated from protobuf field: string identifier = 3
     */
    identifier: string;
    /**
     * @generated from protobuf field: string name = 4
     */
    name: string;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerGeneralInfoMobileRes
 */
export interface UpdateCustomerGeneralInfoMobileRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerExemptionsReq
 */
export interface UpdateCustomerExemptionsReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string eco_fee_exempt_number = 2
     */
    ecoFeeExemptNumber: string;
    /**
     * @generated from protobuf field: string sales_tax_exempt_number = 3
     */
    salesTaxExemptNumber: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID tax_rate_id = 4
     */
    taxRateId?: UUID;
    /**
     * @generated from protobuf field: string single_use_tax_number = 5
     */
    singleUseTaxNumber: string;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerExemptionsRes
 */
export interface UpdateCustomerExemptionsRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldRequirePOReq
 */
export interface UpdateCustomerShouldRequirePOReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: bool should_require_po = 2
     */
    shouldRequirePo: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldRequirePORes
 */
export interface UpdateCustomerShouldRequirePORes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldPrintInvoicesAndReceiptsReq
 */
export interface UpdateCustomerShouldPrintInvoicesAndReceiptsReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: bool should_print_invoices_and_receipts = 2
     */
    shouldPrintInvoicesAndReceipts: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldPrintInvoicesAndReceiptsRes
 */
export interface UpdateCustomerShouldPrintInvoicesAndReceiptsRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerNotesReq
 */
export interface UpdateCustomerNotesReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string notes = 2
     */
    notes: string;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerNotesRes
 */
export interface UpdateCustomerNotesRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerIsActiveReq
 */
export interface UpdateCustomerIsActiveReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: bool is_active = 2
     */
    isActive: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerIsActiveRes
 */
export interface UpdateCustomerIsActiveRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerFinancingTermReq
 */
export interface UpdateCustomerFinancingTermReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string financing_term_id_string = 2
     */
    financingTermIdString: string;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerFinancingTermRes
 */
export interface UpdateCustomerFinancingTermRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerCreditLimitReq
 */
export interface UpdateCustomerCreditLimitReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.money.Money credit_limit = 2
     */
    creditLimit?: Money;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerCreditLimitRes
 */
export interface UpdateCustomerCreditLimitRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerIsOnCreditHoldReq
 */
export interface UpdateCustomerIsOnCreditHoldReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: bool is_on_credit_hold = 2
     */
    isOnCreditHold: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerIsOnCreditHoldRes
 */
export interface UpdateCustomerIsOnCreditHoldRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldAutopayStatementBalancesReq
 */
export interface UpdateCustomerShouldAutopayStatementBalancesReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: bool should_autopay_statement_balances = 2
     */
    shouldAutopayStatementBalances: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldAutopayStatementBalancesRes
 */
export interface UpdateCustomerShouldAutopayStatementBalancesRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldMailStatementsReq
 */
export interface UpdateCustomerShouldMailStatementsReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: bool should_mail_statements = 2
     */
    shouldMailStatements: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldMailStatementsRes
 */
export interface UpdateCustomerShouldMailStatementsRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldRequireCustomerContactReq
 */
export interface UpdateCustomerShouldRequireCustomerContactReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: bool should_require_customer_contact = 2
     */
    shouldRequireCustomerContact: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldRequireCustomerContactRes
 */
export interface UpdateCustomerShouldRequireCustomerContactRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldRequireSaleNotesReq
 */
export interface UpdateCustomerShouldRequireSaleNotesReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: bool should_require_sale_notes = 2
     */
    shouldRequireSaleNotes: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldRequireSaleNotesRes
 */
export interface UpdateCustomerShouldRequireSaleNotesRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldRequireInternalSaleNotesReq
 */
export interface UpdateCustomerShouldRequireInternalSaleNotesReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: bool should_require_internal_sale_notes = 2
     */
    shouldRequireInternalSaleNotes: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldRequireInternalSaleNotesRes
 */
export interface UpdateCustomerShouldRequireInternalSaleNotesRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerFinanceChargeSettingReq
 */
export interface UpdateCustomerFinanceChargeSettingReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID finance_charge_setting_id = 2
     */
    financeChargeSettingId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerFinanceChargeSettingRes
 */
export interface UpdateCustomerFinanceChargeSettingRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerRepReq
 */
export interface UpdateCustomerRepReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID rep_staff_id = 2
     */
    repStaffId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerRepRes
 */
export interface UpdateCustomerRepRes {
}
/**
 * @generated from protobuf message rd.api.customer.ListPurchaseOrdersForCustomerReq
 */
export interface ListPurchaseOrdersForCustomerReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.ListPurchaseOrdersForCustomerRes
 */
export interface ListPurchaseOrdersForCustomerRes {
    /**
     * @generated from protobuf field: repeated rd.customer.PurchaseOrder purchase_orders = 1
     */
    purchaseOrders: PurchaseOrder[];
}
/**
 * @generated from protobuf message rd.api.customer.ListInteractionsForCustomerReq
 */
export interface ListInteractionsForCustomerReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.ListInteractionsForCustomerRes
 */
export interface ListInteractionsForCustomerRes {
    /**
     * @generated from protobuf field: repeated rd.customer.Interaction interactions = 1
     */
    interactions: Interaction[];
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerContractorRewardsReq
 */
export interface UpdateCustomerContractorRewardsReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: string pax_id = 2
     */
    paxId: string;
    /**
     * @generated from protobuf field: string rsd_number = 3
     */
    rsdNumber: string;
    /**
     * @generated from protobuf field: rd.customer.Customer.Type type = 4
     */
    type: Customer_Type;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerContractorRewardsRes
 */
export interface UpdateCustomerContractorRewardsRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldRequireReceiptSignatureReq
 */
export interface UpdateCustomerShouldRequireReceiptSignatureReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.customer.Customer.SignatureRequirement signature_requirement = 3
     */
    signatureRequirement: Customer_SignatureRequirement;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldRequireReceiptSignatureRes
 */
export interface UpdateCustomerShouldRequireReceiptSignatureRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerPricingTierReq
 */
export interface UpdateCustomerPricingTierReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: string pricing_tier_id_string = 2
     */
    pricingTierIdString: string;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerPricingTierRes
 */
export interface UpdateCustomerPricingTierRes {
}
/**
 * @generated from protobuf message rd.api.customer.ListCustomersForRepReq
 */
export interface ListCustomersForRepReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID rep_staff_id = 1
     */
    repStaffId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.ListCustomersForRepRes
 */
export interface ListCustomersForRepRes {
    /**
     * @generated from protobuf field: repeated rd.customer.Customer customers = 1
     */
    customers: Customer[];
}
/**
 * @generated from protobuf message rd.api.customer.GetCustomerCountForTierReq
 */
export interface GetCustomerCountForTierReq {
    /**
     * @generated from protobuf field: string pricing_tier_id_string = 1
     */
    pricingTierIdString: string;
}
/**
 * @generated from protobuf message rd.api.customer.GetCustomerCountForTierRes
 */
export interface GetCustomerCountForTierRes {
    /**
     * @generated from protobuf field: int32 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message rd.api.customer.GetJobCountForCustomerReq
 */
export interface GetJobCountForCustomerReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.GetJobCountForCustomerRes
 */
export interface GetJobCountForCustomerRes {
    /**
     * @generated from protobuf field: int32 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message rd.api.customer.GetActiveCustomerCountReq
 */
export interface GetActiveCustomerCountReq {
}
/**
 * @generated from protobuf message rd.api.customer.GetActiveCustomerCountRes
 */
export interface GetActiveCustomerCountRes {
    /**
     * @generated from protobuf field: int32 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message rd.api.customer.EnrollCustomerInFanBuilderLoyaltyReq
 */
export interface EnrollCustomerInFanBuilderLoyaltyReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
    /**
     * CES POS context: typically Location.prefix as system_store_id; terminal_id from the POS
     * terminal.
     *
     * @generated from protobuf field: string system_store_id = 3
     */
    systemStoreId: string;
    /**
     * @generated from protobuf field: string terminal_id = 4
     */
    terminalId: string;
}
/**
 * @generated from protobuf message rd.api.customer.EnrollCustomerInFanBuilderLoyaltyRes
 */
export interface EnrollCustomerInFanBuilderLoyaltyRes {
    /**
     * @generated from protobuf field: string fan_builder_system_customer_id = 1
     */
    fanBuilderSystemCustomerId: string;
}
/**
 * @generated from protobuf message rd.api.customer.GetCustomerFanBuilderLoyaltyReq
 */
export interface GetCustomerFanBuilderLoyaltyReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
    /**
     * Same POS context as EnrollCustomerInFanBuilderLoyaltyReq.
     *
     * @generated from protobuf field: string system_store_id = 3
     */
    systemStoreId: string;
    /**
     * @generated from protobuf field: string terminal_id = 4
     */
    terminalId: string;
}
/**
 * @generated from protobuf message rd.api.customer.GetCustomerFanBuilderLoyaltyRes
 */
export interface GetCustomerFanBuilderLoyaltyRes {
    /**
     * @generated from protobuf field: bool enrolled = 1
     */
    enrolled: boolean;
    /**
     * @generated from protobuf field: string fan_builder_system_customer_id = 2
     */
    fanBuilderSystemCustomerId: string;
    /**
     * @generated from protobuf field: string dashboard_url = 3
     */
    dashboardUrl: string;
    /**
     * @generated from protobuf field: repeated rd.api.customer.FanBuilderLoyaltyCoupon coupons = 4
     */
    coupons: FanBuilderLoyaltyCoupon[];
}
/**
 * @generated from protobuf message rd.api.customer.FanBuilderLoyaltyCoupon
 */
export interface FanBuilderLoyaltyCoupon {
    /**
     * @generated from protobuf field: int32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: int32 customer_id = 2
     */
    customerId: number;
    /**
     * @generated from protobuf field: int32 coupon_id = 3
     */
    couponId: number;
    /**
     * @generated from protobuf field: string short_description = 4
     */
    shortDescription: string;
    /**
     * @generated from protobuf field: string barcode = 5
     */
    barcode: string;
    /**
     * @generated from protobuf field: string expires = 6
     */
    expires: string;
    /**
     * @generated from protobuf field: int32 discount_type = 7
     */
    discountType: number; // 1 = $ off, 2 = % off (per Fan Builder)
    /**
     * @generated from protobuf field: double amount = 8
     */
    amount: number;
    /**
     * @generated from protobuf field: int32 num_uses = 9
     */
    numUses: number;
    /**
     * @generated from protobuf field: int32 max_uses = 10
     */
    maxUses: number;
    /**
     * @generated from protobuf field: string date_issued = 11
     */
    dateIssued: string;
    /**
     * @generated from protobuf field: string required_skus = 12
     */
    requiredSkus: string;
    /**
     * @generated from protobuf field: double minimum_purchase = 13
     */
    minimumPurchase: number;
    /**
     * @generated from protobuf field: int32 points_threshold = 14
     */
    pointsThreshold: number;
}
/**
 * @generated from protobuf message rd.api.customer.ValidateFanBuilderLoyaltyCouponReq
 */
export interface ValidateFanBuilderLoyaltyCouponReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: string system_store_id = 2
     */
    systemStoreId: string;
    /**
     * @generated from protobuf field: string terminal_id = 3
     */
    terminalId: string;
    /**
     * Every coupon going on this sale. CES applies stacking limits and minimum purchase
     * across the whole set, so a sale with several coupons must validate them in one call
     * rather than one call per coupon.
     *
     * @generated from protobuf field: repeated string coupon_barcodes = 4
     */
    couponBarcodes: string[];
    /**
     * Pre-tax cart subtotal in dollars (CES Coupon/ValidateCoupon Subtotal). Do not mark
     * `require` on double: rd/validator treats 0 as missing (empty cart is valid).
     *
     * @generated from protobuf field: double cart_subtotal = 5
     */
    cartSubtotal: number;
}
/**
 * @generated from protobuf message rd.api.customer.ValidateFanBuilderLoyaltyCouponRes
 */
export interface ValidateFanBuilderLoyaltyCouponRes {
    /**
     * True only when CES accepted every requested coupon. Per-coupon detail is in `coupons`.
     *
     * @generated from protobuf field: bool valid = 1
     */
    valid: boolean;
    /**
     * One entry per requested coupon, in request order.
     *
     * @generated from protobuf field: repeated rd.api.customer.ValidatedFanBuilderLoyaltyCoupon coupons = 2
     */
    coupons: ValidatedFanBuilderLoyaltyCoupon[];
}
/**
 * @generated from protobuf message rd.api.customer.ValidatedFanBuilderLoyaltyCoupon
 */
export interface ValidatedFanBuilderLoyaltyCoupon {
    /**
     * @generated from protobuf field: string coupon_barcode = 1
     */
    couponBarcode: string;
    /**
     * @generated from protobuf field: bool valid = 2
     */
    valid: boolean;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * What this coupon is worth against the cart it was validated for. For a percentage coupon it
     * depends on the cart, so it is only true for the subtotal that was sent.
     *
     * @generated from protobuf field: double discount_amount = 4
     */
    discountAmount: number;
    /**
     * @generated from protobuf field: string message = 5
     */
    message: string;
    /**
     * @generated from protobuf field: rd.api.customer.ValidatedFanBuilderLoyaltyCoupon.DiscountType discount_type = 6
     */
    discountType: ValidatedFanBuilderLoyaltyCoupon_DiscountType;
    /**
     * For a percentage coupon, the fraction of the subtotal (0.1 means 10%).
     *
     * @generated from protobuf field: double amount = 7
     */
    amount: number;
}
/**
 * How CES computes this coupon's discount.
 *
 * @generated from protobuf enum rd.api.customer.ValidatedFanBuilderLoyaltyCoupon.DiscountType
 */
export enum ValidatedFanBuilderLoyaltyCoupon_DiscountType {
    /**
     * @generated from protobuf enum value: DISCOUNT_TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: DISCOUNT_TYPE_FIXED_AMOUNT = 1;
     */
    FIXED_AMOUNT = 1,
    /**
     * @generated from protobuf enum value: DISCOUNT_TYPE_PERCENTAGE = 2;
     */
    PERCENTAGE = 2
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldRequireJobReq
 */
export interface UpdateCustomerShouldRequireJobReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: bool should_require_job = 2
     */
    shouldRequireJob: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldRequireJobRes
 */
export interface UpdateCustomerShouldRequireJobRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerStatementInvoicesFormatReq
 */
export interface UpdateCustomerStatementInvoicesFormatReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.customer.Customer.StatementInvoicesFormatType statement_invoices_format = 2
     */
    statementInvoicesFormat: Customer_StatementInvoicesFormatType;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerStatementInvoicesFormatRes
 */
export interface UpdateCustomerStatementInvoicesFormatRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldHidePricesOnInvoicesReq
 */
export interface UpdateCustomerShouldHidePricesOnInvoicesReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: bool should_hide_prices_on_invoices = 2
     */
    shouldHidePricesOnInvoices: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldHidePricesOnInvoicesRes
 */
export interface UpdateCustomerShouldHidePricesOnInvoicesRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerStatementTypeReq
 */
export interface UpdateCustomerStatementTypeReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.customer.Customer.StatementType statement_type = 2
     */
    statementType: Customer_StatementType;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerStatementTypeRes
 */
export interface UpdateCustomerStatementTypeRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerTypeReq
 */
export interface UpdateCustomerTypeReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.customer.Customer.Type type = 2
     */
    type: Customer_Type;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerTypeRes
 */
export interface UpdateCustomerTypeRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerIsCardSurchargeExemptReq
 */
export interface UpdateCustomerIsCardSurchargeExemptReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: bool is_card_surcharge_exempt = 2
     */
    isCardSurchargeExempt: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerIsCardSurchargeExemptRes
 */
export interface UpdateCustomerIsCardSurchargeExemptRes {
}
/**
 * @generated from protobuf message rd.api.customer.MergeCustomersReq
 */
export interface MergeCustomersReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID source_customer_id = 1
     */
    sourceCustomerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID target_customer_id = 2
     */
    targetCustomerId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.MergeCustomersRes
 */
export interface MergeCustomersRes {
}
/**
 * Statement
 *
 * @generated from protobuf message rd.api.customer.GetLastStatementRunReq
 */
export interface GetLastStatementRunReq {
}
/**
 * @generated from protobuf message rd.api.customer.GetLastStatementRunRes
 */
export interface GetLastStatementRunRes {
    /**
     * @generated from protobuf field: rd.statement.StatementRun statement = 1
     */
    statement?: StatementRun;
    /**
     * @generated from protobuf field: int32 num_customers_to_mail = 5
     */
    numCustomersToMail: number;
    /**
     * @generated from protobuf field: int32 num_customers_with_contacts_to_email = 6
     */
    numCustomersWithContactsToEmail: number;
    /**
     * @generated from protobuf field: int32 num_customer_contacts_to_email = 7
     */
    numCustomerContactsToEmail: number;
    /**
     * @generated from protobuf field: repeated string emailed_download_urls = 8
     */
    emailedDownloadUrls: string[];
    /**
     * @generated from protobuf field: repeated string mailed_download_urls = 9
     */
    mailedDownloadUrls: string[];
}
/**
 * @generated from protobuf message rd.api.customer.MailBulkStatementRunReq
 */
export interface MailBulkStatementRunReq {
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 1
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID statement_run_id = 2
     */
    statementRunId?: UUID;
    /**
     * @generated from protobuf field: bool is_preview = 3
     */
    isPreview: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.MailBulkStatementRunRes
 */
export interface MailBulkStatementRunRes {
    /**
     * @generated from protobuf field: bytes pdf_bytes = 1
     */
    pdfBytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.api.customer.ListStatementsForCustomerReq
 */
export interface ListStatementsForCustomerReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.ListStatementsForCustomerRes
 */
export interface ListStatementsForCustomerRes {
    /**
     * @generated from protobuf field: repeated rd.api.customer.ListStatementsForCustomerRes.Result results = 1
     */
    results: ListStatementsForCustomerRes_Result[];
}
/**
 * @generated from protobuf message rd.api.customer.ListStatementsForCustomerRes.Result
 */
export interface ListStatementsForCustomerRes_Result {
    /**
     * @generated from protobuf field: rd.statement.Statement statement = 1
     */
    statement?: Statement;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp statement_run_created_at = 2
     */
    statementRunCreatedAt?: Timestamp;
}
/**
 * @generated from protobuf message rd.api.customer.EmailCustomerStatementPDFReq
 */
export interface EmailCustomerStatementPDFReq {
    /**
     * @generated from protobuf field: repeated string customer_contact_id_strings = 2
     */
    customerContactIdStrings: string[];
    /**
     * @generated from protobuf field: repeated string additional_emails = 3
     */
    additionalEmails: string[];
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 4
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID statement_run_id = 5
     */
    statementRunId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.EmailCustomerStatementPDFRes
 */
export interface EmailCustomerStatementPDFRes {
}
/**
 * @generated from protobuf message rd.api.customer.EmailStatementRunReq
 */
export interface EmailStatementRunReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID statement_run_id = 1
     */
    statementRunId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 2
     */
    customerIds: UUID[];
}
/**
 * @generated from protobuf message rd.api.customer.EmailStatementRunRes
 */
export interface EmailStatementRunRes {
}
/**
 * @generated from protobuf message rd.api.customer.GetStatementRunReq
 */
export interface GetStatementRunReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID statement_run_id = 1
     */
    statementRunId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.GetStatementRunRes
 */
export interface GetStatementRunRes {
    /**
     * @generated from protobuf field: rd.statement.StatementRun statement_run = 1
     */
    statementRun?: StatementRun;
}
/**
 * @generated from protobuf message rd.api.customer.GetStatementRunStatsReq
 */
export interface GetStatementRunStatsReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID statement_run_id = 1
     */
    statementRunId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.GetStatementRunStatsRes
 */
export interface GetStatementRunStatsRes {
    /**
     * @generated from protobuf field: int32 generated_count = 1
     */
    generatedCount: number;
    /**
     * @generated from protobuf field: int32 mailed_count = 2
     */
    mailedCount: number;
    /**
     * @generated from protobuf field: int32 emailed_count = 3
     */
    emailedCount: number;
    /**
     * @generated from protobuf field: int32 sent_count = 4
     */
    sentCount: number;
    /**
     * @generated from protobuf field: int32 generated_count_v2 = 5
     */
    generatedCountV2: number;
    /**
     * @generated from protobuf field: int32 completed_count = 6
     */
    completedCount: number;
    /**
     * @generated from protobuf field: int32 error_count = 7
     */
    errorCount: number;
    /**
     * @generated from protobuf field: int32 initiated_count = 8
     */
    initiatedCount: number;
}
/**
 * @generated from protobuf message rd.api.customer.EmailAllInStatementRunReq
 */
export interface EmailAllInStatementRunReq {
    /**
     * @generated from protobuf field: repeated string financing_term_id_strings = 1
     */
    financingTermIdStrings: string[];
    /**
     * @generated from protobuf field: repeated string pricing_tier_id_strings = 2
     */
    pricingTierIdStrings: string[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID rep_staff_ids = 3
     */
    repStaffIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID finance_charge_setting_ids = 4
     */
    financeChargeSettingIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tag_ids = 5
     */
    tagIds: UUID[];
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID statement_run_id = 6
     */
    statementRunId?: UUID;
    /**
     * @generated from protobuf field: bool email_only = 7
     */
    emailOnly: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.EmailAllInStatementRunRes
 */
export interface EmailAllInStatementRunRes {
}
/**
 * @generated from protobuf message rd.api.customer.GenerateStatementRunPdfsReq
 */
export interface GenerateStatementRunPdfsReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID statement_run_id = 1
     */
    statementRunId?: UUID;
    /**
     * @generated from protobuf field: bool is_all_selected = 2
     */
    isAllSelected: boolean;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 3
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: repeated string financing_term_id_strings = 4
     */
    financingTermIdStrings: string[];
    /**
     * @generated from protobuf field: repeated string pricing_tier_id_strings = 5
     */
    pricingTierIdStrings: string[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID rep_staff_ids = 6
     */
    repStaffIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID finance_charge_setting_ids = 7
     */
    financeChargeSettingIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tag_ids = 8
     */
    tagIds: UUID[];
    /**
     * @generated from protobuf field: bool email_only = 9
     */
    emailOnly: boolean;
    /**
     * @generated from protobuf field: bool mail_only = 10
     */
    mailOnly: boolean;
    /**
     * @generated from protobuf field: bool is_preview = 11
     */
    isPreview: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.GenerateStatementRunPdfsRes
 */
export interface GenerateStatementRunPdfsRes {
    /**
     * @generated from protobuf field: string pdf_url = 1
     */
    pdfUrl: string;
}
/**
 * @generated from protobuf message rd.api.customer.GetLastStatementRunIdReq
 */
export interface GetLastStatementRunIdReq {
}
/**
 * @generated from protobuf message rd.api.customer.GetLastStatementRunIdRes
 */
export interface GetLastStatementRunIdRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID statement_run_id = 1
     */
    statementRunId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
}
/**
 * @generated from protobuf message rd.api.customer.GetLastStatementRunSendStatsReq
 */
export interface GetLastStatementRunSendStatsReq {
}
/**
 * @generated from protobuf message rd.api.customer.GetLastStatementRunSendStatsRes
 */
export interface GetLastStatementRunSendStatsRes {
    /**
     * @generated from protobuf field: int32 num_customers_to_mail = 1
     */
    numCustomersToMail: number;
    /**
     * @generated from protobuf field: int32 num_customers_with_contacts_to_email = 2
     */
    numCustomersWithContactsToEmail: number;
    /**
     * @generated from protobuf field: int32 num_customer_contacts_to_email = 3
     */
    numCustomerContactsToEmail: number;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID statement_run_id = 4
     */
    statementRunId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID mail_customer_ids = 5
     */
    mailCustomerIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID email_customer_ids = 6
     */
    emailCustomerIds: UUID[];
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange statement_period = 7
     */
    statementPeriod?: TimestampRange;
    /**
     * @generated from protobuf field: int32 num_customers_mailed = 8
     */
    numCustomersMailed: number;
    /**
     * @generated from protobuf field: int32 num_customers_emailed = 9
     */
    numCustomersEmailed: number;
    /**
     * @generated from protobuf field: int32 num_statements = 10
     */
    numStatements: number; // generated
    /**
     * @generated from protobuf field: int32 num_statements_sent = 11
     */
    numStatementsSent: number; // sent
    /**
     * @generated from protobuf field: int32 num_errors = 12
     */
    numErrors: number;
    /**
     * @generated from protobuf field: int32 num_initiated = 13
     */
    numInitiated: number;
}
/**
 * @generated from protobuf message rd.api.customer.GenerateAndSendIndividualCustomerStatementReq
 */
export interface GenerateAndSendIndividualCustomerStatementReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start_date = 2
     */
    startDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end_date = 3
     */
    endDate?: Timestamp;
    /**
     * @generated from protobuf field: rd.api.customer.GenerateAndSendIndividualCustomerStatementReq.SendType send_type = 4
     */
    sendType: GenerateAndSendIndividualCustomerStatementReq_SendType;
    /**
     * @generated from protobuf field: repeated string customer_contact_id_strings = 5
     */
    customerContactIdStrings: string[];
    /**
     * @generated from protobuf field: repeated string additional_emails = 6
     */
    additionalEmails: string[];
    /**
     * @generated from protobuf field: rd.statement.StatementType statement_type = 7
     */
    statementType: StatementType;
    /**
     * @generated from protobuf field: rd.statement.StatementInvoicesFormatType statement_invoices_format = 8
     */
    statementInvoicesFormat: StatementInvoicesFormatType;
    /**
     * @generated from protobuf field: bool should_include_jobs = 9
     */
    shouldIncludeJobs: boolean;
    /**
     * @generated from protobuf field: string client_time_zone = 10
     */
    clientTimeZone: string;
}
/**
 * @generated from protobuf enum rd.api.customer.GenerateAndSendIndividualCustomerStatementReq.SendType
 */
export enum GenerateAndSendIndividualCustomerStatementReq_SendType {
    /**
     * @generated from protobuf enum value: SEND_TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: SEND_TYPE_MAIL = 1;
     */
    MAIL = 1,
    /**
     * @generated from protobuf enum value: SEND_TYPE_EMAIL = 2;
     */
    EMAIL = 2
}
/**
 * @generated from protobuf message rd.api.customer.GenerateAndSendIndividualCustomerStatementRes
 */
export interface GenerateAndSendIndividualCustomerStatementRes {
    /**
     * @generated from protobuf field: string pdf_url = 1
     */
    pdfUrl: string;
}
/**
 * @generated from protobuf message rd.api.customer.CountCustomersForBulkStatementReq
 */
export interface CountCustomersForBulkStatementReq {
    /**
     * @generated from protobuf field: repeated string financing_term_id_strings = 1
     */
    financingTermIdStrings: string[];
    /**
     * @generated from protobuf field: repeated string pricing_tier_id_strings = 2
     */
    pricingTierIdStrings: string[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID rep_staff_ids = 3
     */
    repStaffIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID finance_charge_setting_ids = 4
     */
    financeChargeSettingIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tag_ids = 5
     */
    tagIds: UUID[];
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID statement_run_id = 6
     */
    statementRunId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.CountCustomersForBulkStatementRes
 */
export interface CountCustomersForBulkStatementRes {
    /**
     * @generated from protobuf field: int32 count_email = 1
     */
    countEmail: number; // all email
    /**
     * @generated from protobuf field: int32 count_mail = 2
     */
    countMail: number; // all mail
    /**
     * @generated from protobuf field: int32 count_email_contacts = 3
     */
    countEmailContacts: number; // all email contacts
    /**
     * @generated from protobuf field: int32 count_mailed = 4
     */
    countMailed: number;
    /**
     * @generated from protobuf field: int32 count_emailed = 5
     */
    countEmailed: number;
    /**
     * @generated from protobuf field: int32 count_generated = 6
     */
    countGenerated: number;
    /**
     * @generated from protobuf field: int32 count_sent = 7
     */
    countSent: number;
    /**
     * @generated from protobuf field: int32 count_errors = 8
     */
    countErrors: number;
    /**
     * @generated from protobuf field: int32 count_initiated = 9
     */
    countInitiated: number;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq
 */
export interface UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: bool restrict_outstanding_invoices_to_statement_period = 2
     */
    restrictOutstandingInvoicesToStatementPeriod: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodRes
 */
export interface UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodRes {
}
/**
 * @generated from protobuf message rd.api.customer.GenerateStatementsForCustomersReq
 */
export interface GenerateStatementsForCustomersReq {
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 1
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start_date = 2
     */
    startDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end_date = 3
     */
    endDate?: Timestamp;
    /**
     * @generated from protobuf field: string client_time_zone = 4
     */
    clientTimeZone: string;
}
/**
 * @generated from protobuf message rd.api.customer.GenerateStatementsForCustomersRes
 */
export interface GenerateStatementsForCustomersRes {
}
/**
 * @generated from protobuf message rd.api.customer.BulkGenerateStatementsForCustomersReq
 */
export interface BulkGenerateStatementsForCustomersReq {
    /**
     * @generated from protobuf field: repeated string financing_term_id_strings = 1
     */
    financingTermIdStrings: string[];
    /**
     * @generated from protobuf field: repeated string pricing_tier_id_strings = 2
     */
    pricingTierIdStrings: string[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID rep_staff_ids = 3
     */
    repStaffIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID finance_charge_setting_ids = 4
     */
    financeChargeSettingIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tag_ids = 5
     */
    tagIds: UUID[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start_date = 6
     */
    startDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end_date = 7
     */
    endDate?: Timestamp;
    /**
     * @generated from protobuf field: string client_time_zone = 8
     */
    clientTimeZone: string;
}
/**
 * @generated from protobuf message rd.api.customer.BulkGenerateStatementsForCustomersRes
 */
export interface BulkGenerateStatementsForCustomersRes {
}
/**
 * Payment Card
 *
 * @generated from protobuf message rd.api.customer.GetCustomerSavedCardsReq
 */
export interface GetCustomerSavedCardsReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 2
     */
    customerId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.GetCustomerSavedCardsRes
 */
export interface GetCustomerSavedCardsRes {
    /**
     * @generated from protobuf field: repeated rd.payments.Card cards = 1
     */
    cards: Card[];
    /**
     * @generated from protobuf field: repeated string card_display_strings = 2
     */
    cardDisplayStrings: string[];
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerPrimaryCardReq
 */
export interface UpdateCustomerPrimaryCardReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string stripe_card_id = 2
     */
    stripeCardId: string;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerPrimaryCardRes
 */
export interface UpdateCustomerPrimaryCardRes {
}
/**
 * @generated from protobuf message rd.api.customer.DeleteCustomerCardReq
 */
export interface DeleteCustomerCardReq {
    /**
     * @generated from protobuf field: string stripe_card_id = 1
     */
    stripeCardId: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 2
     */
    customerId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.DeleteCustomerCardRes
 */
export interface DeleteCustomerCardRes {
    /**
     * @generated from protobuf field: rd.api.customer.DeleteCustomerCardRes.MethodType new_primary_method_type = 3
     */
    newPrimaryMethodType: DeleteCustomerCardRes_MethodType;
    /**
     * @generated from protobuf field: string new_primary_last_4 = 4
     */
    newPrimaryLast4: string;
}
/**
 * @generated from protobuf enum rd.api.customer.DeleteCustomerCardRes.MethodType
 */
export enum DeleteCustomerCardRes_MethodType {
    /**
     * @generated from protobuf enum value: METHOD_TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: METHOD_TYPE_CARD = 1;
     */
    CARD = 1,
    /**
     * @generated from protobuf enum value: METHOD_TYPE_BANK_ACCOUNT = 2;
     */
    BANK_ACCOUNT = 2
}
/**
 * @generated from protobuf message rd.api.customer.AddCustomerCardReq
 */
export interface AddCustomerCardReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: string card_number = 2
     */
    cardNumber: string;
    /**
     * @generated from protobuf field: int32 card_expiration_month = 3
     */
    cardExpirationMonth: number;
    /**
     * @generated from protobuf field: int32 card_expiration_year = 4
     */
    cardExpirationYear: number;
    /**
     * @generated from protobuf field: string card_cvc = 5
     */
    cardCvc: string;
    /**
     * @generated from protobuf field: bool is_primary_card = 6
     */
    isPrimaryCard: boolean;
    /**
     * @generated from protobuf field: string zip_code = 7
     */
    zipCode: string;
    /**
     * @generated from protobuf field: string card_nickname = 8
     */
    cardNickname: string;
}
/**
 * @generated from protobuf message rd.api.customer.AddCustomerCardRes
 */
export interface AddCustomerCardRes {
    /**
     * @generated from protobuf field: string stripe_card_id = 1
     */
    stripeCardId: string;
}
/**
 * @generated from protobuf message rd.api.customer.SendACHPaymentEmailAndSmsReq
 */
export interface SendACHPaymentEmailAndSmsReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: string customer_contact_id = 2
     */
    customerContactId: string;
}
/**
 * @generated from protobuf message rd.api.customer.SendACHPaymentEmailAndSmsRes
 */
export interface SendACHPaymentEmailAndSmsRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerCardReq
 */
export interface UpdateCustomerCardReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: string stripe_card_id = 2
     */
    stripeCardId: string;
    /**
     * @generated from protobuf field: string card_nickname = 3
     */
    cardNickname: string;
    /**
     * @generated from protobuf field: bool is_primary_card = 4
     */
    isPrimaryCard: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerCardRes
 */
export interface UpdateCustomerCardRes {
}
/**
 * Bank Accounts
 *
 * @generated from protobuf message rd.api.customer.GetCustomerSavedBankAccountsReq
 */
export interface GetCustomerSavedBankAccountsReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.GetCustomerSavedBankAccountsRes
 */
export interface GetCustomerSavedBankAccountsRes {
    /**
     * @generated from protobuf field: repeated rd.payments.BankPaymentMethod bank_accounts = 1
     */
    bankAccounts: BankPaymentMethod[];
    /**
     * @generated from protobuf field: repeated string bank_account_display_strings = 2
     */
    bankAccountDisplayStrings: string[];
}
/**
 * Customer Contact
 *
 * @generated from protobuf message rd.api.customer.CreateCustomerContactReq
 */
export interface CreateCustomerContactReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: bool is_primary = 2
     */
    isPrimary: boolean;
    /**
     * @generated from protobuf field: string name = 3
     */
    name: string;
    /**
     * @generated from protobuf field: string phone = 4
     */
    phone: string;
    /**
     * @generated from protobuf field: string email = 5
     */
    email: string;
    /**
     * @generated from protobuf field: string notes = 6
     */
    notes: string;
    /**
     * @generated from protobuf field: bool should_email_invoices = 7
     */
    shouldEmailInvoices: boolean;
    /**
     * @generated from protobuf field: bool should_email_statements = 8
     */
    shouldEmailStatements: boolean;
    /**
     * @generated from protobuf field: rd.customer.Customer.StatementInvoicesFormatType invoice_format = 9
     */
    invoiceFormat: Customer_StatementInvoicesFormatType;
    /**
     * @generated from protobuf field: rd.customer.Contacts.Contact.EmailFrequency email_frequency = 10
     */
    emailFrequency: Contacts_Contact_EmailFrequency;
    /**
     * @generated from protobuf field: bool sms_consent = 11
     */
    smsConsent: boolean;
    /**
     * @generated from protobuf field: bool authorized_buyer = 12
     */
    authorizedBuyer: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.CreateCustomerContactRes
 */
export interface CreateCustomerContactRes {
    /**
     * @generated from protobuf field: string id_string = 1
     */
    idString: string;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerContactReq
 */
export interface UpdateCustomerContactReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string id_string = 2
     */
    idString: string;
    /**
     * @generated from protobuf field: bool is_primary = 3
     */
    isPrimary: boolean;
    /**
     * @generated from protobuf field: string name = 4
     */
    name: string;
    /**
     * @generated from protobuf field: string phone = 5
     */
    phone: string;
    /**
     * @generated from protobuf field: string email = 6
     */
    email: string;
    /**
     * @generated from protobuf field: string notes = 7
     */
    notes: string;
    /**
     * @generated from protobuf field: bool should_email_invoices = 8
     */
    shouldEmailInvoices: boolean;
    /**
     * @generated from protobuf field: bool should_email_statements = 9
     */
    shouldEmailStatements: boolean;
    /**
     * @generated from protobuf field: rd.customer.Customer.StatementInvoicesFormatType invoice_format = 10
     */
    invoiceFormat: Customer_StatementInvoicesFormatType;
    /**
     * @generated from protobuf field: rd.customer.Contacts.Contact.EmailFrequency email_frequency = 11
     */
    emailFrequency: Contacts_Contact_EmailFrequency;
    /**
     * @generated from protobuf field: bool sms_consent = 12
     */
    smsConsent: boolean;
    /**
     * @generated from protobuf field: bool authorized_buyer = 13
     */
    authorizedBuyer: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerContactRes
 */
export interface UpdateCustomerContactRes {
}
/**
 * @generated from protobuf message rd.api.customer.DeactivateCustomerContactReq
 */
export interface DeactivateCustomerContactReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string id_string = 2
     */
    idString: string;
}
/**
 * @generated from protobuf message rd.api.customer.DeactivateCustomerContactRes
 */
export interface DeactivateCustomerContactRes {
}
/**
 * Customer Sale History
 *
 * @generated from protobuf message rd.api.customer.GetCustomerSaleHistoryPDFReq
 */
export interface GetCustomerSaleHistoryPDFReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange sold_at_range = 2
     */
    soldAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: string client_time_zone = 3
     */
    clientTimeZone: string;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID purchase_order_ids = 4
     */
    purchaseOrderIds: UUID[];
    /**
     * @generated from protobuf field: rd.customer.Customer.StatementInvoicesFormatType invoice_format = 5
     */
    invoiceFormat: Customer_StatementInvoicesFormatType;
}
/**
 * @generated from protobuf message rd.api.customer.GetCustomerSaleHistoryPDFRes
 */
export interface GetCustomerSaleHistoryPDFRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.api.customer.EmailCustomerSaleHistoryPDFReq
 */
export interface EmailCustomerSaleHistoryPDFReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange sold_at_range = 2
     */
    soldAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: string client_time_zone = 3
     */
    clientTimeZone: string;
    /**
     * @generated from protobuf field: repeated string customer_contact_id_strings = 4
     */
    customerContactIdStrings: string[];
    /**
     * @generated from protobuf field: repeated string additional_emails = 5
     */
    additionalEmails: string[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID purchase_order_ids = 6
     */
    purchaseOrderIds: UUID[];
    /**
     * @generated from protobuf field: rd.customer.Customer.StatementInvoicesFormatType invoice_format = 7
     */
    invoiceFormat: Customer_StatementInvoicesFormatType;
}
/**
 * @generated from protobuf message rd.api.customer.EmailCustomerSaleHistoryPDFRes
 */
export interface EmailCustomerSaleHistoryPDFRes {
}
/**
 * @generated from protobuf message rd.api.customer.EmailContractorRewardsInvitationReq
 */
export interface EmailContractorRewardsInvitationReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.EmailContractorRewardsInvitationRes
 */
export interface EmailContractorRewardsInvitationRes {
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerSalesReminderReq
 */
export interface UpdateCustomerSalesReminderReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string sales_reminder = 2
     */
    salesReminder: string;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerSalesReminderRes
 */
export interface UpdateCustomerSalesReminderRes {
}
/**
 * BUB
 *
 * @generated from protobuf message rd.api.customer.BulkUpsertCustomersReq
 */
export interface BulkUpsertCustomersReq {
    /**
     * @generated from protobuf field: string file_url = 1
     */
    fileUrl: string;
    /**
     * @generated from protobuf field: bool write_changes = 2
     */
    writeChanges: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.BulkUpsertCustomersRes
 */
export interface BulkUpsertCustomersRes {
    /**
     * @generated from protobuf field: rd.bub.Summary summary = 1
     */
    summary?: Summary;
}
/**
 * @generated from protobuf message rd.api.customer.BulkUpsertCustomerContactsReq
 */
export interface BulkUpsertCustomerContactsReq {
    /**
     * @generated from protobuf field: string file_url = 1
     */
    fileUrl: string;
    /**
     * @generated from protobuf field: bool write_changes = 2
     */
    writeChanges: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.BulkUpsertCustomerContactsRes
 */
export interface BulkUpsertCustomerContactsRes {
    /**
     * @generated from protobuf field: rd.bub.Summary summary = 1
     */
    summary?: Summary;
}
/**
 * @generated from protobuf message rd.api.customer.BulkUpsertJobsReq
 */
export interface BulkUpsertJobsReq {
    /**
     * @generated from protobuf field: string file_url = 1
     */
    fileUrl: string;
    /**
     * @generated from protobuf field: bool write_changes = 2
     */
    writeChanges: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.BulkUpsertJobsRes
 */
export interface BulkUpsertJobsRes {
    /**
     * @generated from protobuf field: rd.bubv2.Summary summary = 1
     */
    summary?: Summary$;
}
/**
 * Job
 *
 * @generated from protobuf message rd.api.customer.GenerateNextJobIdentifierReq
 */
export interface GenerateNextJobIdentifierReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.GenerateNextJobIdentifierRes
 */
export interface GenerateNextJobIdentifierRes {
    /**
     * @generated from protobuf field: string identifier = 1
     */
    identifier: string;
}
/**
 * @generated from protobuf message rd.api.customer.CreateJobReq
 */
export interface CreateJobReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID parent_id = 1
     */
    parentId?: UUID;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string identifier = 3
     */
    identifier: string;
    /**
     * @generated from protobuf field: rd.proto.address.Address address = 4
     */
    address?: Address;
}
/**
 * @generated from protobuf message rd.api.customer.CreateJobRes
 */
export interface CreateJobRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldReceiveJobStatementsReq
 */
export interface UpdateCustomerShouldReceiveJobStatementsReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: bool should_receive_job_statements = 2
     */
    shouldReceiveJobStatements: boolean;
}
/**
 * @generated from protobuf message rd.api.customer.UpdateCustomerShouldReceiveJobStatementsRes
 */
export interface UpdateCustomerShouldReceiveJobStatementsRes {
}
/**
 * @generated from protobuf message rd.api.customer.ConvertToJobReq
 */
export interface ConvertToJobReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID original_customer_id = 1
     */
    originalCustomerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID parent_customer_id = 2
     */
    parentCustomerId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.ConvertToJobRes
 */
export interface ConvertToJobRes {
}
/**
 * Tags
 *
 * @generated from protobuf message rd.api.customer.ListCustomerTagsReq
 */
export interface ListCustomerTagsReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.ListCustomerTagsRes
 */
export interface ListCustomerTagsRes {
    /**
     * @generated from protobuf field: repeated rd.tag.Tag tags = 1
     */
    tags: Tag[];
}
/**
 * @generated from protobuf message rd.api.customer.AttachNewCustomerTagReq
 */
export interface AttachNewCustomerTagReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: string tag_name = 2
     */
    tagName: string;
}
/**
 * @generated from protobuf message rd.api.customer.AttachNewCustomerTagRes
 */
export interface AttachNewCustomerTagRes {
}
/**
 * @generated from protobuf message rd.api.customer.AttachCustomerTagReq
 */
export interface AttachCustomerTagReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID tag_id = 2
     */
    tagId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.AttachCustomerTagRes
 */
export interface AttachCustomerTagRes {
}
/**
 * @generated from protobuf message rd.api.customer.DetachCustomerTagReq
 */
export interface DetachCustomerTagReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID tag_id = 2
     */
    tagId?: UUID;
}
/**
 * @generated from protobuf message rd.api.customer.DetachCustomerTagRes
 */
export interface DetachCustomerTagRes {
}
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomerReq$Type extends MessageType<GetCustomerReq> {
    constructor() {
        super("rd.api.customer.GetCustomerReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "location_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<GetCustomerReq>): GetCustomerReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCustomerReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCustomerReq): GetCustomerReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 2:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCustomerReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 2; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetCustomerReq
 */
export const GetCustomerReq = new GetCustomerReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomerRes$Type extends MessageType<GetCustomerRes> {
    constructor() {
        super("rd.api.customer.GetCustomerRes", [
            { no: 1, name: "customer", kind: "message", T: () => Customer },
            { no: 2, name: "pricing_tier", kind: "message", T: () => PricingTiers_Tier },
            { no: 3, name: "financing_term", kind: "message", T: () => FinancingTerms_Term },
            { no: 6, name: "financing_term_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "balance", kind: "message", T: () => CustomerBalance },
            { no: 8, name: "total_balance", kind: "message", T: () => Money },
            { no: 10, name: "max_charge_account_sale_total", kind: "message", T: () => Money },
            { no: 11, name: "sale_today_due_at", kind: "message", T: () => Timestamp },
            { no: 12, name: "contacts", kind: "message", T: () => Contacts },
            { no: 14, name: "is_charge_account", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "representative_staff", kind: "message", T: () => Staff },
            { no: 16, name: "last_statement_balance", kind: "message", T: () => CustomerBalance },
            { no: 17, name: "last_statement_total_balance", kind: "message", T: () => Money },
            { no: 18, name: "analytics", kind: "message", T: () => CustomerSalesAnalytics },
            { no: 19, name: "finance_charge_setting", kind: "message", T: () => FinanceChargeSetting },
            { no: 20, name: "custom_price_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "margin_ytd", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 22, name: "remaining_statement_balance", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<GetCustomerRes>): GetCustomerRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.financingTermName = "";
        message.isChargeAccount = false;
        message.customPriceCount = 0;
        message.marginYtd = 0;
        if (value !== undefined)
            reflectionMergePartial<GetCustomerRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCustomerRes): GetCustomerRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.customer.Customer customer */ 1:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* rd.company.PricingTiers.Tier pricing_tier */ 2:
                    message.pricingTier = PricingTiers_Tier.internalBinaryRead(reader, reader.uint32(), options, message.pricingTier);
                    break;
                case /* rd.company.FinancingTerms.Term financing_term */ 3:
                    message.financingTerm = FinancingTerms_Term.internalBinaryRead(reader, reader.uint32(), options, message.financingTerm);
                    break;
                case /* string financing_term_name */ 6:
                    message.financingTermName = reader.string();
                    break;
                case /* rd.txn.CustomerBalance balance */ 7:
                    message.balance = CustomerBalance.internalBinaryRead(reader, reader.uint32(), options, message.balance);
                    break;
                case /* rd.proto.money.Money total_balance */ 8:
                    message.totalBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.totalBalance);
                    break;
                case /* rd.proto.money.Money max_charge_account_sale_total */ 10:
                    message.maxChargeAccountSaleTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.maxChargeAccountSaleTotal);
                    break;
                case /* google.protobuf.Timestamp sale_today_due_at */ 11:
                    message.saleTodayDueAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.saleTodayDueAt);
                    break;
                case /* rd.customer.Contacts contacts */ 12:
                    message.contacts = Contacts.internalBinaryRead(reader, reader.uint32(), options, message.contacts);
                    break;
                case /* bool is_charge_account */ 14:
                    message.isChargeAccount = reader.bool();
                    break;
                case /* rd.company.Staff representative_staff */ 15:
                    message.representativeStaff = Staff.internalBinaryRead(reader, reader.uint32(), options, message.representativeStaff);
                    break;
                case /* rd.txn.CustomerBalance last_statement_balance */ 16:
                    message.lastStatementBalance = CustomerBalance.internalBinaryRead(reader, reader.uint32(), options, message.lastStatementBalance);
                    break;
                case /* rd.proto.money.Money last_statement_total_balance */ 17:
                    message.lastStatementTotalBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.lastStatementTotalBalance);
                    break;
                case /* rd.txn.CustomerSalesAnalytics analytics */ 18:
                    message.analytics = CustomerSalesAnalytics.internalBinaryRead(reader, reader.uint32(), options, message.analytics);
                    break;
                case /* rd.company.FinanceChargeSetting finance_charge_setting */ 19:
                    message.financeChargeSetting = FinanceChargeSetting.internalBinaryRead(reader, reader.uint32(), options, message.financeChargeSetting);
                    break;
                case /* int32 custom_price_count */ 20:
                    message.customPriceCount = reader.int32();
                    break;
                case /* float margin_ytd */ 21:
                    message.marginYtd = reader.float();
                    break;
                case /* rd.proto.money.Money remaining_statement_balance */ 22:
                    message.remainingStatementBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.remainingStatementBalance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCustomerRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.customer.Customer customer = 1; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.PricingTiers.Tier pricing_tier = 2; */
        if (message.pricingTier)
            PricingTiers_Tier.internalBinaryWrite(message.pricingTier, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.FinancingTerms.Term financing_term = 3; */
        if (message.financingTerm)
            FinancingTerms_Term.internalBinaryWrite(message.financingTerm, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string financing_term_name = 6; */
        if (message.financingTermName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.financingTermName);
        /* rd.txn.CustomerBalance balance = 7; */
        if (message.balance)
            CustomerBalance.internalBinaryWrite(message.balance, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total_balance = 8; */
        if (message.totalBalance)
            Money.internalBinaryWrite(message.totalBalance, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money max_charge_account_sale_total = 10; */
        if (message.maxChargeAccountSaleTotal)
            Money.internalBinaryWrite(message.maxChargeAccountSaleTotal, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp sale_today_due_at = 11; */
        if (message.saleTodayDueAt)
            Timestamp.internalBinaryWrite(message.saleTodayDueAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Contacts contacts = 12; */
        if (message.contacts)
            Contacts.internalBinaryWrite(message.contacts, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* bool is_charge_account = 14; */
        if (message.isChargeAccount !== false)
            writer.tag(14, WireType.Varint).bool(message.isChargeAccount);
        /* rd.company.Staff representative_staff = 15; */
        if (message.representativeStaff)
            Staff.internalBinaryWrite(message.representativeStaff, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.CustomerBalance last_statement_balance = 16; */
        if (message.lastStatementBalance)
            CustomerBalance.internalBinaryWrite(message.lastStatementBalance, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money last_statement_total_balance = 17; */
        if (message.lastStatementTotalBalance)
            Money.internalBinaryWrite(message.lastStatementTotalBalance, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.CustomerSalesAnalytics analytics = 18; */
        if (message.analytics)
            CustomerSalesAnalytics.internalBinaryWrite(message.analytics, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.FinanceChargeSetting finance_charge_setting = 19; */
        if (message.financeChargeSetting)
            FinanceChargeSetting.internalBinaryWrite(message.financeChargeSetting, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* int32 custom_price_count = 20; */
        if (message.customPriceCount !== 0)
            writer.tag(20, WireType.Varint).int32(message.customPriceCount);
        /* float margin_ytd = 21; */
        if (message.marginYtd !== 0)
            writer.tag(21, WireType.Bit32).float(message.marginYtd);
        /* rd.proto.money.Money remaining_statement_balance = 22; */
        if (message.remainingStatementBalance)
            Money.internalBinaryWrite(message.remainingStatementBalance, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetCustomerRes
 */
export const GetCustomerRes = new GetCustomerRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCustomerReq$Type extends MessageType<CreateCustomerReq> {
    constructor() {
        super("rd.api.customer.CreateCustomerReq", [
            { no: 1, name: "pricing_tier_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.log": true, "rd.validator.require": true, "rd.validator.is_phone": true } },
            { no: 4, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.log": true, "rd.validator.is_email": true } },
            { no: 5, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.log": true } },
            { no: 6, name: "sales_reminder", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.log": true } },
            { no: 7, name: "location_id", kind: "message", T: () => UUID },
            { no: 8, name: "sms_consent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "address", kind: "message", T: () => Address, options: { "rd.sanitize.log": true } },
            { no: 10, name: "tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 11, name: "type", kind: "enum", T: () => ["rd.customer.Customer.Type", Customer_Type, "TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<CreateCustomerReq>): CreateCustomerReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pricingTierIdString = "";
        message.name = "";
        message.phone = "";
        message.email = "";
        message.notes = "";
        message.salesReminder = "";
        message.smsConsent = false;
        message.tagIds = [];
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<CreateCustomerReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateCustomerReq): CreateCustomerReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string pricing_tier_id_string */ 1:
                    message.pricingTierIdString = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string phone */ 3:
                    message.phone = reader.string();
                    break;
                case /* string email */ 4:
                    message.email = reader.string();
                    break;
                case /* string notes */ 5:
                    message.notes = reader.string();
                    break;
                case /* string sales_reminder */ 6:
                    message.salesReminder = reader.string();
                    break;
                case /* rd.proto.uuid.UUID location_id */ 7:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* bool sms_consent */ 8:
                    message.smsConsent = reader.bool();
                    break;
                case /* rd.proto.address.Address address */ 9:
                    message.address = Address.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                case /* repeated rd.proto.uuid.UUID tag_ids */ 10:
                    message.tagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.customer.Customer.Type type */ 11:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateCustomerReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string pricing_tier_id_string = 1; */
        if (message.pricingTierIdString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.pricingTierIdString);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string phone = 3; */
        if (message.phone !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.phone);
        /* string email = 4; */
        if (message.email !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.email);
        /* string notes = 5; */
        if (message.notes !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.notes);
        /* string sales_reminder = 6; */
        if (message.salesReminder !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.salesReminder);
        /* rd.proto.uuid.UUID location_id = 7; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* bool sms_consent = 8; */
        if (message.smsConsent !== false)
            writer.tag(8, WireType.Varint).bool(message.smsConsent);
        /* rd.proto.address.Address address = 9; */
        if (message.address)
            Address.internalBinaryWrite(message.address, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID tag_ids = 10; */
        for (let i = 0; i < message.tagIds.length; i++)
            UUID.internalBinaryWrite(message.tagIds[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Customer.Type type = 11; */
        if (message.type !== 0)
            writer.tag(11, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.CreateCustomerReq
 */
export const CreateCustomerReq = new CreateCustomerReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCustomerRes$Type extends MessageType<CreateCustomerRes> {
    constructor() {
        super("rd.api.customer.CreateCustomerRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<CreateCustomerRes>): CreateCustomerRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateCustomerRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateCustomerRes): CreateCustomerRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateCustomerRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.CreateCustomerRes
 */
export const CreateCustomerRes = new CreateCustomerRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DuplicateCustomerReq$Type extends MessageType<DuplicateCustomerReq> {
    constructor() {
        super("rd.api.customer.DuplicateCustomerReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DuplicateCustomerReq>): DuplicateCustomerReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DuplicateCustomerReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DuplicateCustomerReq): DuplicateCustomerReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DuplicateCustomerReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.DuplicateCustomerReq
 */
export const DuplicateCustomerReq = new DuplicateCustomerReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DuplicateCustomerRes$Type extends MessageType<DuplicateCustomerRes> {
    constructor() {
        super("rd.api.customer.DuplicateCustomerRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<DuplicateCustomerRes>): DuplicateCustomerRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DuplicateCustomerRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DuplicateCustomerRes): DuplicateCustomerRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DuplicateCustomerRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.DuplicateCustomerRes
 */
export const DuplicateCustomerRes = new DuplicateCustomerRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCustomerInteractionReq$Type extends MessageType<CreateCustomerInteractionReq> {
    constructor() {
        super("rd.api.customer.CreateCustomerInteractionReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.log": true, "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<CreateCustomerInteractionReq>): CreateCustomerInteractionReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notes = "";
        if (value !== undefined)
            reflectionMergePartial<CreateCustomerInteractionReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateCustomerInteractionReq): CreateCustomerInteractionReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string notes */ 2:
                    message.notes = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateCustomerInteractionReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 2; */
        if (message.notes !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.notes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.CreateCustomerInteractionReq
 */
export const CreateCustomerInteractionReq = new CreateCustomerInteractionReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCustomerInteractionRes$Type extends MessageType<CreateCustomerInteractionRes> {
    constructor() {
        super("rd.api.customer.CreateCustomerInteractionRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<CreateCustomerInteractionRes>): CreateCustomerInteractionRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateCustomerInteractionRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateCustomerInteractionRes): CreateCustomerInteractionRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateCustomerInteractionRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.CreateCustomerInteractionRes
 */
export const CreateCustomerInteractionRes = new CreateCustomerInteractionRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerGeneralInformationReq$Type extends MessageType<UpdateCustomerGeneralInformationReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerGeneralInformationReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "pricing_tier_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 5, name: "address", kind: "message", T: () => Address, options: { "rd.sanitize.log": true } },
            { no: 6, name: "primary_location_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerGeneralInformationReq>): UpdateCustomerGeneralInformationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pricingTierIdString = "";
        message.identifier = "";
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerGeneralInformationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerGeneralInformationReq): UpdateCustomerGeneralInformationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string pricing_tier_id_string */ 2:
                    message.pricingTierIdString = reader.string();
                    break;
                case /* string identifier */ 3:
                    message.identifier = reader.string();
                    break;
                case /* string name */ 4:
                    message.name = reader.string();
                    break;
                case /* rd.proto.address.Address address */ 5:
                    message.address = Address.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                case /* rd.proto.uuid.UUID primary_location_id */ 6:
                    message.primaryLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.primaryLocationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerGeneralInformationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string pricing_tier_id_string = 2; */
        if (message.pricingTierIdString !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pricingTierIdString);
        /* string identifier = 3; */
        if (message.identifier !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.identifier);
        /* string name = 4; */
        if (message.name !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.name);
        /* rd.proto.address.Address address = 5; */
        if (message.address)
            Address.internalBinaryWrite(message.address, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID primary_location_id = 6; */
        if (message.primaryLocationId)
            UUID.internalBinaryWrite(message.primaryLocationId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerGeneralInformationReq
 */
export const UpdateCustomerGeneralInformationReq = new UpdateCustomerGeneralInformationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerGeneralInformationRes$Type extends MessageType<UpdateCustomerGeneralInformationRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerGeneralInformationRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerGeneralInformationRes>): UpdateCustomerGeneralInformationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerGeneralInformationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerGeneralInformationRes): UpdateCustomerGeneralInformationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerGeneralInformationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerGeneralInformationRes
 */
export const UpdateCustomerGeneralInformationRes = new UpdateCustomerGeneralInformationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerGeneralInfoMobileReq$Type extends MessageType<UpdateCustomerGeneralInfoMobileReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerGeneralInfoMobileReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "pricing_tier_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerGeneralInfoMobileReq>): UpdateCustomerGeneralInfoMobileReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pricingTierIdString = "";
        message.identifier = "";
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerGeneralInfoMobileReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerGeneralInfoMobileReq): UpdateCustomerGeneralInfoMobileReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string pricing_tier_id_string */ 2:
                    message.pricingTierIdString = reader.string();
                    break;
                case /* string identifier */ 3:
                    message.identifier = reader.string();
                    break;
                case /* string name */ 4:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerGeneralInfoMobileReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string pricing_tier_id_string = 2; */
        if (message.pricingTierIdString !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pricingTierIdString);
        /* string identifier = 3; */
        if (message.identifier !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.identifier);
        /* string name = 4; */
        if (message.name !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerGeneralInfoMobileReq
 */
export const UpdateCustomerGeneralInfoMobileReq = new UpdateCustomerGeneralInfoMobileReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerGeneralInfoMobileRes$Type extends MessageType<UpdateCustomerGeneralInfoMobileRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerGeneralInfoMobileRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerGeneralInfoMobileRes>): UpdateCustomerGeneralInfoMobileRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerGeneralInfoMobileRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerGeneralInfoMobileRes): UpdateCustomerGeneralInfoMobileRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerGeneralInfoMobileRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerGeneralInfoMobileRes
 */
export const UpdateCustomerGeneralInfoMobileRes = new UpdateCustomerGeneralInfoMobileRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerExemptionsReq$Type extends MessageType<UpdateCustomerExemptionsReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerExemptionsReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "eco_fee_exempt_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "sales_tax_exempt_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "tax_rate_id", kind: "message", T: () => UUID },
            { no: 5, name: "single_use_tax_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerExemptionsReq>): UpdateCustomerExemptionsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ecoFeeExemptNumber = "";
        message.salesTaxExemptNumber = "";
        message.singleUseTaxNumber = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerExemptionsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerExemptionsReq): UpdateCustomerExemptionsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string eco_fee_exempt_number */ 2:
                    message.ecoFeeExemptNumber = reader.string();
                    break;
                case /* string sales_tax_exempt_number */ 3:
                    message.salesTaxExemptNumber = reader.string();
                    break;
                case /* rd.proto.uuid.UUID tax_rate_id */ 4:
                    message.taxRateId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.taxRateId);
                    break;
                case /* string single_use_tax_number */ 5:
                    message.singleUseTaxNumber = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerExemptionsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string eco_fee_exempt_number = 2; */
        if (message.ecoFeeExemptNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ecoFeeExemptNumber);
        /* string sales_tax_exempt_number = 3; */
        if (message.salesTaxExemptNumber !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.salesTaxExemptNumber);
        /* rd.proto.uuid.UUID tax_rate_id = 4; */
        if (message.taxRateId)
            UUID.internalBinaryWrite(message.taxRateId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string single_use_tax_number = 5; */
        if (message.singleUseTaxNumber !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.singleUseTaxNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerExemptionsReq
 */
export const UpdateCustomerExemptionsReq = new UpdateCustomerExemptionsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerExemptionsRes$Type extends MessageType<UpdateCustomerExemptionsRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerExemptionsRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerExemptionsRes>): UpdateCustomerExemptionsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerExemptionsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerExemptionsRes): UpdateCustomerExemptionsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerExemptionsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerExemptionsRes
 */
export const UpdateCustomerExemptionsRes = new UpdateCustomerExemptionsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldRequirePOReq$Type extends MessageType<UpdateCustomerShouldRequirePOReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldRequirePOReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "should_require_po", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerShouldRequirePOReq>): UpdateCustomerShouldRequirePOReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldRequirePo = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldRequirePOReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldRequirePOReq): UpdateCustomerShouldRequirePOReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool should_require_po */ 2:
                    message.shouldRequirePo = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldRequirePOReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool should_require_po = 2; */
        if (message.shouldRequirePo !== false)
            writer.tag(2, WireType.Varint).bool(message.shouldRequirePo);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldRequirePOReq
 */
export const UpdateCustomerShouldRequirePOReq = new UpdateCustomerShouldRequirePOReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldRequirePORes$Type extends MessageType<UpdateCustomerShouldRequirePORes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldRequirePORes", []);
    }
    create(value?: PartialMessage<UpdateCustomerShouldRequirePORes>): UpdateCustomerShouldRequirePORes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldRequirePORes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldRequirePORes): UpdateCustomerShouldRequirePORes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldRequirePORes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldRequirePORes
 */
export const UpdateCustomerShouldRequirePORes = new UpdateCustomerShouldRequirePORes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldPrintInvoicesAndReceiptsReq$Type extends MessageType<UpdateCustomerShouldPrintInvoicesAndReceiptsReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldPrintInvoicesAndReceiptsReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "should_print_invoices_and_receipts", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerShouldPrintInvoicesAndReceiptsReq>): UpdateCustomerShouldPrintInvoicesAndReceiptsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldPrintInvoicesAndReceipts = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldPrintInvoicesAndReceiptsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldPrintInvoicesAndReceiptsReq): UpdateCustomerShouldPrintInvoicesAndReceiptsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool should_print_invoices_and_receipts */ 2:
                    message.shouldPrintInvoicesAndReceipts = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldPrintInvoicesAndReceiptsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool should_print_invoices_and_receipts = 2; */
        if (message.shouldPrintInvoicesAndReceipts !== false)
            writer.tag(2, WireType.Varint).bool(message.shouldPrintInvoicesAndReceipts);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldPrintInvoicesAndReceiptsReq
 */
export const UpdateCustomerShouldPrintInvoicesAndReceiptsReq = new UpdateCustomerShouldPrintInvoicesAndReceiptsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldPrintInvoicesAndReceiptsRes$Type extends MessageType<UpdateCustomerShouldPrintInvoicesAndReceiptsRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldPrintInvoicesAndReceiptsRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerShouldPrintInvoicesAndReceiptsRes>): UpdateCustomerShouldPrintInvoicesAndReceiptsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldPrintInvoicesAndReceiptsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldPrintInvoicesAndReceiptsRes): UpdateCustomerShouldPrintInvoicesAndReceiptsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldPrintInvoicesAndReceiptsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldPrintInvoicesAndReceiptsRes
 */
export const UpdateCustomerShouldPrintInvoicesAndReceiptsRes = new UpdateCustomerShouldPrintInvoicesAndReceiptsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerNotesReq$Type extends MessageType<UpdateCustomerNotesReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerNotesReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.log": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerNotesReq>): UpdateCustomerNotesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notes = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerNotesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerNotesReq): UpdateCustomerNotesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string notes */ 2:
                    message.notes = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerNotesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 2; */
        if (message.notes !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.notes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerNotesReq
 */
export const UpdateCustomerNotesReq = new UpdateCustomerNotesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerNotesRes$Type extends MessageType<UpdateCustomerNotesRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerNotesRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerNotesRes>): UpdateCustomerNotesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerNotesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerNotesRes): UpdateCustomerNotesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerNotesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerNotesRes
 */
export const UpdateCustomerNotesRes = new UpdateCustomerNotesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerIsActiveReq$Type extends MessageType<UpdateCustomerIsActiveReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerIsActiveReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerIsActiveReq>): UpdateCustomerIsActiveReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isActive = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerIsActiveReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerIsActiveReq): UpdateCustomerIsActiveReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool is_active */ 2:
                    message.isActive = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerIsActiveReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool is_active = 2; */
        if (message.isActive !== false)
            writer.tag(2, WireType.Varint).bool(message.isActive);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerIsActiveReq
 */
export const UpdateCustomerIsActiveReq = new UpdateCustomerIsActiveReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerIsActiveRes$Type extends MessageType<UpdateCustomerIsActiveRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerIsActiveRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerIsActiveRes>): UpdateCustomerIsActiveRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerIsActiveRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerIsActiveRes): UpdateCustomerIsActiveRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerIsActiveRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerIsActiveRes
 */
export const UpdateCustomerIsActiveRes = new UpdateCustomerIsActiveRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerFinancingTermReq$Type extends MessageType<UpdateCustomerFinancingTermReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerFinancingTermReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "financing_term_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerFinancingTermReq>): UpdateCustomerFinancingTermReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.financingTermIdString = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerFinancingTermReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerFinancingTermReq): UpdateCustomerFinancingTermReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string financing_term_id_string */ 2:
                    message.financingTermIdString = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerFinancingTermReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string financing_term_id_string = 2; */
        if (message.financingTermIdString !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.financingTermIdString);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerFinancingTermReq
 */
export const UpdateCustomerFinancingTermReq = new UpdateCustomerFinancingTermReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerFinancingTermRes$Type extends MessageType<UpdateCustomerFinancingTermRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerFinancingTermRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerFinancingTermRes>): UpdateCustomerFinancingTermRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerFinancingTermRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerFinancingTermRes): UpdateCustomerFinancingTermRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerFinancingTermRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerFinancingTermRes
 */
export const UpdateCustomerFinancingTermRes = new UpdateCustomerFinancingTermRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerCreditLimitReq$Type extends MessageType<UpdateCustomerCreditLimitReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerCreditLimitReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "credit_limit", kind: "message", T: () => Money, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerCreditLimitReq>): UpdateCustomerCreditLimitReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerCreditLimitReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerCreditLimitReq): UpdateCustomerCreditLimitReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.money.Money credit_limit */ 2:
                    message.creditLimit = Money.internalBinaryRead(reader, reader.uint32(), options, message.creditLimit);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerCreditLimitReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money credit_limit = 2; */
        if (message.creditLimit)
            Money.internalBinaryWrite(message.creditLimit, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerCreditLimitReq
 */
export const UpdateCustomerCreditLimitReq = new UpdateCustomerCreditLimitReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerCreditLimitRes$Type extends MessageType<UpdateCustomerCreditLimitRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerCreditLimitRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerCreditLimitRes>): UpdateCustomerCreditLimitRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerCreditLimitRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerCreditLimitRes): UpdateCustomerCreditLimitRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerCreditLimitRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerCreditLimitRes
 */
export const UpdateCustomerCreditLimitRes = new UpdateCustomerCreditLimitRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerIsOnCreditHoldReq$Type extends MessageType<UpdateCustomerIsOnCreditHoldReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerIsOnCreditHoldReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "is_on_credit_hold", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerIsOnCreditHoldReq>): UpdateCustomerIsOnCreditHoldReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isOnCreditHold = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerIsOnCreditHoldReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerIsOnCreditHoldReq): UpdateCustomerIsOnCreditHoldReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool is_on_credit_hold */ 2:
                    message.isOnCreditHold = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerIsOnCreditHoldReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool is_on_credit_hold = 2; */
        if (message.isOnCreditHold !== false)
            writer.tag(2, WireType.Varint).bool(message.isOnCreditHold);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerIsOnCreditHoldReq
 */
export const UpdateCustomerIsOnCreditHoldReq = new UpdateCustomerIsOnCreditHoldReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerIsOnCreditHoldRes$Type extends MessageType<UpdateCustomerIsOnCreditHoldRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerIsOnCreditHoldRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerIsOnCreditHoldRes>): UpdateCustomerIsOnCreditHoldRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerIsOnCreditHoldRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerIsOnCreditHoldRes): UpdateCustomerIsOnCreditHoldRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerIsOnCreditHoldRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerIsOnCreditHoldRes
 */
export const UpdateCustomerIsOnCreditHoldRes = new UpdateCustomerIsOnCreditHoldRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldAutopayStatementBalancesReq$Type extends MessageType<UpdateCustomerShouldAutopayStatementBalancesReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldAutopayStatementBalancesReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "should_autopay_statement_balances", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerShouldAutopayStatementBalancesReq>): UpdateCustomerShouldAutopayStatementBalancesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldAutopayStatementBalances = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldAutopayStatementBalancesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldAutopayStatementBalancesReq): UpdateCustomerShouldAutopayStatementBalancesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool should_autopay_statement_balances */ 2:
                    message.shouldAutopayStatementBalances = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldAutopayStatementBalancesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool should_autopay_statement_balances = 2; */
        if (message.shouldAutopayStatementBalances !== false)
            writer.tag(2, WireType.Varint).bool(message.shouldAutopayStatementBalances);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldAutopayStatementBalancesReq
 */
export const UpdateCustomerShouldAutopayStatementBalancesReq = new UpdateCustomerShouldAutopayStatementBalancesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldAutopayStatementBalancesRes$Type extends MessageType<UpdateCustomerShouldAutopayStatementBalancesRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldAutopayStatementBalancesRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerShouldAutopayStatementBalancesRes>): UpdateCustomerShouldAutopayStatementBalancesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldAutopayStatementBalancesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldAutopayStatementBalancesRes): UpdateCustomerShouldAutopayStatementBalancesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldAutopayStatementBalancesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldAutopayStatementBalancesRes
 */
export const UpdateCustomerShouldAutopayStatementBalancesRes = new UpdateCustomerShouldAutopayStatementBalancesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldMailStatementsReq$Type extends MessageType<UpdateCustomerShouldMailStatementsReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldMailStatementsReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "should_mail_statements", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerShouldMailStatementsReq>): UpdateCustomerShouldMailStatementsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldMailStatements = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldMailStatementsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldMailStatementsReq): UpdateCustomerShouldMailStatementsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool should_mail_statements */ 2:
                    message.shouldMailStatements = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldMailStatementsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool should_mail_statements = 2; */
        if (message.shouldMailStatements !== false)
            writer.tag(2, WireType.Varint).bool(message.shouldMailStatements);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldMailStatementsReq
 */
export const UpdateCustomerShouldMailStatementsReq = new UpdateCustomerShouldMailStatementsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldMailStatementsRes$Type extends MessageType<UpdateCustomerShouldMailStatementsRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldMailStatementsRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerShouldMailStatementsRes>): UpdateCustomerShouldMailStatementsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldMailStatementsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldMailStatementsRes): UpdateCustomerShouldMailStatementsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldMailStatementsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldMailStatementsRes
 */
export const UpdateCustomerShouldMailStatementsRes = new UpdateCustomerShouldMailStatementsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldRequireCustomerContactReq$Type extends MessageType<UpdateCustomerShouldRequireCustomerContactReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldRequireCustomerContactReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "should_require_customer_contact", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerShouldRequireCustomerContactReq>): UpdateCustomerShouldRequireCustomerContactReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldRequireCustomerContact = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldRequireCustomerContactReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldRequireCustomerContactReq): UpdateCustomerShouldRequireCustomerContactReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool should_require_customer_contact */ 2:
                    message.shouldRequireCustomerContact = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldRequireCustomerContactReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool should_require_customer_contact = 2; */
        if (message.shouldRequireCustomerContact !== false)
            writer.tag(2, WireType.Varint).bool(message.shouldRequireCustomerContact);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldRequireCustomerContactReq
 */
export const UpdateCustomerShouldRequireCustomerContactReq = new UpdateCustomerShouldRequireCustomerContactReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldRequireCustomerContactRes$Type extends MessageType<UpdateCustomerShouldRequireCustomerContactRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldRequireCustomerContactRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerShouldRequireCustomerContactRes>): UpdateCustomerShouldRequireCustomerContactRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldRequireCustomerContactRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldRequireCustomerContactRes): UpdateCustomerShouldRequireCustomerContactRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldRequireCustomerContactRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldRequireCustomerContactRes
 */
export const UpdateCustomerShouldRequireCustomerContactRes = new UpdateCustomerShouldRequireCustomerContactRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldRequireSaleNotesReq$Type extends MessageType<UpdateCustomerShouldRequireSaleNotesReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldRequireSaleNotesReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "should_require_sale_notes", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerShouldRequireSaleNotesReq>): UpdateCustomerShouldRequireSaleNotesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldRequireSaleNotes = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldRequireSaleNotesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldRequireSaleNotesReq): UpdateCustomerShouldRequireSaleNotesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool should_require_sale_notes */ 2:
                    message.shouldRequireSaleNotes = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldRequireSaleNotesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool should_require_sale_notes = 2; */
        if (message.shouldRequireSaleNotes !== false)
            writer.tag(2, WireType.Varint).bool(message.shouldRequireSaleNotes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldRequireSaleNotesReq
 */
export const UpdateCustomerShouldRequireSaleNotesReq = new UpdateCustomerShouldRequireSaleNotesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldRequireSaleNotesRes$Type extends MessageType<UpdateCustomerShouldRequireSaleNotesRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldRequireSaleNotesRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerShouldRequireSaleNotesRes>): UpdateCustomerShouldRequireSaleNotesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldRequireSaleNotesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldRequireSaleNotesRes): UpdateCustomerShouldRequireSaleNotesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldRequireSaleNotesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldRequireSaleNotesRes
 */
export const UpdateCustomerShouldRequireSaleNotesRes = new UpdateCustomerShouldRequireSaleNotesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldRequireInternalSaleNotesReq$Type extends MessageType<UpdateCustomerShouldRequireInternalSaleNotesReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldRequireInternalSaleNotesReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "should_require_internal_sale_notes", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerShouldRequireInternalSaleNotesReq>): UpdateCustomerShouldRequireInternalSaleNotesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldRequireInternalSaleNotes = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldRequireInternalSaleNotesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldRequireInternalSaleNotesReq): UpdateCustomerShouldRequireInternalSaleNotesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool should_require_internal_sale_notes */ 2:
                    message.shouldRequireInternalSaleNotes = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldRequireInternalSaleNotesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool should_require_internal_sale_notes = 2; */
        if (message.shouldRequireInternalSaleNotes !== false)
            writer.tag(2, WireType.Varint).bool(message.shouldRequireInternalSaleNotes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldRequireInternalSaleNotesReq
 */
export const UpdateCustomerShouldRequireInternalSaleNotesReq = new UpdateCustomerShouldRequireInternalSaleNotesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldRequireInternalSaleNotesRes$Type extends MessageType<UpdateCustomerShouldRequireInternalSaleNotesRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldRequireInternalSaleNotesRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerShouldRequireInternalSaleNotesRes>): UpdateCustomerShouldRequireInternalSaleNotesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldRequireInternalSaleNotesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldRequireInternalSaleNotesRes): UpdateCustomerShouldRequireInternalSaleNotesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldRequireInternalSaleNotesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldRequireInternalSaleNotesRes
 */
export const UpdateCustomerShouldRequireInternalSaleNotesRes = new UpdateCustomerShouldRequireInternalSaleNotesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerFinanceChargeSettingReq$Type extends MessageType<UpdateCustomerFinanceChargeSettingReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerFinanceChargeSettingReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "finance_charge_setting_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerFinanceChargeSettingReq>): UpdateCustomerFinanceChargeSettingReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerFinanceChargeSettingReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerFinanceChargeSettingReq): UpdateCustomerFinanceChargeSettingReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID finance_charge_setting_id */ 2:
                    message.financeChargeSettingId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.financeChargeSettingId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerFinanceChargeSettingReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID finance_charge_setting_id = 2; */
        if (message.financeChargeSettingId)
            UUID.internalBinaryWrite(message.financeChargeSettingId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerFinanceChargeSettingReq
 */
export const UpdateCustomerFinanceChargeSettingReq = new UpdateCustomerFinanceChargeSettingReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerFinanceChargeSettingRes$Type extends MessageType<UpdateCustomerFinanceChargeSettingRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerFinanceChargeSettingRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerFinanceChargeSettingRes>): UpdateCustomerFinanceChargeSettingRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerFinanceChargeSettingRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerFinanceChargeSettingRes): UpdateCustomerFinanceChargeSettingRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerFinanceChargeSettingRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerFinanceChargeSettingRes
 */
export const UpdateCustomerFinanceChargeSettingRes = new UpdateCustomerFinanceChargeSettingRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerRepReq$Type extends MessageType<UpdateCustomerRepReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerRepReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "rep_staff_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerRepReq>): UpdateCustomerRepReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerRepReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerRepReq): UpdateCustomerRepReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID rep_staff_id */ 2:
                    message.repStaffId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.repStaffId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerRepReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID rep_staff_id = 2; */
        if (message.repStaffId)
            UUID.internalBinaryWrite(message.repStaffId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerRepReq
 */
export const UpdateCustomerRepReq = new UpdateCustomerRepReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerRepRes$Type extends MessageType<UpdateCustomerRepRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerRepRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerRepRes>): UpdateCustomerRepRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerRepRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerRepRes): UpdateCustomerRepRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerRepRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerRepRes
 */
export const UpdateCustomerRepRes = new UpdateCustomerRepRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPurchaseOrdersForCustomerReq$Type extends MessageType<ListPurchaseOrdersForCustomerReq> {
    constructor() {
        super("rd.api.customer.ListPurchaseOrdersForCustomerReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ListPurchaseOrdersForCustomerReq>): ListPurchaseOrdersForCustomerReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListPurchaseOrdersForCustomerReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListPurchaseOrdersForCustomerReq): ListPurchaseOrdersForCustomerReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListPurchaseOrdersForCustomerReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.ListPurchaseOrdersForCustomerReq
 */
export const ListPurchaseOrdersForCustomerReq = new ListPurchaseOrdersForCustomerReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPurchaseOrdersForCustomerRes$Type extends MessageType<ListPurchaseOrdersForCustomerRes> {
    constructor() {
        super("rd.api.customer.ListPurchaseOrdersForCustomerRes", [
            { no: 1, name: "purchase_orders", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PurchaseOrder }
        ]);
    }
    create(value?: PartialMessage<ListPurchaseOrdersForCustomerRes>): ListPurchaseOrdersForCustomerRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.purchaseOrders = [];
        if (value !== undefined)
            reflectionMergePartial<ListPurchaseOrdersForCustomerRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListPurchaseOrdersForCustomerRes): ListPurchaseOrdersForCustomerRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.customer.PurchaseOrder purchase_orders */ 1:
                    message.purchaseOrders.push(PurchaseOrder.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListPurchaseOrdersForCustomerRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.customer.PurchaseOrder purchase_orders = 1; */
        for (let i = 0; i < message.purchaseOrders.length; i++)
            PurchaseOrder.internalBinaryWrite(message.purchaseOrders[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.ListPurchaseOrdersForCustomerRes
 */
export const ListPurchaseOrdersForCustomerRes = new ListPurchaseOrdersForCustomerRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListInteractionsForCustomerReq$Type extends MessageType<ListInteractionsForCustomerReq> {
    constructor() {
        super("rd.api.customer.ListInteractionsForCustomerReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ListInteractionsForCustomerReq>): ListInteractionsForCustomerReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListInteractionsForCustomerReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListInteractionsForCustomerReq): ListInteractionsForCustomerReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListInteractionsForCustomerReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.ListInteractionsForCustomerReq
 */
export const ListInteractionsForCustomerReq = new ListInteractionsForCustomerReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListInteractionsForCustomerRes$Type extends MessageType<ListInteractionsForCustomerRes> {
    constructor() {
        super("rd.api.customer.ListInteractionsForCustomerRes", [
            { no: 1, name: "interactions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Interaction }
        ]);
    }
    create(value?: PartialMessage<ListInteractionsForCustomerRes>): ListInteractionsForCustomerRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.interactions = [];
        if (value !== undefined)
            reflectionMergePartial<ListInteractionsForCustomerRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListInteractionsForCustomerRes): ListInteractionsForCustomerRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.customer.Interaction interactions */ 1:
                    message.interactions.push(Interaction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListInteractionsForCustomerRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.customer.Interaction interactions = 1; */
        for (let i = 0; i < message.interactions.length; i++)
            Interaction.internalBinaryWrite(message.interactions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.ListInteractionsForCustomerRes
 */
export const ListInteractionsForCustomerRes = new ListInteractionsForCustomerRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerContractorRewardsReq$Type extends MessageType<UpdateCustomerContractorRewardsReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerContractorRewardsReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "pax_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "rsd_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "type", kind: "enum", T: () => ["rd.customer.Customer.Type", Customer_Type, "TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerContractorRewardsReq>): UpdateCustomerContractorRewardsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paxId = "";
        message.rsdNumber = "";
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerContractorRewardsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerContractorRewardsReq): UpdateCustomerContractorRewardsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* string pax_id */ 2:
                    message.paxId = reader.string();
                    break;
                case /* string rsd_number */ 3:
                    message.rsdNumber = reader.string();
                    break;
                case /* rd.customer.Customer.Type type */ 4:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerContractorRewardsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string pax_id = 2; */
        if (message.paxId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.paxId);
        /* string rsd_number = 3; */
        if (message.rsdNumber !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.rsdNumber);
        /* rd.customer.Customer.Type type = 4; */
        if (message.type !== 0)
            writer.tag(4, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerContractorRewardsReq
 */
export const UpdateCustomerContractorRewardsReq = new UpdateCustomerContractorRewardsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerContractorRewardsRes$Type extends MessageType<UpdateCustomerContractorRewardsRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerContractorRewardsRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerContractorRewardsRes>): UpdateCustomerContractorRewardsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerContractorRewardsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerContractorRewardsRes): UpdateCustomerContractorRewardsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerContractorRewardsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerContractorRewardsRes
 */
export const UpdateCustomerContractorRewardsRes = new UpdateCustomerContractorRewardsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldRequireReceiptSignatureReq$Type extends MessageType<UpdateCustomerShouldRequireReceiptSignatureReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldRequireReceiptSignatureReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 3, name: "signature_requirement", kind: "enum", T: () => ["rd.customer.Customer.SignatureRequirement", Customer_SignatureRequirement, "SIGNATURE_REQUIREMENT_"] }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerShouldRequireReceiptSignatureReq>): UpdateCustomerShouldRequireReceiptSignatureReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.signatureRequirement = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldRequireReceiptSignatureReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldRequireReceiptSignatureReq): UpdateCustomerShouldRequireReceiptSignatureReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.customer.Customer.SignatureRequirement signature_requirement */ 3:
                    message.signatureRequirement = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldRequireReceiptSignatureReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Customer.SignatureRequirement signature_requirement = 3; */
        if (message.signatureRequirement !== 0)
            writer.tag(3, WireType.Varint).int32(message.signatureRequirement);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldRequireReceiptSignatureReq
 */
export const UpdateCustomerShouldRequireReceiptSignatureReq = new UpdateCustomerShouldRequireReceiptSignatureReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldRequireReceiptSignatureRes$Type extends MessageType<UpdateCustomerShouldRequireReceiptSignatureRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldRequireReceiptSignatureRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerShouldRequireReceiptSignatureRes>): UpdateCustomerShouldRequireReceiptSignatureRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldRequireReceiptSignatureRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldRequireReceiptSignatureRes): UpdateCustomerShouldRequireReceiptSignatureRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldRequireReceiptSignatureRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldRequireReceiptSignatureRes
 */
export const UpdateCustomerShouldRequireReceiptSignatureRes = new UpdateCustomerShouldRequireReceiptSignatureRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerPricingTierReq$Type extends MessageType<UpdateCustomerPricingTierReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerPricingTierReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "pricing_tier_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerPricingTierReq>): UpdateCustomerPricingTierReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pricingTierIdString = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerPricingTierReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerPricingTierReq): UpdateCustomerPricingTierReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* string pricing_tier_id_string */ 2:
                    message.pricingTierIdString = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerPricingTierReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string pricing_tier_id_string = 2; */
        if (message.pricingTierIdString !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pricingTierIdString);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerPricingTierReq
 */
export const UpdateCustomerPricingTierReq = new UpdateCustomerPricingTierReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerPricingTierRes$Type extends MessageType<UpdateCustomerPricingTierRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerPricingTierRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerPricingTierRes>): UpdateCustomerPricingTierRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerPricingTierRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerPricingTierRes): UpdateCustomerPricingTierRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerPricingTierRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerPricingTierRes
 */
export const UpdateCustomerPricingTierRes = new UpdateCustomerPricingTierRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCustomersForRepReq$Type extends MessageType<ListCustomersForRepReq> {
    constructor() {
        super("rd.api.customer.ListCustomersForRepReq", [
            { no: 1, name: "rep_staff_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ListCustomersForRepReq>): ListCustomersForRepReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListCustomersForRepReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListCustomersForRepReq): ListCustomersForRepReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID rep_staff_id */ 1:
                    message.repStaffId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.repStaffId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListCustomersForRepReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID rep_staff_id = 1; */
        if (message.repStaffId)
            UUID.internalBinaryWrite(message.repStaffId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.ListCustomersForRepReq
 */
export const ListCustomersForRepReq = new ListCustomersForRepReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCustomersForRepRes$Type extends MessageType<ListCustomersForRepRes> {
    constructor() {
        super("rd.api.customer.ListCustomersForRepRes", [
            { no: 1, name: "customers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Customer }
        ]);
    }
    create(value?: PartialMessage<ListCustomersForRepRes>): ListCustomersForRepRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.customers = [];
        if (value !== undefined)
            reflectionMergePartial<ListCustomersForRepRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListCustomersForRepRes): ListCustomersForRepRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.customer.Customer customers */ 1:
                    message.customers.push(Customer.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListCustomersForRepRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.customer.Customer customers = 1; */
        for (let i = 0; i < message.customers.length; i++)
            Customer.internalBinaryWrite(message.customers[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.ListCustomersForRepRes
 */
export const ListCustomersForRepRes = new ListCustomersForRepRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomerCountForTierReq$Type extends MessageType<GetCustomerCountForTierReq> {
    constructor() {
        super("rd.api.customer.GetCustomerCountForTierReq", [
            { no: 1, name: "pricing_tier_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetCustomerCountForTierReq>): GetCustomerCountForTierReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pricingTierIdString = "";
        if (value !== undefined)
            reflectionMergePartial<GetCustomerCountForTierReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCustomerCountForTierReq): GetCustomerCountForTierReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string pricing_tier_id_string */ 1:
                    message.pricingTierIdString = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCustomerCountForTierReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string pricing_tier_id_string = 1; */
        if (message.pricingTierIdString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.pricingTierIdString);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetCustomerCountForTierReq
 */
export const GetCustomerCountForTierReq = new GetCustomerCountForTierReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomerCountForTierRes$Type extends MessageType<GetCustomerCountForTierRes> {
    constructor() {
        super("rd.api.customer.GetCustomerCountForTierRes", [
            { no: 1, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetCustomerCountForTierRes>): GetCustomerCountForTierRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<GetCustomerCountForTierRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCustomerCountForTierRes): GetCustomerCountForTierRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 count */ 1:
                    message.count = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCustomerCountForTierRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int32(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetCustomerCountForTierRes
 */
export const GetCustomerCountForTierRes = new GetCustomerCountForTierRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetJobCountForCustomerReq$Type extends MessageType<GetJobCountForCustomerReq> {
    constructor() {
        super("rd.api.customer.GetJobCountForCustomerReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetJobCountForCustomerReq>): GetJobCountForCustomerReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetJobCountForCustomerReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetJobCountForCustomerReq): GetJobCountForCustomerReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetJobCountForCustomerReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetJobCountForCustomerReq
 */
export const GetJobCountForCustomerReq = new GetJobCountForCustomerReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetJobCountForCustomerRes$Type extends MessageType<GetJobCountForCustomerRes> {
    constructor() {
        super("rd.api.customer.GetJobCountForCustomerRes", [
            { no: 1, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetJobCountForCustomerRes>): GetJobCountForCustomerRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<GetJobCountForCustomerRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetJobCountForCustomerRes): GetJobCountForCustomerRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 count */ 1:
                    message.count = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetJobCountForCustomerRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int32(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetJobCountForCustomerRes
 */
export const GetJobCountForCustomerRes = new GetJobCountForCustomerRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetActiveCustomerCountReq$Type extends MessageType<GetActiveCustomerCountReq> {
    constructor() {
        super("rd.api.customer.GetActiveCustomerCountReq", []);
    }
    create(value?: PartialMessage<GetActiveCustomerCountReq>): GetActiveCustomerCountReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetActiveCustomerCountReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetActiveCustomerCountReq): GetActiveCustomerCountReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetActiveCustomerCountReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetActiveCustomerCountReq
 */
export const GetActiveCustomerCountReq = new GetActiveCustomerCountReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetActiveCustomerCountRes$Type extends MessageType<GetActiveCustomerCountRes> {
    constructor() {
        super("rd.api.customer.GetActiveCustomerCountRes", [
            { no: 1, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetActiveCustomerCountRes>): GetActiveCustomerCountRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<GetActiveCustomerCountRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetActiveCustomerCountRes): GetActiveCustomerCountRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 count */ 1:
                    message.count = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetActiveCustomerCountRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int32(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetActiveCustomerCountRes
 */
export const GetActiveCustomerCountRes = new GetActiveCustomerCountRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnrollCustomerInFanBuilderLoyaltyReq$Type extends MessageType<EnrollCustomerInFanBuilderLoyaltyReq> {
    constructor() {
        super("rd.api.customer.EnrollCustomerInFanBuilderLoyaltyReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 3, name: "system_store_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 4, name: "terminal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<EnrollCustomerInFanBuilderLoyaltyReq>): EnrollCustomerInFanBuilderLoyaltyReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.systemStoreId = "";
        message.terminalId = "";
        if (value !== undefined)
            reflectionMergePartial<EnrollCustomerInFanBuilderLoyaltyReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EnrollCustomerInFanBuilderLoyaltyReq): EnrollCustomerInFanBuilderLoyaltyReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* string system_store_id */ 3:
                    message.systemStoreId = reader.string();
                    break;
                case /* string terminal_id */ 4:
                    message.terminalId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EnrollCustomerInFanBuilderLoyaltyReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string system_store_id = 3; */
        if (message.systemStoreId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.systemStoreId);
        /* string terminal_id = 4; */
        if (message.terminalId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.terminalId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.EnrollCustomerInFanBuilderLoyaltyReq
 */
export const EnrollCustomerInFanBuilderLoyaltyReq = new EnrollCustomerInFanBuilderLoyaltyReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnrollCustomerInFanBuilderLoyaltyRes$Type extends MessageType<EnrollCustomerInFanBuilderLoyaltyRes> {
    constructor() {
        super("rd.api.customer.EnrollCustomerInFanBuilderLoyaltyRes", [
            { no: 1, name: "fan_builder_system_customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EnrollCustomerInFanBuilderLoyaltyRes>): EnrollCustomerInFanBuilderLoyaltyRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fanBuilderSystemCustomerId = "";
        if (value !== undefined)
            reflectionMergePartial<EnrollCustomerInFanBuilderLoyaltyRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EnrollCustomerInFanBuilderLoyaltyRes): EnrollCustomerInFanBuilderLoyaltyRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string fan_builder_system_customer_id */ 1:
                    message.fanBuilderSystemCustomerId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EnrollCustomerInFanBuilderLoyaltyRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string fan_builder_system_customer_id = 1; */
        if (message.fanBuilderSystemCustomerId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fanBuilderSystemCustomerId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.EnrollCustomerInFanBuilderLoyaltyRes
 */
export const EnrollCustomerInFanBuilderLoyaltyRes = new EnrollCustomerInFanBuilderLoyaltyRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomerFanBuilderLoyaltyReq$Type extends MessageType<GetCustomerFanBuilderLoyaltyReq> {
    constructor() {
        super("rd.api.customer.GetCustomerFanBuilderLoyaltyReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 3, name: "system_store_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 4, name: "terminal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetCustomerFanBuilderLoyaltyReq>): GetCustomerFanBuilderLoyaltyReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.systemStoreId = "";
        message.terminalId = "";
        if (value !== undefined)
            reflectionMergePartial<GetCustomerFanBuilderLoyaltyReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCustomerFanBuilderLoyaltyReq): GetCustomerFanBuilderLoyaltyReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* string system_store_id */ 3:
                    message.systemStoreId = reader.string();
                    break;
                case /* string terminal_id */ 4:
                    message.terminalId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCustomerFanBuilderLoyaltyReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string system_store_id = 3; */
        if (message.systemStoreId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.systemStoreId);
        /* string terminal_id = 4; */
        if (message.terminalId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.terminalId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetCustomerFanBuilderLoyaltyReq
 */
export const GetCustomerFanBuilderLoyaltyReq = new GetCustomerFanBuilderLoyaltyReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomerFanBuilderLoyaltyRes$Type extends MessageType<GetCustomerFanBuilderLoyaltyRes> {
    constructor() {
        super("rd.api.customer.GetCustomerFanBuilderLoyaltyRes", [
            { no: 1, name: "enrolled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "fan_builder_system_customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "dashboard_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "coupons", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FanBuilderLoyaltyCoupon }
        ]);
    }
    create(value?: PartialMessage<GetCustomerFanBuilderLoyaltyRes>): GetCustomerFanBuilderLoyaltyRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.enrolled = false;
        message.fanBuilderSystemCustomerId = "";
        message.dashboardUrl = "";
        message.coupons = [];
        if (value !== undefined)
            reflectionMergePartial<GetCustomerFanBuilderLoyaltyRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCustomerFanBuilderLoyaltyRes): GetCustomerFanBuilderLoyaltyRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enrolled */ 1:
                    message.enrolled = reader.bool();
                    break;
                case /* string fan_builder_system_customer_id */ 2:
                    message.fanBuilderSystemCustomerId = reader.string();
                    break;
                case /* string dashboard_url */ 3:
                    message.dashboardUrl = reader.string();
                    break;
                case /* repeated rd.api.customer.FanBuilderLoyaltyCoupon coupons */ 4:
                    message.coupons.push(FanBuilderLoyaltyCoupon.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCustomerFanBuilderLoyaltyRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enrolled = 1; */
        if (message.enrolled !== false)
            writer.tag(1, WireType.Varint).bool(message.enrolled);
        /* string fan_builder_system_customer_id = 2; */
        if (message.fanBuilderSystemCustomerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.fanBuilderSystemCustomerId);
        /* string dashboard_url = 3; */
        if (message.dashboardUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.dashboardUrl);
        /* repeated rd.api.customer.FanBuilderLoyaltyCoupon coupons = 4; */
        for (let i = 0; i < message.coupons.length; i++)
            FanBuilderLoyaltyCoupon.internalBinaryWrite(message.coupons[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetCustomerFanBuilderLoyaltyRes
 */
export const GetCustomerFanBuilderLoyaltyRes = new GetCustomerFanBuilderLoyaltyRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FanBuilderLoyaltyCoupon$Type extends MessageType<FanBuilderLoyaltyCoupon> {
    constructor() {
        super("rd.api.customer.FanBuilderLoyaltyCoupon", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "customer_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "coupon_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "short_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "barcode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "expires", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "discount_type", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "num_uses", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "max_uses", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "date_issued", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "required_skus", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "minimum_purchase", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 14, name: "points_threshold", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<FanBuilderLoyaltyCoupon>): FanBuilderLoyaltyCoupon {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.customerId = 0;
        message.couponId = 0;
        message.shortDescription = "";
        message.barcode = "";
        message.expires = "";
        message.discountType = 0;
        message.amount = 0;
        message.numUses = 0;
        message.maxUses = 0;
        message.dateIssued = "";
        message.requiredSkus = "";
        message.minimumPurchase = 0;
        message.pointsThreshold = 0;
        if (value !== undefined)
            reflectionMergePartial<FanBuilderLoyaltyCoupon>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FanBuilderLoyaltyCoupon): FanBuilderLoyaltyCoupon {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 customer_id */ 2:
                    message.customerId = reader.int32();
                    break;
                case /* int32 coupon_id */ 3:
                    message.couponId = reader.int32();
                    break;
                case /* string short_description */ 4:
                    message.shortDescription = reader.string();
                    break;
                case /* string barcode */ 5:
                    message.barcode = reader.string();
                    break;
                case /* string expires */ 6:
                    message.expires = reader.string();
                    break;
                case /* int32 discount_type */ 7:
                    message.discountType = reader.int32();
                    break;
                case /* double amount */ 8:
                    message.amount = reader.double();
                    break;
                case /* int32 num_uses */ 9:
                    message.numUses = reader.int32();
                    break;
                case /* int32 max_uses */ 10:
                    message.maxUses = reader.int32();
                    break;
                case /* string date_issued */ 11:
                    message.dateIssued = reader.string();
                    break;
                case /* string required_skus */ 12:
                    message.requiredSkus = reader.string();
                    break;
                case /* double minimum_purchase */ 13:
                    message.minimumPurchase = reader.double();
                    break;
                case /* int32 points_threshold */ 14:
                    message.pointsThreshold = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FanBuilderLoyaltyCoupon, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 customer_id = 2; */
        if (message.customerId !== 0)
            writer.tag(2, WireType.Varint).int32(message.customerId);
        /* int32 coupon_id = 3; */
        if (message.couponId !== 0)
            writer.tag(3, WireType.Varint).int32(message.couponId);
        /* string short_description = 4; */
        if (message.shortDescription !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.shortDescription);
        /* string barcode = 5; */
        if (message.barcode !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.barcode);
        /* string expires = 6; */
        if (message.expires !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.expires);
        /* int32 discount_type = 7; */
        if (message.discountType !== 0)
            writer.tag(7, WireType.Varint).int32(message.discountType);
        /* double amount = 8; */
        if (message.amount !== 0)
            writer.tag(8, WireType.Bit64).double(message.amount);
        /* int32 num_uses = 9; */
        if (message.numUses !== 0)
            writer.tag(9, WireType.Varint).int32(message.numUses);
        /* int32 max_uses = 10; */
        if (message.maxUses !== 0)
            writer.tag(10, WireType.Varint).int32(message.maxUses);
        /* string date_issued = 11; */
        if (message.dateIssued !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.dateIssued);
        /* string required_skus = 12; */
        if (message.requiredSkus !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.requiredSkus);
        /* double minimum_purchase = 13; */
        if (message.minimumPurchase !== 0)
            writer.tag(13, WireType.Bit64).double(message.minimumPurchase);
        /* int32 points_threshold = 14; */
        if (message.pointsThreshold !== 0)
            writer.tag(14, WireType.Varint).int32(message.pointsThreshold);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.FanBuilderLoyaltyCoupon
 */
export const FanBuilderLoyaltyCoupon = new FanBuilderLoyaltyCoupon$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidateFanBuilderLoyaltyCouponReq$Type extends MessageType<ValidateFanBuilderLoyaltyCouponReq> {
    constructor() {
        super("rd.api.customer.ValidateFanBuilderLoyaltyCouponReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "system_store_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "terminal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 4, name: "coupon_barcodes", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 5, name: "cart_subtotal", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<ValidateFanBuilderLoyaltyCouponReq>): ValidateFanBuilderLoyaltyCouponReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.systemStoreId = "";
        message.terminalId = "";
        message.couponBarcodes = [];
        message.cartSubtotal = 0;
        if (value !== undefined)
            reflectionMergePartial<ValidateFanBuilderLoyaltyCouponReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ValidateFanBuilderLoyaltyCouponReq): ValidateFanBuilderLoyaltyCouponReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* string system_store_id */ 2:
                    message.systemStoreId = reader.string();
                    break;
                case /* string terminal_id */ 3:
                    message.terminalId = reader.string();
                    break;
                case /* repeated string coupon_barcodes */ 4:
                    message.couponBarcodes.push(reader.string());
                    break;
                case /* double cart_subtotal */ 5:
                    message.cartSubtotal = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ValidateFanBuilderLoyaltyCouponReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string system_store_id = 2; */
        if (message.systemStoreId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.systemStoreId);
        /* string terminal_id = 3; */
        if (message.terminalId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.terminalId);
        /* repeated string coupon_barcodes = 4; */
        for (let i = 0; i < message.couponBarcodes.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.couponBarcodes[i]);
        /* double cart_subtotal = 5; */
        if (message.cartSubtotal !== 0)
            writer.tag(5, WireType.Bit64).double(message.cartSubtotal);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.ValidateFanBuilderLoyaltyCouponReq
 */
export const ValidateFanBuilderLoyaltyCouponReq = new ValidateFanBuilderLoyaltyCouponReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidateFanBuilderLoyaltyCouponRes$Type extends MessageType<ValidateFanBuilderLoyaltyCouponRes> {
    constructor() {
        super("rd.api.customer.ValidateFanBuilderLoyaltyCouponRes", [
            { no: 1, name: "valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "coupons", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ValidatedFanBuilderLoyaltyCoupon }
        ]);
    }
    create(value?: PartialMessage<ValidateFanBuilderLoyaltyCouponRes>): ValidateFanBuilderLoyaltyCouponRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.valid = false;
        message.coupons = [];
        if (value !== undefined)
            reflectionMergePartial<ValidateFanBuilderLoyaltyCouponRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ValidateFanBuilderLoyaltyCouponRes): ValidateFanBuilderLoyaltyCouponRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool valid */ 1:
                    message.valid = reader.bool();
                    break;
                case /* repeated rd.api.customer.ValidatedFanBuilderLoyaltyCoupon coupons */ 2:
                    message.coupons.push(ValidatedFanBuilderLoyaltyCoupon.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ValidateFanBuilderLoyaltyCouponRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool valid = 1; */
        if (message.valid !== false)
            writer.tag(1, WireType.Varint).bool(message.valid);
        /* repeated rd.api.customer.ValidatedFanBuilderLoyaltyCoupon coupons = 2; */
        for (let i = 0; i < message.coupons.length; i++)
            ValidatedFanBuilderLoyaltyCoupon.internalBinaryWrite(message.coupons[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.ValidateFanBuilderLoyaltyCouponRes
 */
export const ValidateFanBuilderLoyaltyCouponRes = new ValidateFanBuilderLoyaltyCouponRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidatedFanBuilderLoyaltyCoupon$Type extends MessageType<ValidatedFanBuilderLoyaltyCoupon> {
    constructor() {
        super("rd.api.customer.ValidatedFanBuilderLoyaltyCoupon", [
            { no: 1, name: "coupon_barcode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "discount_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "discount_type", kind: "enum", T: () => ["rd.api.customer.ValidatedFanBuilderLoyaltyCoupon.DiscountType", ValidatedFanBuilderLoyaltyCoupon_DiscountType, "DISCOUNT_TYPE_"] },
            { no: 7, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<ValidatedFanBuilderLoyaltyCoupon>): ValidatedFanBuilderLoyaltyCoupon {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.couponBarcode = "";
        message.valid = false;
        message.description = "";
        message.discountAmount = 0;
        message.message = "";
        message.discountType = 0;
        message.amount = 0;
        if (value !== undefined)
            reflectionMergePartial<ValidatedFanBuilderLoyaltyCoupon>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ValidatedFanBuilderLoyaltyCoupon): ValidatedFanBuilderLoyaltyCoupon {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string coupon_barcode */ 1:
                    message.couponBarcode = reader.string();
                    break;
                case /* bool valid */ 2:
                    message.valid = reader.bool();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* double discount_amount */ 4:
                    message.discountAmount = reader.double();
                    break;
                case /* string message */ 5:
                    message.message = reader.string();
                    break;
                case /* rd.api.customer.ValidatedFanBuilderLoyaltyCoupon.DiscountType discount_type */ 6:
                    message.discountType = reader.int32();
                    break;
                case /* double amount */ 7:
                    message.amount = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ValidatedFanBuilderLoyaltyCoupon, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string coupon_barcode = 1; */
        if (message.couponBarcode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.couponBarcode);
        /* bool valid = 2; */
        if (message.valid !== false)
            writer.tag(2, WireType.Varint).bool(message.valid);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* double discount_amount = 4; */
        if (message.discountAmount !== 0)
            writer.tag(4, WireType.Bit64).double(message.discountAmount);
        /* string message = 5; */
        if (message.message !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.message);
        /* rd.api.customer.ValidatedFanBuilderLoyaltyCoupon.DiscountType discount_type = 6; */
        if (message.discountType !== 0)
            writer.tag(6, WireType.Varint).int32(message.discountType);
        /* double amount = 7; */
        if (message.amount !== 0)
            writer.tag(7, WireType.Bit64).double(message.amount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.ValidatedFanBuilderLoyaltyCoupon
 */
export const ValidatedFanBuilderLoyaltyCoupon = new ValidatedFanBuilderLoyaltyCoupon$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldRequireJobReq$Type extends MessageType<UpdateCustomerShouldRequireJobReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldRequireJobReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "should_require_job", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerShouldRequireJobReq>): UpdateCustomerShouldRequireJobReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldRequireJob = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldRequireJobReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldRequireJobReq): UpdateCustomerShouldRequireJobReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool should_require_job */ 2:
                    message.shouldRequireJob = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldRequireJobReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool should_require_job = 2; */
        if (message.shouldRequireJob !== false)
            writer.tag(2, WireType.Varint).bool(message.shouldRequireJob);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldRequireJobReq
 */
export const UpdateCustomerShouldRequireJobReq = new UpdateCustomerShouldRequireJobReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldRequireJobRes$Type extends MessageType<UpdateCustomerShouldRequireJobRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldRequireJobRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerShouldRequireJobRes>): UpdateCustomerShouldRequireJobRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldRequireJobRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldRequireJobRes): UpdateCustomerShouldRequireJobRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldRequireJobRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldRequireJobRes
 */
export const UpdateCustomerShouldRequireJobRes = new UpdateCustomerShouldRequireJobRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerStatementInvoicesFormatReq$Type extends MessageType<UpdateCustomerStatementInvoicesFormatReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerStatementInvoicesFormatReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "statement_invoices_format", kind: "enum", T: () => ["rd.customer.Customer.StatementInvoicesFormatType", Customer_StatementInvoicesFormatType, "STATEMENT_INVOICES_FORMAT_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerStatementInvoicesFormatReq>): UpdateCustomerStatementInvoicesFormatReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.statementInvoicesFormat = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerStatementInvoicesFormatReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerStatementInvoicesFormatReq): UpdateCustomerStatementInvoicesFormatReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.customer.Customer.StatementInvoicesFormatType statement_invoices_format */ 2:
                    message.statementInvoicesFormat = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerStatementInvoicesFormatReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Customer.StatementInvoicesFormatType statement_invoices_format = 2; */
        if (message.statementInvoicesFormat !== 0)
            writer.tag(2, WireType.Varint).int32(message.statementInvoicesFormat);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerStatementInvoicesFormatReq
 */
export const UpdateCustomerStatementInvoicesFormatReq = new UpdateCustomerStatementInvoicesFormatReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerStatementInvoicesFormatRes$Type extends MessageType<UpdateCustomerStatementInvoicesFormatRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerStatementInvoicesFormatRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerStatementInvoicesFormatRes>): UpdateCustomerStatementInvoicesFormatRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerStatementInvoicesFormatRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerStatementInvoicesFormatRes): UpdateCustomerStatementInvoicesFormatRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerStatementInvoicesFormatRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerStatementInvoicesFormatRes
 */
export const UpdateCustomerStatementInvoicesFormatRes = new UpdateCustomerStatementInvoicesFormatRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldHidePricesOnInvoicesReq$Type extends MessageType<UpdateCustomerShouldHidePricesOnInvoicesReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldHidePricesOnInvoicesReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "should_hide_prices_on_invoices", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerShouldHidePricesOnInvoicesReq>): UpdateCustomerShouldHidePricesOnInvoicesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldHidePricesOnInvoices = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldHidePricesOnInvoicesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldHidePricesOnInvoicesReq): UpdateCustomerShouldHidePricesOnInvoicesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool should_hide_prices_on_invoices */ 2:
                    message.shouldHidePricesOnInvoices = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldHidePricesOnInvoicesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool should_hide_prices_on_invoices = 2; */
        if (message.shouldHidePricesOnInvoices !== false)
            writer.tag(2, WireType.Varint).bool(message.shouldHidePricesOnInvoices);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldHidePricesOnInvoicesReq
 */
export const UpdateCustomerShouldHidePricesOnInvoicesReq = new UpdateCustomerShouldHidePricesOnInvoicesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldHidePricesOnInvoicesRes$Type extends MessageType<UpdateCustomerShouldHidePricesOnInvoicesRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldHidePricesOnInvoicesRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerShouldHidePricesOnInvoicesRes>): UpdateCustomerShouldHidePricesOnInvoicesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldHidePricesOnInvoicesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldHidePricesOnInvoicesRes): UpdateCustomerShouldHidePricesOnInvoicesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldHidePricesOnInvoicesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldHidePricesOnInvoicesRes
 */
export const UpdateCustomerShouldHidePricesOnInvoicesRes = new UpdateCustomerShouldHidePricesOnInvoicesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerStatementTypeReq$Type extends MessageType<UpdateCustomerStatementTypeReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerStatementTypeReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "statement_type", kind: "enum", T: () => ["rd.customer.Customer.StatementType", Customer_StatementType, "STATEMENT_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerStatementTypeReq>): UpdateCustomerStatementTypeReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.statementType = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerStatementTypeReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerStatementTypeReq): UpdateCustomerStatementTypeReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.customer.Customer.StatementType statement_type */ 2:
                    message.statementType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerStatementTypeReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Customer.StatementType statement_type = 2; */
        if (message.statementType !== 0)
            writer.tag(2, WireType.Varint).int32(message.statementType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerStatementTypeReq
 */
export const UpdateCustomerStatementTypeReq = new UpdateCustomerStatementTypeReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerStatementTypeRes$Type extends MessageType<UpdateCustomerStatementTypeRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerStatementTypeRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerStatementTypeRes>): UpdateCustomerStatementTypeRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerStatementTypeRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerStatementTypeRes): UpdateCustomerStatementTypeRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerStatementTypeRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerStatementTypeRes
 */
export const UpdateCustomerStatementTypeRes = new UpdateCustomerStatementTypeRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerTypeReq$Type extends MessageType<UpdateCustomerTypeReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerTypeReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "type", kind: "enum", T: () => ["rd.customer.Customer.Type", Customer_Type, "TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerTypeReq>): UpdateCustomerTypeReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerTypeReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerTypeReq): UpdateCustomerTypeReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.customer.Customer.Type type */ 2:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerTypeReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Customer.Type type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerTypeReq
 */
export const UpdateCustomerTypeReq = new UpdateCustomerTypeReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerTypeRes$Type extends MessageType<UpdateCustomerTypeRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerTypeRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerTypeRes>): UpdateCustomerTypeRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerTypeRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerTypeRes): UpdateCustomerTypeRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerTypeRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerTypeRes
 */
export const UpdateCustomerTypeRes = new UpdateCustomerTypeRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerIsCardSurchargeExemptReq$Type extends MessageType<UpdateCustomerIsCardSurchargeExemptReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerIsCardSurchargeExemptReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "is_card_surcharge_exempt", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerIsCardSurchargeExemptReq>): UpdateCustomerIsCardSurchargeExemptReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isCardSurchargeExempt = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerIsCardSurchargeExemptReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerIsCardSurchargeExemptReq): UpdateCustomerIsCardSurchargeExemptReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool is_card_surcharge_exempt */ 2:
                    message.isCardSurchargeExempt = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerIsCardSurchargeExemptReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool is_card_surcharge_exempt = 2; */
        if (message.isCardSurchargeExempt !== false)
            writer.tag(2, WireType.Varint).bool(message.isCardSurchargeExempt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerIsCardSurchargeExemptReq
 */
export const UpdateCustomerIsCardSurchargeExemptReq = new UpdateCustomerIsCardSurchargeExemptReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerIsCardSurchargeExemptRes$Type extends MessageType<UpdateCustomerIsCardSurchargeExemptRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerIsCardSurchargeExemptRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerIsCardSurchargeExemptRes>): UpdateCustomerIsCardSurchargeExemptRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerIsCardSurchargeExemptRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerIsCardSurchargeExemptRes): UpdateCustomerIsCardSurchargeExemptRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerIsCardSurchargeExemptRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerIsCardSurchargeExemptRes
 */
export const UpdateCustomerIsCardSurchargeExemptRes = new UpdateCustomerIsCardSurchargeExemptRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MergeCustomersReq$Type extends MessageType<MergeCustomersReq> {
    constructor() {
        super("rd.api.customer.MergeCustomersReq", [
            { no: 1, name: "source_customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "target_customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<MergeCustomersReq>): MergeCustomersReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<MergeCustomersReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MergeCustomersReq): MergeCustomersReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID source_customer_id */ 1:
                    message.sourceCustomerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.sourceCustomerId);
                    break;
                case /* rd.proto.uuid.UUID target_customer_id */ 2:
                    message.targetCustomerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.targetCustomerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MergeCustomersReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID source_customer_id = 1; */
        if (message.sourceCustomerId)
            UUID.internalBinaryWrite(message.sourceCustomerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID target_customer_id = 2; */
        if (message.targetCustomerId)
            UUID.internalBinaryWrite(message.targetCustomerId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.MergeCustomersReq
 */
export const MergeCustomersReq = new MergeCustomersReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MergeCustomersRes$Type extends MessageType<MergeCustomersRes> {
    constructor() {
        super("rd.api.customer.MergeCustomersRes", []);
    }
    create(value?: PartialMessage<MergeCustomersRes>): MergeCustomersRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<MergeCustomersRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MergeCustomersRes): MergeCustomersRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MergeCustomersRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.MergeCustomersRes
 */
export const MergeCustomersRes = new MergeCustomersRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLastStatementRunReq$Type extends MessageType<GetLastStatementRunReq> {
    constructor() {
        super("rd.api.customer.GetLastStatementRunReq", []);
    }
    create(value?: PartialMessage<GetLastStatementRunReq>): GetLastStatementRunReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetLastStatementRunReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLastStatementRunReq): GetLastStatementRunReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLastStatementRunReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetLastStatementRunReq
 */
export const GetLastStatementRunReq = new GetLastStatementRunReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLastStatementRunRes$Type extends MessageType<GetLastStatementRunRes> {
    constructor() {
        super("rd.api.customer.GetLastStatementRunRes", [
            { no: 1, name: "statement", kind: "message", T: () => StatementRun },
            { no: 5, name: "num_customers_to_mail", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "num_customers_with_contacts_to_email", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "num_customer_contacts_to_email", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "emailed_download_urls", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "mailed_download_urls", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetLastStatementRunRes>): GetLastStatementRunRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.numCustomersToMail = 0;
        message.numCustomersWithContactsToEmail = 0;
        message.numCustomerContactsToEmail = 0;
        message.emailedDownloadUrls = [];
        message.mailedDownloadUrls = [];
        if (value !== undefined)
            reflectionMergePartial<GetLastStatementRunRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLastStatementRunRes): GetLastStatementRunRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.statement.StatementRun statement */ 1:
                    message.statement = StatementRun.internalBinaryRead(reader, reader.uint32(), options, message.statement);
                    break;
                case /* int32 num_customers_to_mail */ 5:
                    message.numCustomersToMail = reader.int32();
                    break;
                case /* int32 num_customers_with_contacts_to_email */ 6:
                    message.numCustomersWithContactsToEmail = reader.int32();
                    break;
                case /* int32 num_customer_contacts_to_email */ 7:
                    message.numCustomerContactsToEmail = reader.int32();
                    break;
                case /* repeated string emailed_download_urls */ 8:
                    message.emailedDownloadUrls.push(reader.string());
                    break;
                case /* repeated string mailed_download_urls */ 9:
                    message.mailedDownloadUrls.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLastStatementRunRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.statement.StatementRun statement = 1; */
        if (message.statement)
            StatementRun.internalBinaryWrite(message.statement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 num_customers_to_mail = 5; */
        if (message.numCustomersToMail !== 0)
            writer.tag(5, WireType.Varint).int32(message.numCustomersToMail);
        /* int32 num_customers_with_contacts_to_email = 6; */
        if (message.numCustomersWithContactsToEmail !== 0)
            writer.tag(6, WireType.Varint).int32(message.numCustomersWithContactsToEmail);
        /* int32 num_customer_contacts_to_email = 7; */
        if (message.numCustomerContactsToEmail !== 0)
            writer.tag(7, WireType.Varint).int32(message.numCustomerContactsToEmail);
        /* repeated string emailed_download_urls = 8; */
        for (let i = 0; i < message.emailedDownloadUrls.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.emailedDownloadUrls[i]);
        /* repeated string mailed_download_urls = 9; */
        for (let i = 0; i < message.mailedDownloadUrls.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.mailedDownloadUrls[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetLastStatementRunRes
 */
export const GetLastStatementRunRes = new GetLastStatementRunRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MailBulkStatementRunReq$Type extends MessageType<MailBulkStatementRunReq> {
    constructor() {
        super("rd.api.customer.MailBulkStatementRunReq", [
            { no: 1, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 2, name: "statement_run_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 3, name: "is_preview", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<MailBulkStatementRunReq>): MailBulkStatementRunReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.customerIds = [];
        message.isPreview = false;
        if (value !== undefined)
            reflectionMergePartial<MailBulkStatementRunReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MailBulkStatementRunReq): MailBulkStatementRunReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.proto.uuid.UUID customer_ids */ 1:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.uuid.UUID statement_run_id */ 2:
                    message.statementRunId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.statementRunId);
                    break;
                case /* bool is_preview */ 3:
                    message.isPreview = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MailBulkStatementRunReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.proto.uuid.UUID customer_ids = 1; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID statement_run_id = 2; */
        if (message.statementRunId)
            UUID.internalBinaryWrite(message.statementRunId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool is_preview = 3; */
        if (message.isPreview !== false)
            writer.tag(3, WireType.Varint).bool(message.isPreview);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.MailBulkStatementRunReq
 */
export const MailBulkStatementRunReq = new MailBulkStatementRunReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MailBulkStatementRunRes$Type extends MessageType<MailBulkStatementRunRes> {
    constructor() {
        super("rd.api.customer.MailBulkStatementRunRes", [
            { no: 1, name: "pdf_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<MailBulkStatementRunRes>): MailBulkStatementRunRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pdfBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<MailBulkStatementRunRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MailBulkStatementRunRes): MailBulkStatementRunRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes pdf_bytes */ 1:
                    message.pdfBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MailBulkStatementRunRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes pdf_bytes = 1; */
        if (message.pdfBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.pdfBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.MailBulkStatementRunRes
 */
export const MailBulkStatementRunRes = new MailBulkStatementRunRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListStatementsForCustomerReq$Type extends MessageType<ListStatementsForCustomerReq> {
    constructor() {
        super("rd.api.customer.ListStatementsForCustomerReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ListStatementsForCustomerReq>): ListStatementsForCustomerReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListStatementsForCustomerReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListStatementsForCustomerReq): ListStatementsForCustomerReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListStatementsForCustomerReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.ListStatementsForCustomerReq
 */
export const ListStatementsForCustomerReq = new ListStatementsForCustomerReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListStatementsForCustomerRes$Type extends MessageType<ListStatementsForCustomerRes> {
    constructor() {
        super("rd.api.customer.ListStatementsForCustomerRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ListStatementsForCustomerRes_Result }
        ]);
    }
    create(value?: PartialMessage<ListStatementsForCustomerRes>): ListStatementsForCustomerRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        if (value !== undefined)
            reflectionMergePartial<ListStatementsForCustomerRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListStatementsForCustomerRes): ListStatementsForCustomerRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.api.customer.ListStatementsForCustomerRes.Result results */ 1:
                    message.results.push(ListStatementsForCustomerRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListStatementsForCustomerRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.api.customer.ListStatementsForCustomerRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ListStatementsForCustomerRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.ListStatementsForCustomerRes
 */
export const ListStatementsForCustomerRes = new ListStatementsForCustomerRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListStatementsForCustomerRes_Result$Type extends MessageType<ListStatementsForCustomerRes_Result> {
    constructor() {
        super("rd.api.customer.ListStatementsForCustomerRes.Result", [
            { no: 1, name: "statement", kind: "message", T: () => Statement },
            { no: 2, name: "statement_run_created_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<ListStatementsForCustomerRes_Result>): ListStatementsForCustomerRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListStatementsForCustomerRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListStatementsForCustomerRes_Result): ListStatementsForCustomerRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.statement.Statement statement */ 1:
                    message.statement = Statement.internalBinaryRead(reader, reader.uint32(), options, message.statement);
                    break;
                case /* google.protobuf.Timestamp statement_run_created_at */ 2:
                    message.statementRunCreatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.statementRunCreatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListStatementsForCustomerRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.statement.Statement statement = 1; */
        if (message.statement)
            Statement.internalBinaryWrite(message.statement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp statement_run_created_at = 2; */
        if (message.statementRunCreatedAt)
            Timestamp.internalBinaryWrite(message.statementRunCreatedAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.ListStatementsForCustomerRes.Result
 */
export const ListStatementsForCustomerRes_Result = new ListStatementsForCustomerRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailCustomerStatementPDFReq$Type extends MessageType<EmailCustomerStatementPDFReq> {
    constructor() {
        super("rd.api.customer.EmailCustomerStatementPDFReq", [
            { no: 2, name: "customer_contact_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "additional_emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 5, name: "statement_run_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<EmailCustomerStatementPDFReq>): EmailCustomerStatementPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.customerContactIdStrings = [];
        message.additionalEmails = [];
        if (value !== undefined)
            reflectionMergePartial<EmailCustomerStatementPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailCustomerStatementPDFReq): EmailCustomerStatementPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string customer_contact_id_strings */ 2:
                    message.customerContactIdStrings.push(reader.string());
                    break;
                case /* repeated string additional_emails */ 3:
                    message.additionalEmails.push(reader.string());
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 4:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.uuid.UUID statement_run_id */ 5:
                    message.statementRunId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.statementRunId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailCustomerStatementPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string customer_contact_id_strings = 2; */
        for (let i = 0; i < message.customerContactIdStrings.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.customerContactIdStrings[i]);
        /* repeated string additional_emails = 3; */
        for (let i = 0; i < message.additionalEmails.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.additionalEmails[i]);
        /* rd.proto.uuid.UUID customer_id = 4; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID statement_run_id = 5; */
        if (message.statementRunId)
            UUID.internalBinaryWrite(message.statementRunId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.EmailCustomerStatementPDFReq
 */
export const EmailCustomerStatementPDFReq = new EmailCustomerStatementPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailCustomerStatementPDFRes$Type extends MessageType<EmailCustomerStatementPDFRes> {
    constructor() {
        super("rd.api.customer.EmailCustomerStatementPDFRes", []);
    }
    create(value?: PartialMessage<EmailCustomerStatementPDFRes>): EmailCustomerStatementPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EmailCustomerStatementPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailCustomerStatementPDFRes): EmailCustomerStatementPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailCustomerStatementPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.EmailCustomerStatementPDFRes
 */
export const EmailCustomerStatementPDFRes = new EmailCustomerStatementPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailStatementRunReq$Type extends MessageType<EmailStatementRunReq> {
    constructor() {
        super("rd.api.customer.EmailStatementRunReq", [
            { no: 1, name: "statement_run_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<EmailStatementRunReq>): EmailStatementRunReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.customerIds = [];
        if (value !== undefined)
            reflectionMergePartial<EmailStatementRunReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailStatementRunReq): EmailStatementRunReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID statement_run_id */ 1:
                    message.statementRunId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.statementRunId);
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 2:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailStatementRunReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID statement_run_id = 1; */
        if (message.statementRunId)
            UUID.internalBinaryWrite(message.statementRunId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID customer_ids = 2; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.EmailStatementRunReq
 */
export const EmailStatementRunReq = new EmailStatementRunReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailStatementRunRes$Type extends MessageType<EmailStatementRunRes> {
    constructor() {
        super("rd.api.customer.EmailStatementRunRes", []);
    }
    create(value?: PartialMessage<EmailStatementRunRes>): EmailStatementRunRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EmailStatementRunRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailStatementRunRes): EmailStatementRunRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailStatementRunRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.EmailStatementRunRes
 */
export const EmailStatementRunRes = new EmailStatementRunRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStatementRunReq$Type extends MessageType<GetStatementRunReq> {
    constructor() {
        super("rd.api.customer.GetStatementRunReq", [
            { no: 1, name: "statement_run_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetStatementRunReq>): GetStatementRunReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetStatementRunReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetStatementRunReq): GetStatementRunReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID statement_run_id */ 1:
                    message.statementRunId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.statementRunId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetStatementRunReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID statement_run_id = 1; */
        if (message.statementRunId)
            UUID.internalBinaryWrite(message.statementRunId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetStatementRunReq
 */
export const GetStatementRunReq = new GetStatementRunReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStatementRunRes$Type extends MessageType<GetStatementRunRes> {
    constructor() {
        super("rd.api.customer.GetStatementRunRes", [
            { no: 1, name: "statement_run", kind: "message", T: () => StatementRun }
        ]);
    }
    create(value?: PartialMessage<GetStatementRunRes>): GetStatementRunRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetStatementRunRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetStatementRunRes): GetStatementRunRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.statement.StatementRun statement_run */ 1:
                    message.statementRun = StatementRun.internalBinaryRead(reader, reader.uint32(), options, message.statementRun);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetStatementRunRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.statement.StatementRun statement_run = 1; */
        if (message.statementRun)
            StatementRun.internalBinaryWrite(message.statementRun, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetStatementRunRes
 */
export const GetStatementRunRes = new GetStatementRunRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStatementRunStatsReq$Type extends MessageType<GetStatementRunStatsReq> {
    constructor() {
        super("rd.api.customer.GetStatementRunStatsReq", [
            { no: 1, name: "statement_run_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetStatementRunStatsReq>): GetStatementRunStatsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetStatementRunStatsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetStatementRunStatsReq): GetStatementRunStatsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID statement_run_id */ 1:
                    message.statementRunId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.statementRunId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetStatementRunStatsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID statement_run_id = 1; */
        if (message.statementRunId)
            UUID.internalBinaryWrite(message.statementRunId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetStatementRunStatsReq
 */
export const GetStatementRunStatsReq = new GetStatementRunStatsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStatementRunStatsRes$Type extends MessageType<GetStatementRunStatsRes> {
    constructor() {
        super("rd.api.customer.GetStatementRunStatsRes", [
            { no: 1, name: "generated_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "mailed_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "emailed_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "sent_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "generated_count_v2", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "completed_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "error_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "initiated_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetStatementRunStatsRes>): GetStatementRunStatsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.generatedCount = 0;
        message.mailedCount = 0;
        message.emailedCount = 0;
        message.sentCount = 0;
        message.generatedCountV2 = 0;
        message.completedCount = 0;
        message.errorCount = 0;
        message.initiatedCount = 0;
        if (value !== undefined)
            reflectionMergePartial<GetStatementRunStatsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetStatementRunStatsRes): GetStatementRunStatsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 generated_count */ 1:
                    message.generatedCount = reader.int32();
                    break;
                case /* int32 mailed_count */ 2:
                    message.mailedCount = reader.int32();
                    break;
                case /* int32 emailed_count */ 3:
                    message.emailedCount = reader.int32();
                    break;
                case /* int32 sent_count */ 4:
                    message.sentCount = reader.int32();
                    break;
                case /* int32 generated_count_v2 */ 5:
                    message.generatedCountV2 = reader.int32();
                    break;
                case /* int32 completed_count */ 6:
                    message.completedCount = reader.int32();
                    break;
                case /* int32 error_count */ 7:
                    message.errorCount = reader.int32();
                    break;
                case /* int32 initiated_count */ 8:
                    message.initiatedCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetStatementRunStatsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 generated_count = 1; */
        if (message.generatedCount !== 0)
            writer.tag(1, WireType.Varint).int32(message.generatedCount);
        /* int32 mailed_count = 2; */
        if (message.mailedCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.mailedCount);
        /* int32 emailed_count = 3; */
        if (message.emailedCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.emailedCount);
        /* int32 sent_count = 4; */
        if (message.sentCount !== 0)
            writer.tag(4, WireType.Varint).int32(message.sentCount);
        /* int32 generated_count_v2 = 5; */
        if (message.generatedCountV2 !== 0)
            writer.tag(5, WireType.Varint).int32(message.generatedCountV2);
        /* int32 completed_count = 6; */
        if (message.completedCount !== 0)
            writer.tag(6, WireType.Varint).int32(message.completedCount);
        /* int32 error_count = 7; */
        if (message.errorCount !== 0)
            writer.tag(7, WireType.Varint).int32(message.errorCount);
        /* int32 initiated_count = 8; */
        if (message.initiatedCount !== 0)
            writer.tag(8, WireType.Varint).int32(message.initiatedCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetStatementRunStatsRes
 */
export const GetStatementRunStatsRes = new GetStatementRunStatsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailAllInStatementRunReq$Type extends MessageType<EmailAllInStatementRunReq> {
    constructor() {
        super("rd.api.customer.EmailAllInStatementRunReq", [
            { no: 1, name: "financing_term_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pricing_tier_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "rep_staff_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 4, name: "finance_charge_setting_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 5, name: "tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "statement_run_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 7, name: "email_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<EmailAllInStatementRunReq>): EmailAllInStatementRunReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.financingTermIdStrings = [];
        message.pricingTierIdStrings = [];
        message.repStaffIds = [];
        message.financeChargeSettingIds = [];
        message.tagIds = [];
        message.emailOnly = false;
        if (value !== undefined)
            reflectionMergePartial<EmailAllInStatementRunReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailAllInStatementRunReq): EmailAllInStatementRunReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string financing_term_id_strings */ 1:
                    message.financingTermIdStrings.push(reader.string());
                    break;
                case /* repeated string pricing_tier_id_strings */ 2:
                    message.pricingTierIdStrings.push(reader.string());
                    break;
                case /* repeated rd.proto.uuid.UUID rep_staff_ids */ 3:
                    message.repStaffIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID finance_charge_setting_ids */ 4:
                    message.financeChargeSettingIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID tag_ids */ 5:
                    message.tagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.uuid.UUID statement_run_id */ 6:
                    message.statementRunId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.statementRunId);
                    break;
                case /* bool email_only */ 7:
                    message.emailOnly = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailAllInStatementRunReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string financing_term_id_strings = 1; */
        for (let i = 0; i < message.financingTermIdStrings.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.financingTermIdStrings[i]);
        /* repeated string pricing_tier_id_strings = 2; */
        for (let i = 0; i < message.pricingTierIdStrings.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.pricingTierIdStrings[i]);
        /* repeated rd.proto.uuid.UUID rep_staff_ids = 3; */
        for (let i = 0; i < message.repStaffIds.length; i++)
            UUID.internalBinaryWrite(message.repStaffIds[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID finance_charge_setting_ids = 4; */
        for (let i = 0; i < message.financeChargeSettingIds.length; i++)
            UUID.internalBinaryWrite(message.financeChargeSettingIds[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID tag_ids = 5; */
        for (let i = 0; i < message.tagIds.length; i++)
            UUID.internalBinaryWrite(message.tagIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID statement_run_id = 6; */
        if (message.statementRunId)
            UUID.internalBinaryWrite(message.statementRunId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bool email_only = 7; */
        if (message.emailOnly !== false)
            writer.tag(7, WireType.Varint).bool(message.emailOnly);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.EmailAllInStatementRunReq
 */
export const EmailAllInStatementRunReq = new EmailAllInStatementRunReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailAllInStatementRunRes$Type extends MessageType<EmailAllInStatementRunRes> {
    constructor() {
        super("rd.api.customer.EmailAllInStatementRunRes", []);
    }
    create(value?: PartialMessage<EmailAllInStatementRunRes>): EmailAllInStatementRunRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EmailAllInStatementRunRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailAllInStatementRunRes): EmailAllInStatementRunRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailAllInStatementRunRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.EmailAllInStatementRunRes
 */
export const EmailAllInStatementRunRes = new EmailAllInStatementRunRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateStatementRunPdfsReq$Type extends MessageType<GenerateStatementRunPdfsReq> {
    constructor() {
        super("rd.api.customer.GenerateStatementRunPdfsReq", [
            { no: 1, name: "statement_run_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "is_all_selected", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 4, name: "financing_term_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "pricing_tier_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "rep_staff_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 7, name: "finance_charge_setting_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 8, name: "tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 9, name: "email_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "mail_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "is_preview", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GenerateStatementRunPdfsReq>): GenerateStatementRunPdfsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isAllSelected = false;
        message.customerIds = [];
        message.financingTermIdStrings = [];
        message.pricingTierIdStrings = [];
        message.repStaffIds = [];
        message.financeChargeSettingIds = [];
        message.tagIds = [];
        message.emailOnly = false;
        message.mailOnly = false;
        message.isPreview = false;
        if (value !== undefined)
            reflectionMergePartial<GenerateStatementRunPdfsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateStatementRunPdfsReq): GenerateStatementRunPdfsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID statement_run_id */ 1:
                    message.statementRunId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.statementRunId);
                    break;
                case /* bool is_all_selected */ 2:
                    message.isAllSelected = reader.bool();
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 3:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string financing_term_id_strings */ 4:
                    message.financingTermIdStrings.push(reader.string());
                    break;
                case /* repeated string pricing_tier_id_strings */ 5:
                    message.pricingTierIdStrings.push(reader.string());
                    break;
                case /* repeated rd.proto.uuid.UUID rep_staff_ids */ 6:
                    message.repStaffIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID finance_charge_setting_ids */ 7:
                    message.financeChargeSettingIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID tag_ids */ 8:
                    message.tagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool email_only */ 9:
                    message.emailOnly = reader.bool();
                    break;
                case /* bool mail_only */ 10:
                    message.mailOnly = reader.bool();
                    break;
                case /* bool is_preview */ 11:
                    message.isPreview = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateStatementRunPdfsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID statement_run_id = 1; */
        if (message.statementRunId)
            UUID.internalBinaryWrite(message.statementRunId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool is_all_selected = 2; */
        if (message.isAllSelected !== false)
            writer.tag(2, WireType.Varint).bool(message.isAllSelected);
        /* repeated rd.proto.uuid.UUID customer_ids = 3; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated string financing_term_id_strings = 4; */
        for (let i = 0; i < message.financingTermIdStrings.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.financingTermIdStrings[i]);
        /* repeated string pricing_tier_id_strings = 5; */
        for (let i = 0; i < message.pricingTierIdStrings.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.pricingTierIdStrings[i]);
        /* repeated rd.proto.uuid.UUID rep_staff_ids = 6; */
        for (let i = 0; i < message.repStaffIds.length; i++)
            UUID.internalBinaryWrite(message.repStaffIds[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID finance_charge_setting_ids = 7; */
        for (let i = 0; i < message.financeChargeSettingIds.length; i++)
            UUID.internalBinaryWrite(message.financeChargeSettingIds[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID tag_ids = 8; */
        for (let i = 0; i < message.tagIds.length; i++)
            UUID.internalBinaryWrite(message.tagIds[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* bool email_only = 9; */
        if (message.emailOnly !== false)
            writer.tag(9, WireType.Varint).bool(message.emailOnly);
        /* bool mail_only = 10; */
        if (message.mailOnly !== false)
            writer.tag(10, WireType.Varint).bool(message.mailOnly);
        /* bool is_preview = 11; */
        if (message.isPreview !== false)
            writer.tag(11, WireType.Varint).bool(message.isPreview);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GenerateStatementRunPdfsReq
 */
export const GenerateStatementRunPdfsReq = new GenerateStatementRunPdfsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateStatementRunPdfsRes$Type extends MessageType<GenerateStatementRunPdfsRes> {
    constructor() {
        super("rd.api.customer.GenerateStatementRunPdfsRes", [
            { no: 1, name: "pdf_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GenerateStatementRunPdfsRes>): GenerateStatementRunPdfsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pdfUrl = "";
        if (value !== undefined)
            reflectionMergePartial<GenerateStatementRunPdfsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateStatementRunPdfsRes): GenerateStatementRunPdfsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string pdf_url */ 1:
                    message.pdfUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateStatementRunPdfsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string pdf_url = 1; */
        if (message.pdfUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.pdfUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GenerateStatementRunPdfsRes
 */
export const GenerateStatementRunPdfsRes = new GenerateStatementRunPdfsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLastStatementRunIdReq$Type extends MessageType<GetLastStatementRunIdReq> {
    constructor() {
        super("rd.api.customer.GetLastStatementRunIdReq", []);
    }
    create(value?: PartialMessage<GetLastStatementRunIdReq>): GetLastStatementRunIdReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetLastStatementRunIdReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLastStatementRunIdReq): GetLastStatementRunIdReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLastStatementRunIdReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetLastStatementRunIdReq
 */
export const GetLastStatementRunIdReq = new GetLastStatementRunIdReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLastStatementRunIdRes$Type extends MessageType<GetLastStatementRunIdRes> {
    constructor() {
        super("rd.api.customer.GetLastStatementRunIdRes", [
            { no: 1, name: "statement_run_id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<GetLastStatementRunIdRes>): GetLastStatementRunIdRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetLastStatementRunIdRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLastStatementRunIdRes): GetLastStatementRunIdRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID statement_run_id */ 1:
                    message.statementRunId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.statementRunId);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLastStatementRunIdRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID statement_run_id = 1; */
        if (message.statementRunId)
            UUID.internalBinaryWrite(message.statementRunId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetLastStatementRunIdRes
 */
export const GetLastStatementRunIdRes = new GetLastStatementRunIdRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLastStatementRunSendStatsReq$Type extends MessageType<GetLastStatementRunSendStatsReq> {
    constructor() {
        super("rd.api.customer.GetLastStatementRunSendStatsReq", []);
    }
    create(value?: PartialMessage<GetLastStatementRunSendStatsReq>): GetLastStatementRunSendStatsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetLastStatementRunSendStatsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLastStatementRunSendStatsReq): GetLastStatementRunSendStatsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLastStatementRunSendStatsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetLastStatementRunSendStatsReq
 */
export const GetLastStatementRunSendStatsReq = new GetLastStatementRunSendStatsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLastStatementRunSendStatsRes$Type extends MessageType<GetLastStatementRunSendStatsRes> {
    constructor() {
        super("rd.api.customer.GetLastStatementRunSendStatsRes", [
            { no: 1, name: "num_customers_to_mail", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "num_customers_with_contacts_to_email", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "num_customer_contacts_to_email", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "statement_run_id", kind: "message", T: () => UUID },
            { no: 5, name: "mail_customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "email_customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 7, name: "statement_period", kind: "message", T: () => TimestampRange },
            { no: 8, name: "num_customers_mailed", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "num_customers_emailed", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "num_statements", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "num_statements_sent", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "num_errors", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "num_initiated", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetLastStatementRunSendStatsRes>): GetLastStatementRunSendStatsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.numCustomersToMail = 0;
        message.numCustomersWithContactsToEmail = 0;
        message.numCustomerContactsToEmail = 0;
        message.mailCustomerIds = [];
        message.emailCustomerIds = [];
        message.numCustomersMailed = 0;
        message.numCustomersEmailed = 0;
        message.numStatements = 0;
        message.numStatementsSent = 0;
        message.numErrors = 0;
        message.numInitiated = 0;
        if (value !== undefined)
            reflectionMergePartial<GetLastStatementRunSendStatsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLastStatementRunSendStatsRes): GetLastStatementRunSendStatsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 num_customers_to_mail */ 1:
                    message.numCustomersToMail = reader.int32();
                    break;
                case /* int32 num_customers_with_contacts_to_email */ 2:
                    message.numCustomersWithContactsToEmail = reader.int32();
                    break;
                case /* int32 num_customer_contacts_to_email */ 3:
                    message.numCustomerContactsToEmail = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID statement_run_id */ 4:
                    message.statementRunId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.statementRunId);
                    break;
                case /* repeated rd.proto.uuid.UUID mail_customer_ids */ 5:
                    message.mailCustomerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID email_customer_ids */ 6:
                    message.emailCustomerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.timestamprange.TimestampRange statement_period */ 7:
                    message.statementPeriod = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.statementPeriod);
                    break;
                case /* int32 num_customers_mailed */ 8:
                    message.numCustomersMailed = reader.int32();
                    break;
                case /* int32 num_customers_emailed */ 9:
                    message.numCustomersEmailed = reader.int32();
                    break;
                case /* int32 num_statements */ 10:
                    message.numStatements = reader.int32();
                    break;
                case /* int32 num_statements_sent */ 11:
                    message.numStatementsSent = reader.int32();
                    break;
                case /* int32 num_errors */ 12:
                    message.numErrors = reader.int32();
                    break;
                case /* int32 num_initiated */ 13:
                    message.numInitiated = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLastStatementRunSendStatsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 num_customers_to_mail = 1; */
        if (message.numCustomersToMail !== 0)
            writer.tag(1, WireType.Varint).int32(message.numCustomersToMail);
        /* int32 num_customers_with_contacts_to_email = 2; */
        if (message.numCustomersWithContactsToEmail !== 0)
            writer.tag(2, WireType.Varint).int32(message.numCustomersWithContactsToEmail);
        /* int32 num_customer_contacts_to_email = 3; */
        if (message.numCustomerContactsToEmail !== 0)
            writer.tag(3, WireType.Varint).int32(message.numCustomerContactsToEmail);
        /* rd.proto.uuid.UUID statement_run_id = 4; */
        if (message.statementRunId)
            UUID.internalBinaryWrite(message.statementRunId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID mail_customer_ids = 5; */
        for (let i = 0; i < message.mailCustomerIds.length; i++)
            UUID.internalBinaryWrite(message.mailCustomerIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID email_customer_ids = 6; */
        for (let i = 0; i < message.emailCustomerIds.length; i++)
            UUID.internalBinaryWrite(message.emailCustomerIds[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange statement_period = 7; */
        if (message.statementPeriod)
            TimestampRange.internalBinaryWrite(message.statementPeriod, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* int32 num_customers_mailed = 8; */
        if (message.numCustomersMailed !== 0)
            writer.tag(8, WireType.Varint).int32(message.numCustomersMailed);
        /* int32 num_customers_emailed = 9; */
        if (message.numCustomersEmailed !== 0)
            writer.tag(9, WireType.Varint).int32(message.numCustomersEmailed);
        /* int32 num_statements = 10; */
        if (message.numStatements !== 0)
            writer.tag(10, WireType.Varint).int32(message.numStatements);
        /* int32 num_statements_sent = 11; */
        if (message.numStatementsSent !== 0)
            writer.tag(11, WireType.Varint).int32(message.numStatementsSent);
        /* int32 num_errors = 12; */
        if (message.numErrors !== 0)
            writer.tag(12, WireType.Varint).int32(message.numErrors);
        /* int32 num_initiated = 13; */
        if (message.numInitiated !== 0)
            writer.tag(13, WireType.Varint).int32(message.numInitiated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetLastStatementRunSendStatsRes
 */
export const GetLastStatementRunSendStatsRes = new GetLastStatementRunSendStatsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateAndSendIndividualCustomerStatementReq$Type extends MessageType<GenerateAndSendIndividualCustomerStatementReq> {
    constructor() {
        super("rd.api.customer.GenerateAndSendIndividualCustomerStatementReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "start_date", kind: "message", T: () => Timestamp },
            { no: 3, name: "end_date", kind: "message", T: () => Timestamp },
            { no: 4, name: "send_type", kind: "enum", T: () => ["rd.api.customer.GenerateAndSendIndividualCustomerStatementReq.SendType", GenerateAndSendIndividualCustomerStatementReq_SendType, "SEND_TYPE_"] },
            { no: 5, name: "customer_contact_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "additional_emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "statement_type", kind: "enum", T: () => ["rd.statement.StatementType", StatementType, "STATEMENT_TYPE_"] },
            { no: 8, name: "statement_invoices_format", kind: "enum", T: () => ["rd.statement.StatementInvoicesFormatType", StatementInvoicesFormatType, "STATEMENT_INVOICES_FORMAT_TYPE_"] },
            { no: 9, name: "should_include_jobs", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "client_time_zone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GenerateAndSendIndividualCustomerStatementReq>): GenerateAndSendIndividualCustomerStatementReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sendType = 0;
        message.customerContactIdStrings = [];
        message.additionalEmails = [];
        message.statementType = 0;
        message.statementInvoicesFormat = 0;
        message.shouldIncludeJobs = false;
        message.clientTimeZone = "";
        if (value !== undefined)
            reflectionMergePartial<GenerateAndSendIndividualCustomerStatementReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateAndSendIndividualCustomerStatementReq): GenerateAndSendIndividualCustomerStatementReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* google.protobuf.Timestamp start_date */ 2:
                    message.startDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startDate);
                    break;
                case /* google.protobuf.Timestamp end_date */ 3:
                    message.endDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.endDate);
                    break;
                case /* rd.api.customer.GenerateAndSendIndividualCustomerStatementReq.SendType send_type */ 4:
                    message.sendType = reader.int32();
                    break;
                case /* repeated string customer_contact_id_strings */ 5:
                    message.customerContactIdStrings.push(reader.string());
                    break;
                case /* repeated string additional_emails */ 6:
                    message.additionalEmails.push(reader.string());
                    break;
                case /* rd.statement.StatementType statement_type */ 7:
                    message.statementType = reader.int32();
                    break;
                case /* rd.statement.StatementInvoicesFormatType statement_invoices_format */ 8:
                    message.statementInvoicesFormat = reader.int32();
                    break;
                case /* bool should_include_jobs */ 9:
                    message.shouldIncludeJobs = reader.bool();
                    break;
                case /* string client_time_zone */ 10:
                    message.clientTimeZone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateAndSendIndividualCustomerStatementReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp start_date = 2; */
        if (message.startDate)
            Timestamp.internalBinaryWrite(message.startDate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp end_date = 3; */
        if (message.endDate)
            Timestamp.internalBinaryWrite(message.endDate, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.api.customer.GenerateAndSendIndividualCustomerStatementReq.SendType send_type = 4; */
        if (message.sendType !== 0)
            writer.tag(4, WireType.Varint).int32(message.sendType);
        /* repeated string customer_contact_id_strings = 5; */
        for (let i = 0; i < message.customerContactIdStrings.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.customerContactIdStrings[i]);
        /* repeated string additional_emails = 6; */
        for (let i = 0; i < message.additionalEmails.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.additionalEmails[i]);
        /* rd.statement.StatementType statement_type = 7; */
        if (message.statementType !== 0)
            writer.tag(7, WireType.Varint).int32(message.statementType);
        /* rd.statement.StatementInvoicesFormatType statement_invoices_format = 8; */
        if (message.statementInvoicesFormat !== 0)
            writer.tag(8, WireType.Varint).int32(message.statementInvoicesFormat);
        /* bool should_include_jobs = 9; */
        if (message.shouldIncludeJobs !== false)
            writer.tag(9, WireType.Varint).bool(message.shouldIncludeJobs);
        /* string client_time_zone = 10; */
        if (message.clientTimeZone !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.clientTimeZone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GenerateAndSendIndividualCustomerStatementReq
 */
export const GenerateAndSendIndividualCustomerStatementReq = new GenerateAndSendIndividualCustomerStatementReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateAndSendIndividualCustomerStatementRes$Type extends MessageType<GenerateAndSendIndividualCustomerStatementRes> {
    constructor() {
        super("rd.api.customer.GenerateAndSendIndividualCustomerStatementRes", [
            { no: 1, name: "pdf_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GenerateAndSendIndividualCustomerStatementRes>): GenerateAndSendIndividualCustomerStatementRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pdfUrl = "";
        if (value !== undefined)
            reflectionMergePartial<GenerateAndSendIndividualCustomerStatementRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateAndSendIndividualCustomerStatementRes): GenerateAndSendIndividualCustomerStatementRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string pdf_url */ 1:
                    message.pdfUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateAndSendIndividualCustomerStatementRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string pdf_url = 1; */
        if (message.pdfUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.pdfUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GenerateAndSendIndividualCustomerStatementRes
 */
export const GenerateAndSendIndividualCustomerStatementRes = new GenerateAndSendIndividualCustomerStatementRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountCustomersForBulkStatementReq$Type extends MessageType<CountCustomersForBulkStatementReq> {
    constructor() {
        super("rd.api.customer.CountCustomersForBulkStatementReq", [
            { no: 1, name: "financing_term_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pricing_tier_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "rep_staff_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 4, name: "finance_charge_setting_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 5, name: "tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "statement_run_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<CountCustomersForBulkStatementReq>): CountCustomersForBulkStatementReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.financingTermIdStrings = [];
        message.pricingTierIdStrings = [];
        message.repStaffIds = [];
        message.financeChargeSettingIds = [];
        message.tagIds = [];
        if (value !== undefined)
            reflectionMergePartial<CountCustomersForBulkStatementReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountCustomersForBulkStatementReq): CountCustomersForBulkStatementReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string financing_term_id_strings */ 1:
                    message.financingTermIdStrings.push(reader.string());
                    break;
                case /* repeated string pricing_tier_id_strings */ 2:
                    message.pricingTierIdStrings.push(reader.string());
                    break;
                case /* repeated rd.proto.uuid.UUID rep_staff_ids */ 3:
                    message.repStaffIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID finance_charge_setting_ids */ 4:
                    message.financeChargeSettingIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID tag_ids */ 5:
                    message.tagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.uuid.UUID statement_run_id */ 6:
                    message.statementRunId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.statementRunId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountCustomersForBulkStatementReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string financing_term_id_strings = 1; */
        for (let i = 0; i < message.financingTermIdStrings.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.financingTermIdStrings[i]);
        /* repeated string pricing_tier_id_strings = 2; */
        for (let i = 0; i < message.pricingTierIdStrings.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.pricingTierIdStrings[i]);
        /* repeated rd.proto.uuid.UUID rep_staff_ids = 3; */
        for (let i = 0; i < message.repStaffIds.length; i++)
            UUID.internalBinaryWrite(message.repStaffIds[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID finance_charge_setting_ids = 4; */
        for (let i = 0; i < message.financeChargeSettingIds.length; i++)
            UUID.internalBinaryWrite(message.financeChargeSettingIds[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID tag_ids = 5; */
        for (let i = 0; i < message.tagIds.length; i++)
            UUID.internalBinaryWrite(message.tagIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID statement_run_id = 6; */
        if (message.statementRunId)
            UUID.internalBinaryWrite(message.statementRunId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.CountCustomersForBulkStatementReq
 */
export const CountCustomersForBulkStatementReq = new CountCustomersForBulkStatementReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountCustomersForBulkStatementRes$Type extends MessageType<CountCustomersForBulkStatementRes> {
    constructor() {
        super("rd.api.customer.CountCustomersForBulkStatementRes", [
            { no: 1, name: "count_email", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "count_mail", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "count_email_contacts", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "count_mailed", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "count_emailed", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "count_generated", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "count_sent", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "count_errors", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "count_initiated", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<CountCustomersForBulkStatementRes>): CountCustomersForBulkStatementRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.countEmail = 0;
        message.countMail = 0;
        message.countEmailContacts = 0;
        message.countMailed = 0;
        message.countEmailed = 0;
        message.countGenerated = 0;
        message.countSent = 0;
        message.countErrors = 0;
        message.countInitiated = 0;
        if (value !== undefined)
            reflectionMergePartial<CountCustomersForBulkStatementRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountCustomersForBulkStatementRes): CountCustomersForBulkStatementRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 count_email */ 1:
                    message.countEmail = reader.int32();
                    break;
                case /* int32 count_mail */ 2:
                    message.countMail = reader.int32();
                    break;
                case /* int32 count_email_contacts */ 3:
                    message.countEmailContacts = reader.int32();
                    break;
                case /* int32 count_mailed */ 4:
                    message.countMailed = reader.int32();
                    break;
                case /* int32 count_emailed */ 5:
                    message.countEmailed = reader.int32();
                    break;
                case /* int32 count_generated */ 6:
                    message.countGenerated = reader.int32();
                    break;
                case /* int32 count_sent */ 7:
                    message.countSent = reader.int32();
                    break;
                case /* int32 count_errors */ 8:
                    message.countErrors = reader.int32();
                    break;
                case /* int32 count_initiated */ 9:
                    message.countInitiated = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountCustomersForBulkStatementRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 count_email = 1; */
        if (message.countEmail !== 0)
            writer.tag(1, WireType.Varint).int32(message.countEmail);
        /* int32 count_mail = 2; */
        if (message.countMail !== 0)
            writer.tag(2, WireType.Varint).int32(message.countMail);
        /* int32 count_email_contacts = 3; */
        if (message.countEmailContacts !== 0)
            writer.tag(3, WireType.Varint).int32(message.countEmailContacts);
        /* int32 count_mailed = 4; */
        if (message.countMailed !== 0)
            writer.tag(4, WireType.Varint).int32(message.countMailed);
        /* int32 count_emailed = 5; */
        if (message.countEmailed !== 0)
            writer.tag(5, WireType.Varint).int32(message.countEmailed);
        /* int32 count_generated = 6; */
        if (message.countGenerated !== 0)
            writer.tag(6, WireType.Varint).int32(message.countGenerated);
        /* int32 count_sent = 7; */
        if (message.countSent !== 0)
            writer.tag(7, WireType.Varint).int32(message.countSent);
        /* int32 count_errors = 8; */
        if (message.countErrors !== 0)
            writer.tag(8, WireType.Varint).int32(message.countErrors);
        /* int32 count_initiated = 9; */
        if (message.countInitiated !== 0)
            writer.tag(9, WireType.Varint).int32(message.countInitiated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.CountCustomersForBulkStatementRes
 */
export const CountCustomersForBulkStatementRes = new CountCustomersForBulkStatementRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq$Type extends MessageType<UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "restrict_outstanding_invoices_to_statement_period", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq>): UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.restrictOutstandingInvoicesToStatementPeriod = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq): UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool restrict_outstanding_invoices_to_statement_period */ 2:
                    message.restrictOutstandingInvoicesToStatementPeriod = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool restrict_outstanding_invoices_to_statement_period = 2; */
        if (message.restrictOutstandingInvoicesToStatementPeriod !== false)
            writer.tag(2, WireType.Varint).bool(message.restrictOutstandingInvoicesToStatementPeriod);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq
 */
export const UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq = new UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodRes$Type extends MessageType<UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodRes>): UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodRes): UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodRes
 */
export const UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodRes = new UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateStatementsForCustomersReq$Type extends MessageType<GenerateStatementsForCustomersReq> {
    constructor() {
        super("rd.api.customer.GenerateStatementsForCustomersReq", [
            { no: 1, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 2, name: "start_date", kind: "message", T: () => Timestamp },
            { no: 3, name: "end_date", kind: "message", T: () => Timestamp },
            { no: 4, name: "client_time_zone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GenerateStatementsForCustomersReq>): GenerateStatementsForCustomersReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.customerIds = [];
        message.clientTimeZone = "";
        if (value !== undefined)
            reflectionMergePartial<GenerateStatementsForCustomersReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateStatementsForCustomersReq): GenerateStatementsForCustomersReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.proto.uuid.UUID customer_ids */ 1:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp start_date */ 2:
                    message.startDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startDate);
                    break;
                case /* google.protobuf.Timestamp end_date */ 3:
                    message.endDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.endDate);
                    break;
                case /* string client_time_zone */ 4:
                    message.clientTimeZone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateStatementsForCustomersReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.proto.uuid.UUID customer_ids = 1; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp start_date = 2; */
        if (message.startDate)
            Timestamp.internalBinaryWrite(message.startDate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp end_date = 3; */
        if (message.endDate)
            Timestamp.internalBinaryWrite(message.endDate, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string client_time_zone = 4; */
        if (message.clientTimeZone !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.clientTimeZone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GenerateStatementsForCustomersReq
 */
export const GenerateStatementsForCustomersReq = new GenerateStatementsForCustomersReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateStatementsForCustomersRes$Type extends MessageType<GenerateStatementsForCustomersRes> {
    constructor() {
        super("rd.api.customer.GenerateStatementsForCustomersRes", []);
    }
    create(value?: PartialMessage<GenerateStatementsForCustomersRes>): GenerateStatementsForCustomersRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GenerateStatementsForCustomersRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateStatementsForCustomersRes): GenerateStatementsForCustomersRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateStatementsForCustomersRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GenerateStatementsForCustomersRes
 */
export const GenerateStatementsForCustomersRes = new GenerateStatementsForCustomersRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGenerateStatementsForCustomersReq$Type extends MessageType<BulkGenerateStatementsForCustomersReq> {
    constructor() {
        super("rd.api.customer.BulkGenerateStatementsForCustomersReq", [
            { no: 1, name: "financing_term_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pricing_tier_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "rep_staff_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 4, name: "finance_charge_setting_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 5, name: "tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "start_date", kind: "message", T: () => Timestamp },
            { no: 7, name: "end_date", kind: "message", T: () => Timestamp },
            { no: 8, name: "client_time_zone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<BulkGenerateStatementsForCustomersReq>): BulkGenerateStatementsForCustomersReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.financingTermIdStrings = [];
        message.pricingTierIdStrings = [];
        message.repStaffIds = [];
        message.financeChargeSettingIds = [];
        message.tagIds = [];
        message.clientTimeZone = "";
        if (value !== undefined)
            reflectionMergePartial<BulkGenerateStatementsForCustomersReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkGenerateStatementsForCustomersReq): BulkGenerateStatementsForCustomersReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string financing_term_id_strings */ 1:
                    message.financingTermIdStrings.push(reader.string());
                    break;
                case /* repeated string pricing_tier_id_strings */ 2:
                    message.pricingTierIdStrings.push(reader.string());
                    break;
                case /* repeated rd.proto.uuid.UUID rep_staff_ids */ 3:
                    message.repStaffIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID finance_charge_setting_ids */ 4:
                    message.financeChargeSettingIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID tag_ids */ 5:
                    message.tagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp start_date */ 6:
                    message.startDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startDate);
                    break;
                case /* google.protobuf.Timestamp end_date */ 7:
                    message.endDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.endDate);
                    break;
                case /* string client_time_zone */ 8:
                    message.clientTimeZone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkGenerateStatementsForCustomersReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string financing_term_id_strings = 1; */
        for (let i = 0; i < message.financingTermIdStrings.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.financingTermIdStrings[i]);
        /* repeated string pricing_tier_id_strings = 2; */
        for (let i = 0; i < message.pricingTierIdStrings.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.pricingTierIdStrings[i]);
        /* repeated rd.proto.uuid.UUID rep_staff_ids = 3; */
        for (let i = 0; i < message.repStaffIds.length; i++)
            UUID.internalBinaryWrite(message.repStaffIds[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID finance_charge_setting_ids = 4; */
        for (let i = 0; i < message.financeChargeSettingIds.length; i++)
            UUID.internalBinaryWrite(message.financeChargeSettingIds[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID tag_ids = 5; */
        for (let i = 0; i < message.tagIds.length; i++)
            UUID.internalBinaryWrite(message.tagIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp start_date = 6; */
        if (message.startDate)
            Timestamp.internalBinaryWrite(message.startDate, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp end_date = 7; */
        if (message.endDate)
            Timestamp.internalBinaryWrite(message.endDate, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string client_time_zone = 8; */
        if (message.clientTimeZone !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.clientTimeZone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.BulkGenerateStatementsForCustomersReq
 */
export const BulkGenerateStatementsForCustomersReq = new BulkGenerateStatementsForCustomersReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGenerateStatementsForCustomersRes$Type extends MessageType<BulkGenerateStatementsForCustomersRes> {
    constructor() {
        super("rd.api.customer.BulkGenerateStatementsForCustomersRes", []);
    }
    create(value?: PartialMessage<BulkGenerateStatementsForCustomersRes>): BulkGenerateStatementsForCustomersRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<BulkGenerateStatementsForCustomersRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkGenerateStatementsForCustomersRes): BulkGenerateStatementsForCustomersRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkGenerateStatementsForCustomersRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.BulkGenerateStatementsForCustomersRes
 */
export const BulkGenerateStatementsForCustomersRes = new BulkGenerateStatementsForCustomersRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomerSavedCardsReq$Type extends MessageType<GetCustomerSavedCardsReq> {
    constructor() {
        super("rd.api.customer.GetCustomerSavedCardsReq", [
            { no: 2, name: "customer_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<GetCustomerSavedCardsReq>): GetCustomerSavedCardsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCustomerSavedCardsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCustomerSavedCardsReq): GetCustomerSavedCardsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 2:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCustomerSavedCardsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 2; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetCustomerSavedCardsReq
 */
export const GetCustomerSavedCardsReq = new GetCustomerSavedCardsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomerSavedCardsRes$Type extends MessageType<GetCustomerSavedCardsRes> {
    constructor() {
        super("rd.api.customer.GetCustomerSavedCardsRes", [
            { no: 1, name: "cards", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Card },
            { no: 2, name: "card_display_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetCustomerSavedCardsRes>): GetCustomerSavedCardsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cards = [];
        message.cardDisplayStrings = [];
        if (value !== undefined)
            reflectionMergePartial<GetCustomerSavedCardsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCustomerSavedCardsRes): GetCustomerSavedCardsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.payments.Card cards */ 1:
                    message.cards.push(Card.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string card_display_strings */ 2:
                    message.cardDisplayStrings.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCustomerSavedCardsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.payments.Card cards = 1; */
        for (let i = 0; i < message.cards.length; i++)
            Card.internalBinaryWrite(message.cards[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string card_display_strings = 2; */
        for (let i = 0; i < message.cardDisplayStrings.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.cardDisplayStrings[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetCustomerSavedCardsRes
 */
export const GetCustomerSavedCardsRes = new GetCustomerSavedCardsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerPrimaryCardReq$Type extends MessageType<UpdateCustomerPrimaryCardReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerPrimaryCardReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "stripe_card_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerPrimaryCardReq>): UpdateCustomerPrimaryCardReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stripeCardId = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerPrimaryCardReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerPrimaryCardReq): UpdateCustomerPrimaryCardReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string stripe_card_id */ 2:
                    message.stripeCardId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerPrimaryCardReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string stripe_card_id = 2; */
        if (message.stripeCardId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.stripeCardId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerPrimaryCardReq
 */
export const UpdateCustomerPrimaryCardReq = new UpdateCustomerPrimaryCardReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerPrimaryCardRes$Type extends MessageType<UpdateCustomerPrimaryCardRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerPrimaryCardRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerPrimaryCardRes>): UpdateCustomerPrimaryCardRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerPrimaryCardRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerPrimaryCardRes): UpdateCustomerPrimaryCardRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerPrimaryCardRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerPrimaryCardRes
 */
export const UpdateCustomerPrimaryCardRes = new UpdateCustomerPrimaryCardRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCustomerCardReq$Type extends MessageType<DeleteCustomerCardReq> {
    constructor() {
        super("rd.api.customer.DeleteCustomerCardReq", [
            { no: 1, name: "stripe_card_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DeleteCustomerCardReq>): DeleteCustomerCardReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stripeCardId = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteCustomerCardReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteCustomerCardReq): DeleteCustomerCardReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stripe_card_id */ 1:
                    message.stripeCardId = reader.string();
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 2:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteCustomerCardReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stripe_card_id = 1; */
        if (message.stripeCardId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stripeCardId);
        /* rd.proto.uuid.UUID customer_id = 2; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.DeleteCustomerCardReq
 */
export const DeleteCustomerCardReq = new DeleteCustomerCardReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCustomerCardRes$Type extends MessageType<DeleteCustomerCardRes> {
    constructor() {
        super("rd.api.customer.DeleteCustomerCardRes", [
            { no: 3, name: "new_primary_method_type", kind: "enum", T: () => ["rd.api.customer.DeleteCustomerCardRes.MethodType", DeleteCustomerCardRes_MethodType, "METHOD_TYPE_"] },
            { no: 4, name: "new_primary_last_4", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteCustomerCardRes>): DeleteCustomerCardRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.newPrimaryMethodType = 0;
        message.newPrimaryLast4 = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteCustomerCardRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteCustomerCardRes): DeleteCustomerCardRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.api.customer.DeleteCustomerCardRes.MethodType new_primary_method_type */ 3:
                    message.newPrimaryMethodType = reader.int32();
                    break;
                case /* string new_primary_last_4 */ 4:
                    message.newPrimaryLast4 = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteCustomerCardRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.api.customer.DeleteCustomerCardRes.MethodType new_primary_method_type = 3; */
        if (message.newPrimaryMethodType !== 0)
            writer.tag(3, WireType.Varint).int32(message.newPrimaryMethodType);
        /* string new_primary_last_4 = 4; */
        if (message.newPrimaryLast4 !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.newPrimaryLast4);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.DeleteCustomerCardRes
 */
export const DeleteCustomerCardRes = new DeleteCustomerCardRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddCustomerCardReq$Type extends MessageType<AddCustomerCardReq> {
    constructor() {
        super("rd.api.customer.AddCustomerCardReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "card_number", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.log": true, "rd.validator.require": true } },
            { no: 3, name: "card_expiration_month", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "rd.sanitize.log": true, "rd.validator.require": true } },
            { no: 4, name: "card_expiration_year", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "rd.sanitize.log": true, "rd.validator.require": true } },
            { no: 5, name: "card_cvc", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.log": true, "rd.validator.require": true } },
            { no: 6, name: "is_primary_card", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "zip_code", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.log": true, "rd.validator.require": true } },
            { no: 8, name: "card_nickname", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AddCustomerCardReq>): AddCustomerCardReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cardNumber = "";
        message.cardExpirationMonth = 0;
        message.cardExpirationYear = 0;
        message.cardCvc = "";
        message.isPrimaryCard = false;
        message.zipCode = "";
        message.cardNickname = "";
        if (value !== undefined)
            reflectionMergePartial<AddCustomerCardReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddCustomerCardReq): AddCustomerCardReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* string card_number */ 2:
                    message.cardNumber = reader.string();
                    break;
                case /* int32 card_expiration_month */ 3:
                    message.cardExpirationMonth = reader.int32();
                    break;
                case /* int32 card_expiration_year */ 4:
                    message.cardExpirationYear = reader.int32();
                    break;
                case /* string card_cvc */ 5:
                    message.cardCvc = reader.string();
                    break;
                case /* bool is_primary_card */ 6:
                    message.isPrimaryCard = reader.bool();
                    break;
                case /* string zip_code */ 7:
                    message.zipCode = reader.string();
                    break;
                case /* string card_nickname */ 8:
                    message.cardNickname = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddCustomerCardReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string card_number = 2; */
        if (message.cardNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cardNumber);
        /* int32 card_expiration_month = 3; */
        if (message.cardExpirationMonth !== 0)
            writer.tag(3, WireType.Varint).int32(message.cardExpirationMonth);
        /* int32 card_expiration_year = 4; */
        if (message.cardExpirationYear !== 0)
            writer.tag(4, WireType.Varint).int32(message.cardExpirationYear);
        /* string card_cvc = 5; */
        if (message.cardCvc !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.cardCvc);
        /* bool is_primary_card = 6; */
        if (message.isPrimaryCard !== false)
            writer.tag(6, WireType.Varint).bool(message.isPrimaryCard);
        /* string zip_code = 7; */
        if (message.zipCode !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.zipCode);
        /* string card_nickname = 8; */
        if (message.cardNickname !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.cardNickname);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.AddCustomerCardReq
 */
export const AddCustomerCardReq = new AddCustomerCardReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddCustomerCardRes$Type extends MessageType<AddCustomerCardRes> {
    constructor() {
        super("rd.api.customer.AddCustomerCardRes", [
            { no: 1, name: "stripe_card_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AddCustomerCardRes>): AddCustomerCardRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stripeCardId = "";
        if (value !== undefined)
            reflectionMergePartial<AddCustomerCardRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddCustomerCardRes): AddCustomerCardRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stripe_card_id */ 1:
                    message.stripeCardId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddCustomerCardRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stripe_card_id = 1; */
        if (message.stripeCardId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stripeCardId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.AddCustomerCardRes
 */
export const AddCustomerCardRes = new AddCustomerCardRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SendACHPaymentEmailAndSmsReq$Type extends MessageType<SendACHPaymentEmailAndSmsReq> {
    constructor() {
        super("rd.api.customer.SendACHPaymentEmailAndSmsReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "customer_contact_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<SendACHPaymentEmailAndSmsReq>): SendACHPaymentEmailAndSmsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.customerContactId = "";
        if (value !== undefined)
            reflectionMergePartial<SendACHPaymentEmailAndSmsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SendACHPaymentEmailAndSmsReq): SendACHPaymentEmailAndSmsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* string customer_contact_id */ 2:
                    message.customerContactId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SendACHPaymentEmailAndSmsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string customer_contact_id = 2; */
        if (message.customerContactId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerContactId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.SendACHPaymentEmailAndSmsReq
 */
export const SendACHPaymentEmailAndSmsReq = new SendACHPaymentEmailAndSmsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SendACHPaymentEmailAndSmsRes$Type extends MessageType<SendACHPaymentEmailAndSmsRes> {
    constructor() {
        super("rd.api.customer.SendACHPaymentEmailAndSmsRes", []);
    }
    create(value?: PartialMessage<SendACHPaymentEmailAndSmsRes>): SendACHPaymentEmailAndSmsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SendACHPaymentEmailAndSmsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SendACHPaymentEmailAndSmsRes): SendACHPaymentEmailAndSmsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SendACHPaymentEmailAndSmsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.SendACHPaymentEmailAndSmsRes
 */
export const SendACHPaymentEmailAndSmsRes = new SendACHPaymentEmailAndSmsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerCardReq$Type extends MessageType<UpdateCustomerCardReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerCardReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "stripe_card_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "card_nickname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "is_primary_card", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerCardReq>): UpdateCustomerCardReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stripeCardId = "";
        message.cardNickname = "";
        message.isPrimaryCard = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerCardReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerCardReq): UpdateCustomerCardReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* string stripe_card_id */ 2:
                    message.stripeCardId = reader.string();
                    break;
                case /* string card_nickname */ 3:
                    message.cardNickname = reader.string();
                    break;
                case /* bool is_primary_card */ 4:
                    message.isPrimaryCard = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerCardReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string stripe_card_id = 2; */
        if (message.stripeCardId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.stripeCardId);
        /* string card_nickname = 3; */
        if (message.cardNickname !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.cardNickname);
        /* bool is_primary_card = 4; */
        if (message.isPrimaryCard !== false)
            writer.tag(4, WireType.Varint).bool(message.isPrimaryCard);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerCardReq
 */
export const UpdateCustomerCardReq = new UpdateCustomerCardReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerCardRes$Type extends MessageType<UpdateCustomerCardRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerCardRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerCardRes>): UpdateCustomerCardRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerCardRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerCardRes): UpdateCustomerCardRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerCardRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerCardRes
 */
export const UpdateCustomerCardRes = new UpdateCustomerCardRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomerSavedBankAccountsReq$Type extends MessageType<GetCustomerSavedBankAccountsReq> {
    constructor() {
        super("rd.api.customer.GetCustomerSavedBankAccountsReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetCustomerSavedBankAccountsReq>): GetCustomerSavedBankAccountsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCustomerSavedBankAccountsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCustomerSavedBankAccountsReq): GetCustomerSavedBankAccountsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCustomerSavedBankAccountsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetCustomerSavedBankAccountsReq
 */
export const GetCustomerSavedBankAccountsReq = new GetCustomerSavedBankAccountsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomerSavedBankAccountsRes$Type extends MessageType<GetCustomerSavedBankAccountsRes> {
    constructor() {
        super("rd.api.customer.GetCustomerSavedBankAccountsRes", [
            { no: 1, name: "bank_accounts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BankPaymentMethod },
            { no: 2, name: "bank_account_display_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetCustomerSavedBankAccountsRes>): GetCustomerSavedBankAccountsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bankAccounts = [];
        message.bankAccountDisplayStrings = [];
        if (value !== undefined)
            reflectionMergePartial<GetCustomerSavedBankAccountsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCustomerSavedBankAccountsRes): GetCustomerSavedBankAccountsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.payments.BankPaymentMethod bank_accounts */ 1:
                    message.bankAccounts.push(BankPaymentMethod.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string bank_account_display_strings */ 2:
                    message.bankAccountDisplayStrings.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCustomerSavedBankAccountsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.payments.BankPaymentMethod bank_accounts = 1; */
        for (let i = 0; i < message.bankAccounts.length; i++)
            BankPaymentMethod.internalBinaryWrite(message.bankAccounts[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string bank_account_display_strings = 2; */
        for (let i = 0; i < message.bankAccountDisplayStrings.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.bankAccountDisplayStrings[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetCustomerSavedBankAccountsRes
 */
export const GetCustomerSavedBankAccountsRes = new GetCustomerSavedBankAccountsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCustomerContactReq$Type extends MessageType<CreateCustomerContactReq> {
    constructor() {
        super("rd.api.customer.CreateCustomerContactReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "is_primary", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 4, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.log": true, "rd.validator.is_phone": true } },
            { no: 5, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.log": true, "rd.validator.is_email": true } },
            { no: 6, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.log": true } },
            { no: 7, name: "should_email_invoices", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "should_email_statements", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "invoice_format", kind: "enum", T: () => ["rd.customer.Customer.StatementInvoicesFormatType", Customer_StatementInvoicesFormatType, "STATEMENT_INVOICES_FORMAT_TYPE_"] },
            { no: 10, name: "email_frequency", kind: "enum", T: () => ["rd.customer.Contacts.Contact.EmailFrequency", Contacts_Contact_EmailFrequency, "EMAIL_FREQUENCY_"] },
            { no: 11, name: "sms_consent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "authorized_buyer", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CreateCustomerContactReq>): CreateCustomerContactReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isPrimary = false;
        message.name = "";
        message.phone = "";
        message.email = "";
        message.notes = "";
        message.shouldEmailInvoices = false;
        message.shouldEmailStatements = false;
        message.invoiceFormat = 0;
        message.emailFrequency = 0;
        message.smsConsent = false;
        message.authorizedBuyer = false;
        if (value !== undefined)
            reflectionMergePartial<CreateCustomerContactReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateCustomerContactReq): CreateCustomerContactReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool is_primary */ 2:
                    message.isPrimary = reader.bool();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string phone */ 4:
                    message.phone = reader.string();
                    break;
                case /* string email */ 5:
                    message.email = reader.string();
                    break;
                case /* string notes */ 6:
                    message.notes = reader.string();
                    break;
                case /* bool should_email_invoices */ 7:
                    message.shouldEmailInvoices = reader.bool();
                    break;
                case /* bool should_email_statements */ 8:
                    message.shouldEmailStatements = reader.bool();
                    break;
                case /* rd.customer.Customer.StatementInvoicesFormatType invoice_format */ 9:
                    message.invoiceFormat = reader.int32();
                    break;
                case /* rd.customer.Contacts.Contact.EmailFrequency email_frequency */ 10:
                    message.emailFrequency = reader.int32();
                    break;
                case /* bool sms_consent */ 11:
                    message.smsConsent = reader.bool();
                    break;
                case /* bool authorized_buyer */ 12:
                    message.authorizedBuyer = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateCustomerContactReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool is_primary = 2; */
        if (message.isPrimary !== false)
            writer.tag(2, WireType.Varint).bool(message.isPrimary);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string phone = 4; */
        if (message.phone !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.phone);
        /* string email = 5; */
        if (message.email !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.email);
        /* string notes = 6; */
        if (message.notes !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.notes);
        /* bool should_email_invoices = 7; */
        if (message.shouldEmailInvoices !== false)
            writer.tag(7, WireType.Varint).bool(message.shouldEmailInvoices);
        /* bool should_email_statements = 8; */
        if (message.shouldEmailStatements !== false)
            writer.tag(8, WireType.Varint).bool(message.shouldEmailStatements);
        /* rd.customer.Customer.StatementInvoicesFormatType invoice_format = 9; */
        if (message.invoiceFormat !== 0)
            writer.tag(9, WireType.Varint).int32(message.invoiceFormat);
        /* rd.customer.Contacts.Contact.EmailFrequency email_frequency = 10; */
        if (message.emailFrequency !== 0)
            writer.tag(10, WireType.Varint).int32(message.emailFrequency);
        /* bool sms_consent = 11; */
        if (message.smsConsent !== false)
            writer.tag(11, WireType.Varint).bool(message.smsConsent);
        /* bool authorized_buyer = 12; */
        if (message.authorizedBuyer !== false)
            writer.tag(12, WireType.Varint).bool(message.authorizedBuyer);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.CreateCustomerContactReq
 */
export const CreateCustomerContactReq = new CreateCustomerContactReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCustomerContactRes$Type extends MessageType<CreateCustomerContactRes> {
    constructor() {
        super("rd.api.customer.CreateCustomerContactRes", [
            { no: 1, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateCustomerContactRes>): CreateCustomerContactRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        if (value !== undefined)
            reflectionMergePartial<CreateCustomerContactRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateCustomerContactRes): CreateCustomerContactRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id_string */ 1:
                    message.idString = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateCustomerContactRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id_string = 1; */
        if (message.idString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.idString);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.CreateCustomerContactRes
 */
export const CreateCustomerContactRes = new CreateCustomerContactRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerContactReq$Type extends MessageType<UpdateCustomerContactReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerContactReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "is_primary", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 5, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.log": true, "rd.validator.is_phone": true } },
            { no: 6, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.log": true, "rd.validator.is_email": true } },
            { no: 7, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.log": true } },
            { no: 8, name: "should_email_invoices", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "should_email_statements", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "invoice_format", kind: "enum", T: () => ["rd.customer.Customer.StatementInvoicesFormatType", Customer_StatementInvoicesFormatType, "STATEMENT_INVOICES_FORMAT_TYPE_"] },
            { no: 11, name: "email_frequency", kind: "enum", T: () => ["rd.customer.Contacts.Contact.EmailFrequency", Contacts_Contact_EmailFrequency, "EMAIL_FREQUENCY_"] },
            { no: 12, name: "sms_consent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "authorized_buyer", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerContactReq>): UpdateCustomerContactReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        message.isPrimary = false;
        message.name = "";
        message.phone = "";
        message.email = "";
        message.notes = "";
        message.shouldEmailInvoices = false;
        message.shouldEmailStatements = false;
        message.invoiceFormat = 0;
        message.emailFrequency = 0;
        message.smsConsent = false;
        message.authorizedBuyer = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerContactReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerContactReq): UpdateCustomerContactReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string id_string */ 2:
                    message.idString = reader.string();
                    break;
                case /* bool is_primary */ 3:
                    message.isPrimary = reader.bool();
                    break;
                case /* string name */ 4:
                    message.name = reader.string();
                    break;
                case /* string phone */ 5:
                    message.phone = reader.string();
                    break;
                case /* string email */ 6:
                    message.email = reader.string();
                    break;
                case /* string notes */ 7:
                    message.notes = reader.string();
                    break;
                case /* bool should_email_invoices */ 8:
                    message.shouldEmailInvoices = reader.bool();
                    break;
                case /* bool should_email_statements */ 9:
                    message.shouldEmailStatements = reader.bool();
                    break;
                case /* rd.customer.Customer.StatementInvoicesFormatType invoice_format */ 10:
                    message.invoiceFormat = reader.int32();
                    break;
                case /* rd.customer.Contacts.Contact.EmailFrequency email_frequency */ 11:
                    message.emailFrequency = reader.int32();
                    break;
                case /* bool sms_consent */ 12:
                    message.smsConsent = reader.bool();
                    break;
                case /* bool authorized_buyer */ 13:
                    message.authorizedBuyer = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerContactReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string id_string = 2; */
        if (message.idString !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.idString);
        /* bool is_primary = 3; */
        if (message.isPrimary !== false)
            writer.tag(3, WireType.Varint).bool(message.isPrimary);
        /* string name = 4; */
        if (message.name !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.name);
        /* string phone = 5; */
        if (message.phone !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.phone);
        /* string email = 6; */
        if (message.email !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.email);
        /* string notes = 7; */
        if (message.notes !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.notes);
        /* bool should_email_invoices = 8; */
        if (message.shouldEmailInvoices !== false)
            writer.tag(8, WireType.Varint).bool(message.shouldEmailInvoices);
        /* bool should_email_statements = 9; */
        if (message.shouldEmailStatements !== false)
            writer.tag(9, WireType.Varint).bool(message.shouldEmailStatements);
        /* rd.customer.Customer.StatementInvoicesFormatType invoice_format = 10; */
        if (message.invoiceFormat !== 0)
            writer.tag(10, WireType.Varint).int32(message.invoiceFormat);
        /* rd.customer.Contacts.Contact.EmailFrequency email_frequency = 11; */
        if (message.emailFrequency !== 0)
            writer.tag(11, WireType.Varint).int32(message.emailFrequency);
        /* bool sms_consent = 12; */
        if (message.smsConsent !== false)
            writer.tag(12, WireType.Varint).bool(message.smsConsent);
        /* bool authorized_buyer = 13; */
        if (message.authorizedBuyer !== false)
            writer.tag(13, WireType.Varint).bool(message.authorizedBuyer);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerContactReq
 */
export const UpdateCustomerContactReq = new UpdateCustomerContactReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerContactRes$Type extends MessageType<UpdateCustomerContactRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerContactRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerContactRes>): UpdateCustomerContactRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerContactRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerContactRes): UpdateCustomerContactRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerContactRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerContactRes
 */
export const UpdateCustomerContactRes = new UpdateCustomerContactRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateCustomerContactReq$Type extends MessageType<DeactivateCustomerContactReq> {
    constructor() {
        super("rd.api.customer.DeactivateCustomerContactReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DeactivateCustomerContactReq>): DeactivateCustomerContactReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        if (value !== undefined)
            reflectionMergePartial<DeactivateCustomerContactReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateCustomerContactReq): DeactivateCustomerContactReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string id_string */ 2:
                    message.idString = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateCustomerContactReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string id_string = 2; */
        if (message.idString !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.idString);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.DeactivateCustomerContactReq
 */
export const DeactivateCustomerContactReq = new DeactivateCustomerContactReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateCustomerContactRes$Type extends MessageType<DeactivateCustomerContactRes> {
    constructor() {
        super("rd.api.customer.DeactivateCustomerContactRes", []);
    }
    create(value?: PartialMessage<DeactivateCustomerContactRes>): DeactivateCustomerContactRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateCustomerContactRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateCustomerContactRes): DeactivateCustomerContactRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateCustomerContactRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.DeactivateCustomerContactRes
 */
export const DeactivateCustomerContactRes = new DeactivateCustomerContactRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomerSaleHistoryPDFReq$Type extends MessageType<GetCustomerSaleHistoryPDFReq> {
    constructor() {
        super("rd.api.customer.GetCustomerSaleHistoryPDFReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "sold_at_range", kind: "message", T: () => TimestampRange },
            { no: 3, name: "client_time_zone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 4, name: "purchase_order_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 5, name: "invoice_format", kind: "enum", T: () => ["rd.customer.Customer.StatementInvoicesFormatType", Customer_StatementInvoicesFormatType, "STATEMENT_INVOICES_FORMAT_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<GetCustomerSaleHistoryPDFReq>): GetCustomerSaleHistoryPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clientTimeZone = "";
        message.purchaseOrderIds = [];
        message.invoiceFormat = 0;
        if (value !== undefined)
            reflectionMergePartial<GetCustomerSaleHistoryPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCustomerSaleHistoryPDFReq): GetCustomerSaleHistoryPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.timestamprange.TimestampRange sold_at_range */ 2:
                    message.soldAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.soldAtRange);
                    break;
                case /* string client_time_zone */ 3:
                    message.clientTimeZone = reader.string();
                    break;
                case /* repeated rd.proto.uuid.UUID purchase_order_ids */ 4:
                    message.purchaseOrderIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.customer.Customer.StatementInvoicesFormatType invoice_format */ 5:
                    message.invoiceFormat = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCustomerSaleHistoryPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange sold_at_range = 2; */
        if (message.soldAtRange)
            TimestampRange.internalBinaryWrite(message.soldAtRange, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string client_time_zone = 3; */
        if (message.clientTimeZone !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.clientTimeZone);
        /* repeated rd.proto.uuid.UUID purchase_order_ids = 4; */
        for (let i = 0; i < message.purchaseOrderIds.length; i++)
            UUID.internalBinaryWrite(message.purchaseOrderIds[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Customer.StatementInvoicesFormatType invoice_format = 5; */
        if (message.invoiceFormat !== 0)
            writer.tag(5, WireType.Varint).int32(message.invoiceFormat);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetCustomerSaleHistoryPDFReq
 */
export const GetCustomerSaleHistoryPDFReq = new GetCustomerSaleHistoryPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomerSaleHistoryPDFRes$Type extends MessageType<GetCustomerSaleHistoryPDFRes> {
    constructor() {
        super("rd.api.customer.GetCustomerSaleHistoryPDFRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetCustomerSaleHistoryPDFRes>): GetCustomerSaleHistoryPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetCustomerSaleHistoryPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCustomerSaleHistoryPDFRes): GetCustomerSaleHistoryPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCustomerSaleHistoryPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GetCustomerSaleHistoryPDFRes
 */
export const GetCustomerSaleHistoryPDFRes = new GetCustomerSaleHistoryPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailCustomerSaleHistoryPDFReq$Type extends MessageType<EmailCustomerSaleHistoryPDFReq> {
    constructor() {
        super("rd.api.customer.EmailCustomerSaleHistoryPDFReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "sold_at_range", kind: "message", T: () => TimestampRange },
            { no: 3, name: "client_time_zone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 4, name: "customer_contact_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "additional_emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "purchase_order_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 7, name: "invoice_format", kind: "enum", T: () => ["rd.customer.Customer.StatementInvoicesFormatType", Customer_StatementInvoicesFormatType, "STATEMENT_INVOICES_FORMAT_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<EmailCustomerSaleHistoryPDFReq>): EmailCustomerSaleHistoryPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clientTimeZone = "";
        message.customerContactIdStrings = [];
        message.additionalEmails = [];
        message.purchaseOrderIds = [];
        message.invoiceFormat = 0;
        if (value !== undefined)
            reflectionMergePartial<EmailCustomerSaleHistoryPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailCustomerSaleHistoryPDFReq): EmailCustomerSaleHistoryPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.timestamprange.TimestampRange sold_at_range */ 2:
                    message.soldAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.soldAtRange);
                    break;
                case /* string client_time_zone */ 3:
                    message.clientTimeZone = reader.string();
                    break;
                case /* repeated string customer_contact_id_strings */ 4:
                    message.customerContactIdStrings.push(reader.string());
                    break;
                case /* repeated string additional_emails */ 5:
                    message.additionalEmails.push(reader.string());
                    break;
                case /* repeated rd.proto.uuid.UUID purchase_order_ids */ 6:
                    message.purchaseOrderIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.customer.Customer.StatementInvoicesFormatType invoice_format */ 7:
                    message.invoiceFormat = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailCustomerSaleHistoryPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange sold_at_range = 2; */
        if (message.soldAtRange)
            TimestampRange.internalBinaryWrite(message.soldAtRange, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string client_time_zone = 3; */
        if (message.clientTimeZone !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.clientTimeZone);
        /* repeated string customer_contact_id_strings = 4; */
        for (let i = 0; i < message.customerContactIdStrings.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.customerContactIdStrings[i]);
        /* repeated string additional_emails = 5; */
        for (let i = 0; i < message.additionalEmails.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.additionalEmails[i]);
        /* repeated rd.proto.uuid.UUID purchase_order_ids = 6; */
        for (let i = 0; i < message.purchaseOrderIds.length; i++)
            UUID.internalBinaryWrite(message.purchaseOrderIds[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Customer.StatementInvoicesFormatType invoice_format = 7; */
        if (message.invoiceFormat !== 0)
            writer.tag(7, WireType.Varint).int32(message.invoiceFormat);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.EmailCustomerSaleHistoryPDFReq
 */
export const EmailCustomerSaleHistoryPDFReq = new EmailCustomerSaleHistoryPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailCustomerSaleHistoryPDFRes$Type extends MessageType<EmailCustomerSaleHistoryPDFRes> {
    constructor() {
        super("rd.api.customer.EmailCustomerSaleHistoryPDFRes", []);
    }
    create(value?: PartialMessage<EmailCustomerSaleHistoryPDFRes>): EmailCustomerSaleHistoryPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EmailCustomerSaleHistoryPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailCustomerSaleHistoryPDFRes): EmailCustomerSaleHistoryPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailCustomerSaleHistoryPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.EmailCustomerSaleHistoryPDFRes
 */
export const EmailCustomerSaleHistoryPDFRes = new EmailCustomerSaleHistoryPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailContractorRewardsInvitationReq$Type extends MessageType<EmailContractorRewardsInvitationReq> {
    constructor() {
        super("rd.api.customer.EmailContractorRewardsInvitationReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<EmailContractorRewardsInvitationReq>): EmailContractorRewardsInvitationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EmailContractorRewardsInvitationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailContractorRewardsInvitationReq): EmailContractorRewardsInvitationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailContractorRewardsInvitationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.EmailContractorRewardsInvitationReq
 */
export const EmailContractorRewardsInvitationReq = new EmailContractorRewardsInvitationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailContractorRewardsInvitationRes$Type extends MessageType<EmailContractorRewardsInvitationRes> {
    constructor() {
        super("rd.api.customer.EmailContractorRewardsInvitationRes", []);
    }
    create(value?: PartialMessage<EmailContractorRewardsInvitationRes>): EmailContractorRewardsInvitationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EmailContractorRewardsInvitationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailContractorRewardsInvitationRes): EmailContractorRewardsInvitationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailContractorRewardsInvitationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.EmailContractorRewardsInvitationRes
 */
export const EmailContractorRewardsInvitationRes = new EmailContractorRewardsInvitationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerSalesReminderReq$Type extends MessageType<UpdateCustomerSalesReminderReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerSalesReminderReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "sales_reminder", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.log": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerSalesReminderReq>): UpdateCustomerSalesReminderReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.salesReminder = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerSalesReminderReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerSalesReminderReq): UpdateCustomerSalesReminderReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string sales_reminder */ 2:
                    message.salesReminder = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerSalesReminderReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string sales_reminder = 2; */
        if (message.salesReminder !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.salesReminder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerSalesReminderReq
 */
export const UpdateCustomerSalesReminderReq = new UpdateCustomerSalesReminderReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerSalesReminderRes$Type extends MessageType<UpdateCustomerSalesReminderRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerSalesReminderRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerSalesReminderRes>): UpdateCustomerSalesReminderRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerSalesReminderRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerSalesReminderRes): UpdateCustomerSalesReminderRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerSalesReminderRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerSalesReminderRes
 */
export const UpdateCustomerSalesReminderRes = new UpdateCustomerSalesReminderRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertCustomersReq$Type extends MessageType<BulkUpsertCustomersReq> {
    constructor() {
        super("rd.api.customer.BulkUpsertCustomersReq", [
            { no: 1, name: "file_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "write_changes", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertCustomersReq>): BulkUpsertCustomersReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fileUrl = "";
        message.writeChanges = false;
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertCustomersReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertCustomersReq): BulkUpsertCustomersReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string file_url */ 1:
                    message.fileUrl = reader.string();
                    break;
                case /* bool write_changes */ 2:
                    message.writeChanges = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertCustomersReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string file_url = 1; */
        if (message.fileUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fileUrl);
        /* bool write_changes = 2; */
        if (message.writeChanges !== false)
            writer.tag(2, WireType.Varint).bool(message.writeChanges);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.BulkUpsertCustomersReq
 */
export const BulkUpsertCustomersReq = new BulkUpsertCustomersReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertCustomersRes$Type extends MessageType<BulkUpsertCustomersRes> {
    constructor() {
        super("rd.api.customer.BulkUpsertCustomersRes", [
            { no: 1, name: "summary", kind: "message", T: () => Summary }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertCustomersRes>): BulkUpsertCustomersRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertCustomersRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertCustomersRes): BulkUpsertCustomersRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.bub.Summary summary */ 1:
                    message.summary = Summary.internalBinaryRead(reader, reader.uint32(), options, message.summary);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertCustomersRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.bub.Summary summary = 1; */
        if (message.summary)
            Summary.internalBinaryWrite(message.summary, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.BulkUpsertCustomersRes
 */
export const BulkUpsertCustomersRes = new BulkUpsertCustomersRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertCustomerContactsReq$Type extends MessageType<BulkUpsertCustomerContactsReq> {
    constructor() {
        super("rd.api.customer.BulkUpsertCustomerContactsReq", [
            { no: 1, name: "file_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "write_changes", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertCustomerContactsReq>): BulkUpsertCustomerContactsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fileUrl = "";
        message.writeChanges = false;
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertCustomerContactsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertCustomerContactsReq): BulkUpsertCustomerContactsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string file_url */ 1:
                    message.fileUrl = reader.string();
                    break;
                case /* bool write_changes */ 2:
                    message.writeChanges = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertCustomerContactsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string file_url = 1; */
        if (message.fileUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fileUrl);
        /* bool write_changes = 2; */
        if (message.writeChanges !== false)
            writer.tag(2, WireType.Varint).bool(message.writeChanges);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.BulkUpsertCustomerContactsReq
 */
export const BulkUpsertCustomerContactsReq = new BulkUpsertCustomerContactsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertCustomerContactsRes$Type extends MessageType<BulkUpsertCustomerContactsRes> {
    constructor() {
        super("rd.api.customer.BulkUpsertCustomerContactsRes", [
            { no: 1, name: "summary", kind: "message", T: () => Summary }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertCustomerContactsRes>): BulkUpsertCustomerContactsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertCustomerContactsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertCustomerContactsRes): BulkUpsertCustomerContactsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.bub.Summary summary */ 1:
                    message.summary = Summary.internalBinaryRead(reader, reader.uint32(), options, message.summary);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertCustomerContactsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.bub.Summary summary = 1; */
        if (message.summary)
            Summary.internalBinaryWrite(message.summary, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.BulkUpsertCustomerContactsRes
 */
export const BulkUpsertCustomerContactsRes = new BulkUpsertCustomerContactsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertJobsReq$Type extends MessageType<BulkUpsertJobsReq> {
    constructor() {
        super("rd.api.customer.BulkUpsertJobsReq", [
            { no: 1, name: "file_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "write_changes", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertJobsReq>): BulkUpsertJobsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fileUrl = "";
        message.writeChanges = false;
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertJobsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertJobsReq): BulkUpsertJobsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string file_url */ 1:
                    message.fileUrl = reader.string();
                    break;
                case /* bool write_changes */ 2:
                    message.writeChanges = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertJobsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string file_url = 1; */
        if (message.fileUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fileUrl);
        /* bool write_changes = 2; */
        if (message.writeChanges !== false)
            writer.tag(2, WireType.Varint).bool(message.writeChanges);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.BulkUpsertJobsReq
 */
export const BulkUpsertJobsReq = new BulkUpsertJobsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertJobsRes$Type extends MessageType<BulkUpsertJobsRes> {
    constructor() {
        super("rd.api.customer.BulkUpsertJobsRes", [
            { no: 1, name: "summary", kind: "message", T: () => Summary$ }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertJobsRes>): BulkUpsertJobsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertJobsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertJobsRes): BulkUpsertJobsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.bubv2.Summary summary */ 1:
                    message.summary = Summary$.internalBinaryRead(reader, reader.uint32(), options, message.summary);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertJobsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.bubv2.Summary summary = 1; */
        if (message.summary)
            Summary$.internalBinaryWrite(message.summary, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.BulkUpsertJobsRes
 */
export const BulkUpsertJobsRes = new BulkUpsertJobsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateNextJobIdentifierReq$Type extends MessageType<GenerateNextJobIdentifierReq> {
    constructor() {
        super("rd.api.customer.GenerateNextJobIdentifierReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GenerateNextJobIdentifierReq>): GenerateNextJobIdentifierReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GenerateNextJobIdentifierReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateNextJobIdentifierReq): GenerateNextJobIdentifierReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateNextJobIdentifierReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GenerateNextJobIdentifierReq
 */
export const GenerateNextJobIdentifierReq = new GenerateNextJobIdentifierReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateNextJobIdentifierRes$Type extends MessageType<GenerateNextJobIdentifierRes> {
    constructor() {
        super("rd.api.customer.GenerateNextJobIdentifierRes", [
            { no: 1, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GenerateNextJobIdentifierRes>): GenerateNextJobIdentifierRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        if (value !== undefined)
            reflectionMergePartial<GenerateNextJobIdentifierRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateNextJobIdentifierRes): GenerateNextJobIdentifierRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string identifier */ 1:
                    message.identifier = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateNextJobIdentifierRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string identifier = 1; */
        if (message.identifier !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.identifier);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.GenerateNextJobIdentifierRes
 */
export const GenerateNextJobIdentifierRes = new GenerateNextJobIdentifierRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateJobReq$Type extends MessageType<CreateJobReq> {
    constructor() {
        super("rd.api.customer.CreateJobReq", [
            { no: 1, name: "parent_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 4, name: "address", kind: "message", T: () => Address }
        ]);
    }
    create(value?: PartialMessage<CreateJobReq>): CreateJobReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.identifier = "";
        if (value !== undefined)
            reflectionMergePartial<CreateJobReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateJobReq): CreateJobReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID parent_id */ 1:
                    message.parentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.parentId);
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string identifier */ 3:
                    message.identifier = reader.string();
                    break;
                case /* rd.proto.address.Address address */ 4:
                    message.address = Address.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateJobReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID parent_id = 1; */
        if (message.parentId)
            UUID.internalBinaryWrite(message.parentId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string identifier = 3; */
        if (message.identifier !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.identifier);
        /* rd.proto.address.Address address = 4; */
        if (message.address)
            Address.internalBinaryWrite(message.address, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.CreateJobReq
 */
export const CreateJobReq = new CreateJobReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateJobRes$Type extends MessageType<CreateJobRes> {
    constructor() {
        super("rd.api.customer.CreateJobRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<CreateJobRes>): CreateJobRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateJobRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateJobRes): CreateJobRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateJobRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.CreateJobRes
 */
export const CreateJobRes = new CreateJobRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldReceiveJobStatementsReq$Type extends MessageType<UpdateCustomerShouldReceiveJobStatementsReq> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldReceiveJobStatementsReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "should_receive_job_statements", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomerShouldReceiveJobStatementsReq>): UpdateCustomerShouldReceiveJobStatementsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldReceiveJobStatements = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldReceiveJobStatementsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldReceiveJobStatementsReq): UpdateCustomerShouldReceiveJobStatementsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool should_receive_job_statements */ 2:
                    message.shouldReceiveJobStatements = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldReceiveJobStatementsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool should_receive_job_statements = 2; */
        if (message.shouldReceiveJobStatements !== false)
            writer.tag(2, WireType.Varint).bool(message.shouldReceiveJobStatements);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldReceiveJobStatementsReq
 */
export const UpdateCustomerShouldReceiveJobStatementsReq = new UpdateCustomerShouldReceiveJobStatementsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerShouldReceiveJobStatementsRes$Type extends MessageType<UpdateCustomerShouldReceiveJobStatementsRes> {
    constructor() {
        super("rd.api.customer.UpdateCustomerShouldReceiveJobStatementsRes", []);
    }
    create(value?: PartialMessage<UpdateCustomerShouldReceiveJobStatementsRes>): UpdateCustomerShouldReceiveJobStatementsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomerShouldReceiveJobStatementsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomerShouldReceiveJobStatementsRes): UpdateCustomerShouldReceiveJobStatementsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomerShouldReceiveJobStatementsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.UpdateCustomerShouldReceiveJobStatementsRes
 */
export const UpdateCustomerShouldReceiveJobStatementsRes = new UpdateCustomerShouldReceiveJobStatementsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConvertToJobReq$Type extends MessageType<ConvertToJobReq> {
    constructor() {
        super("rd.api.customer.ConvertToJobReq", [
            { no: 1, name: "original_customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "parent_customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ConvertToJobReq>): ConvertToJobReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConvertToJobReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConvertToJobReq): ConvertToJobReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID original_customer_id */ 1:
                    message.originalCustomerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.originalCustomerId);
                    break;
                case /* rd.proto.uuid.UUID parent_customer_id */ 2:
                    message.parentCustomerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.parentCustomerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConvertToJobReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID original_customer_id = 1; */
        if (message.originalCustomerId)
            UUID.internalBinaryWrite(message.originalCustomerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID parent_customer_id = 2; */
        if (message.parentCustomerId)
            UUID.internalBinaryWrite(message.parentCustomerId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.ConvertToJobReq
 */
export const ConvertToJobReq = new ConvertToJobReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConvertToJobRes$Type extends MessageType<ConvertToJobRes> {
    constructor() {
        super("rd.api.customer.ConvertToJobRes", []);
    }
    create(value?: PartialMessage<ConvertToJobRes>): ConvertToJobRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConvertToJobRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConvertToJobRes): ConvertToJobRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConvertToJobRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.ConvertToJobRes
 */
export const ConvertToJobRes = new ConvertToJobRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCustomerTagsReq$Type extends MessageType<ListCustomerTagsReq> {
    constructor() {
        super("rd.api.customer.ListCustomerTagsReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ListCustomerTagsReq>): ListCustomerTagsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListCustomerTagsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListCustomerTagsReq): ListCustomerTagsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListCustomerTagsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.ListCustomerTagsReq
 */
export const ListCustomerTagsReq = new ListCustomerTagsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCustomerTagsRes$Type extends MessageType<ListCustomerTagsRes> {
    constructor() {
        super("rd.api.customer.ListCustomerTagsRes", [
            { no: 1, name: "tags", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Tag }
        ]);
    }
    create(value?: PartialMessage<ListCustomerTagsRes>): ListCustomerTagsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tags = [];
        if (value !== undefined)
            reflectionMergePartial<ListCustomerTagsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListCustomerTagsRes): ListCustomerTagsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.tag.Tag tags */ 1:
                    message.tags.push(Tag.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListCustomerTagsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.tag.Tag tags = 1; */
        for (let i = 0; i < message.tags.length; i++)
            Tag.internalBinaryWrite(message.tags[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.ListCustomerTagsRes
 */
export const ListCustomerTagsRes = new ListCustomerTagsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AttachNewCustomerTagReq$Type extends MessageType<AttachNewCustomerTagReq> {
    constructor() {
        super("rd.api.customer.AttachNewCustomerTagReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "tag_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<AttachNewCustomerTagReq>): AttachNewCustomerTagReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tagName = "";
        if (value !== undefined)
            reflectionMergePartial<AttachNewCustomerTagReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AttachNewCustomerTagReq): AttachNewCustomerTagReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* string tag_name */ 2:
                    message.tagName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AttachNewCustomerTagReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string tag_name = 2; */
        if (message.tagName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tagName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.AttachNewCustomerTagReq
 */
export const AttachNewCustomerTagReq = new AttachNewCustomerTagReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AttachNewCustomerTagRes$Type extends MessageType<AttachNewCustomerTagRes> {
    constructor() {
        super("rd.api.customer.AttachNewCustomerTagRes", []);
    }
    create(value?: PartialMessage<AttachNewCustomerTagRes>): AttachNewCustomerTagRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AttachNewCustomerTagRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AttachNewCustomerTagRes): AttachNewCustomerTagRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AttachNewCustomerTagRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.AttachNewCustomerTagRes
 */
export const AttachNewCustomerTagRes = new AttachNewCustomerTagRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AttachCustomerTagReq$Type extends MessageType<AttachCustomerTagReq> {
    constructor() {
        super("rd.api.customer.AttachCustomerTagReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "tag_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<AttachCustomerTagReq>): AttachCustomerTagReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AttachCustomerTagReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AttachCustomerTagReq): AttachCustomerTagReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.uuid.UUID tag_id */ 2:
                    message.tagId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.tagId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AttachCustomerTagReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID tag_id = 2; */
        if (message.tagId)
            UUID.internalBinaryWrite(message.tagId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.AttachCustomerTagReq
 */
export const AttachCustomerTagReq = new AttachCustomerTagReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AttachCustomerTagRes$Type extends MessageType<AttachCustomerTagRes> {
    constructor() {
        super("rd.api.customer.AttachCustomerTagRes", []);
    }
    create(value?: PartialMessage<AttachCustomerTagRes>): AttachCustomerTagRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AttachCustomerTagRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AttachCustomerTagRes): AttachCustomerTagRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AttachCustomerTagRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.AttachCustomerTagRes
 */
export const AttachCustomerTagRes = new AttachCustomerTagRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DetachCustomerTagReq$Type extends MessageType<DetachCustomerTagReq> {
    constructor() {
        super("rd.api.customer.DetachCustomerTagReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "tag_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DetachCustomerTagReq>): DetachCustomerTagReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DetachCustomerTagReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DetachCustomerTagReq): DetachCustomerTagReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.uuid.UUID tag_id */ 2:
                    message.tagId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.tagId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DetachCustomerTagReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID tag_id = 2; */
        if (message.tagId)
            UUID.internalBinaryWrite(message.tagId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.DetachCustomerTagReq
 */
export const DetachCustomerTagReq = new DetachCustomerTagReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DetachCustomerTagRes$Type extends MessageType<DetachCustomerTagRes> {
    constructor() {
        super("rd.api.customer.DetachCustomerTagRes", []);
    }
    create(value?: PartialMessage<DetachCustomerTagRes>): DetachCustomerTagRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DetachCustomerTagRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DetachCustomerTagRes): DetachCustomerTagRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DetachCustomerTagRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.customer.DetachCustomerTagRes
 */
export const DetachCustomerTagRes = new DetachCustomerTagRes$Type();
/**
 * @generated ServiceType for protobuf service rd.api.customer.CustomerService
 */
export const CustomerService = new ServiceType("rd.api.customer.CustomerService", [
    { name: "GetCustomer", options: {}, I: GetCustomerReq, O: GetCustomerRes },
    { name: "CreateCustomer", options: {}, I: CreateCustomerReq, O: CreateCustomerRes },
    { name: "DuplicateCustomer", options: {}, I: DuplicateCustomerReq, O: DuplicateCustomerRes },
    { name: "CreateCustomerInteraction", options: {}, I: CreateCustomerInteractionReq, O: CreateCustomerInteractionRes },
    { name: "UpdateCustomerGeneralInformation", options: {}, I: UpdateCustomerGeneralInformationReq, O: UpdateCustomerGeneralInformationRes },
    { name: "UpdateCustomerExemptions", options: {}, I: UpdateCustomerExemptionsReq, O: UpdateCustomerExemptionsRes },
    { name: "UpdateCustomerNotes", options: {}, I: UpdateCustomerNotesReq, O: UpdateCustomerNotesRes },
    { name: "UpdateCustomerCreditLimit", options: {}, I: UpdateCustomerCreditLimitReq, O: UpdateCustomerCreditLimitRes },
    { name: "UpdateCustomerIsOnCreditHold", options: {}, I: UpdateCustomerIsOnCreditHoldReq, O: UpdateCustomerIsOnCreditHoldRes },
    { name: "UpdateCustomerIsActive", options: {}, I: UpdateCustomerIsActiveReq, O: UpdateCustomerIsActiveRes },
    { name: "UpdateCustomerShouldRequirePO", options: {}, I: UpdateCustomerShouldRequirePOReq, O: UpdateCustomerShouldRequirePORes },
    { name: "UpdateCustomerShouldPrintInvoicesAndReceipts", options: {}, I: UpdateCustomerShouldPrintInvoicesAndReceiptsReq, O: UpdateCustomerShouldPrintInvoicesAndReceiptsRes },
    { name: "UpdateCustomerShouldAutopayStatementBalances", options: {}, I: UpdateCustomerShouldAutopayStatementBalancesReq, O: UpdateCustomerShouldAutopayStatementBalancesRes },
    { name: "UpdateCustomerShouldMailStatements", options: {}, I: UpdateCustomerShouldMailStatementsReq, O: UpdateCustomerShouldMailStatementsRes },
    { name: "UpdateCustomerShouldRequireCustomerContact", options: {}, I: UpdateCustomerShouldRequireCustomerContactReq, O: UpdateCustomerShouldRequireCustomerContactRes },
    { name: "UpdateCustomerShouldRequireSaleNotes", options: {}, I: UpdateCustomerShouldRequireSaleNotesReq, O: UpdateCustomerShouldRequireSaleNotesRes },
    { name: "UpdateCustomerShouldRequireInternalSaleNotes", options: {}, I: UpdateCustomerShouldRequireInternalSaleNotesReq, O: UpdateCustomerShouldRequireInternalSaleNotesRes },
    { name: "UpdateCustomerFinancingTerm", options: {}, I: UpdateCustomerFinancingTermReq, O: UpdateCustomerFinancingTermRes },
    { name: "UpdateCustomerFinanceChargeSetting", options: {}, I: UpdateCustomerFinanceChargeSettingReq, O: UpdateCustomerFinanceChargeSettingRes },
    { name: "UpdateCustomerRep", options: {}, I: UpdateCustomerRepReq, O: UpdateCustomerRepRes },
    { name: "ListPurchaseOrdersForCustomer", options: {}, I: ListPurchaseOrdersForCustomerReq, O: ListPurchaseOrdersForCustomerRes },
    { name: "ListInteractionsForCustomer", options: {}, I: ListInteractionsForCustomerReq, O: ListInteractionsForCustomerRes },
    { name: "UpdateCustomerContractorRewards", options: {}, I: UpdateCustomerContractorRewardsReq, O: UpdateCustomerContractorRewardsRes },
    { name: "UpdateCustomerShouldRequireReceiptSignature", options: {}, I: UpdateCustomerShouldRequireReceiptSignatureReq, O: UpdateCustomerShouldRequireReceiptSignatureRes },
    { name: "UpdateCustomerPricingTier", options: {}, I: UpdateCustomerPricingTierReq, O: UpdateCustomerPricingTierRes },
    { name: "UpdateCustomerGeneralInfoMobile", options: {}, I: UpdateCustomerGeneralInfoMobileReq, O: UpdateCustomerGeneralInfoMobileRes },
    { name: "UpdateCustomerSalesReminder", options: {}, I: UpdateCustomerSalesReminderReq, O: UpdateCustomerSalesReminderRes },
    { name: "ListCustomersForRep", options: {}, I: ListCustomersForRepReq, O: ListCustomersForRepRes },
    { name: "GetCustomerCountForTier", options: {}, I: GetCustomerCountForTierReq, O: GetCustomerCountForTierRes },
    { name: "GetJobCountForCustomer", options: {}, I: GetJobCountForCustomerReq, O: GetJobCountForCustomerRes },
    { name: "GetActiveCustomerCount", options: {}, I: GetActiveCustomerCountReq, O: GetActiveCustomerCountRes },
    { name: "EnrollCustomerInFanBuilderLoyalty", options: {}, I: EnrollCustomerInFanBuilderLoyaltyReq, O: EnrollCustomerInFanBuilderLoyaltyRes },
    { name: "GetCustomerFanBuilderLoyalty", options: {}, I: GetCustomerFanBuilderLoyaltyReq, O: GetCustomerFanBuilderLoyaltyRes },
    { name: "ValidateFanBuilderLoyaltyCoupon", options: {}, I: ValidateFanBuilderLoyaltyCouponReq, O: ValidateFanBuilderLoyaltyCouponRes },
    { name: "UpdateCustomerShouldRequireJob", options: {}, I: UpdateCustomerShouldRequireJobReq, O: UpdateCustomerShouldRequireJobRes },
    { name: "UpdateCustomerStatementInvoicesFormat", options: {}, I: UpdateCustomerStatementInvoicesFormatReq, O: UpdateCustomerStatementInvoicesFormatRes },
    { name: "UpdateCustomerShouldHidePricesOnInvoices", options: {}, I: UpdateCustomerShouldHidePricesOnInvoicesReq, O: UpdateCustomerShouldHidePricesOnInvoicesRes },
    { name: "UpdateCustomerStatementType", options: {}, I: UpdateCustomerStatementTypeReq, O: UpdateCustomerStatementTypeRes },
    { name: "UpdateCustomerType", options: {}, I: UpdateCustomerTypeReq, O: UpdateCustomerTypeRes },
    { name: "UpdateCustomerIsCardSurchargeExempt", options: {}, I: UpdateCustomerIsCardSurchargeExemptReq, O: UpdateCustomerIsCardSurchargeExemptRes },
    { name: "MergeCustomers", options: {}, I: MergeCustomersReq, O: MergeCustomersRes },
    { name: "GetLastStatementRun", options: {}, I: GetLastStatementRunReq, O: GetLastStatementRunRes },
    { name: "MailBulkStatementRun", options: {}, I: MailBulkStatementRunReq, O: MailBulkStatementRunRes },
    { name: "ListStatementsForCustomer", options: {}, I: ListStatementsForCustomerReq, O: ListStatementsForCustomerRes },
    { name: "EmailCustomerStatementPDF", options: {}, I: EmailCustomerStatementPDFReq, O: EmailCustomerStatementPDFRes },
    { name: "GenerateStatementsForCustomers", options: {}, I: GenerateStatementsForCustomersReq, O: GenerateStatementsForCustomersRes },
    { name: "BulkGenerateStatementsForCustomers", options: {}, I: BulkGenerateStatementsForCustomersReq, O: BulkGenerateStatementsForCustomersRes },
    { name: "EmailStatementRun", options: {}, I: EmailStatementRunReq, O: EmailStatementRunRes },
    { name: "GetStatementRun", options: {}, I: GetStatementRunReq, O: GetStatementRunRes },
    { name: "GetStatementRunStats", options: {}, I: GetStatementRunStatsReq, O: GetStatementRunStatsRes },
    { name: "EmailAllInStatementRun", options: {}, I: EmailAllInStatementRunReq, O: EmailAllInStatementRunRes },
    { name: "CountCustomersForBulkStatement", options: {}, I: CountCustomersForBulkStatementReq, O: CountCustomersForBulkStatementRes },
    { name: "UpdateCustomerRestrictOutstandingInvoicesToStatementPeriod", options: {}, I: UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodReq, O: UpdateCustomerRestrictOutstandingInvoicesToStatementPeriodRes },
    { name: "GenerateStatementRunPdfs", options: {}, I: GenerateStatementRunPdfsReq, O: GenerateStatementRunPdfsRes },
    { name: "GetLastStatementRunId", options: {}, I: GetLastStatementRunIdReq, O: GetLastStatementRunIdRes },
    { name: "GetLastStatementRunSendStats", options: {}, I: GetLastStatementRunSendStatsReq, O: GetLastStatementRunSendStatsRes },
    { name: "GenerateAndSendIndividualCustomerStatement", options: {}, I: GenerateAndSendIndividualCustomerStatementReq, O: GenerateAndSendIndividualCustomerStatementRes },
    { name: "GetCustomerSavedCards", options: {}, I: GetCustomerSavedCardsReq, O: GetCustomerSavedCardsRes },
    { name: "UpdateCustomerPrimaryCard", options: {}, I: UpdateCustomerPrimaryCardReq, O: UpdateCustomerPrimaryCardRes },
    { name: "DeleteCustomerCard", options: {}, I: DeleteCustomerCardReq, O: DeleteCustomerCardRes },
    { name: "AddCustomerCard", options: {}, I: AddCustomerCardReq, O: AddCustomerCardRes },
    { name: "UpdateCustomerCard", options: {}, I: UpdateCustomerCardReq, O: UpdateCustomerCardRes },
    { name: "SendACHPaymentEmailAndSms", options: {}, I: SendACHPaymentEmailAndSmsReq, O: SendACHPaymentEmailAndSmsRes },
    { name: "GetCustomerSavedBankAccounts", options: {}, I: GetCustomerSavedBankAccountsReq, O: GetCustomerSavedBankAccountsRes },
    { name: "CreateCustomerContact", options: {}, I: CreateCustomerContactReq, O: CreateCustomerContactRes },
    { name: "UpdateCustomerContact", options: {}, I: UpdateCustomerContactReq, O: UpdateCustomerContactRes },
    { name: "DeactivateCustomerContact", options: {}, I: DeactivateCustomerContactReq, O: DeactivateCustomerContactRes },
    { name: "GetCustomerSaleHistoryPDF", options: {}, I: GetCustomerSaleHistoryPDFReq, O: GetCustomerSaleHistoryPDFRes },
    { name: "EmailCustomerSaleHistoryPDF", options: {}, I: EmailCustomerSaleHistoryPDFReq, O: EmailCustomerSaleHistoryPDFRes },
    { name: "EmailContractorRewardsInvitation", options: {}, I: EmailContractorRewardsInvitationReq, O: EmailContractorRewardsInvitationRes },
    { name: "BulkUpsertCustomers", options: {}, I: BulkUpsertCustomersReq, O: BulkUpsertCustomersRes },
    { name: "BulkUpsertCustomerContacts", options: {}, I: BulkUpsertCustomerContactsReq, O: BulkUpsertCustomerContactsRes },
    { name: "BulkUpsertJobs", options: {}, I: BulkUpsertJobsReq, O: BulkUpsertJobsRes },
    { name: "GenerateNextJobIdentifier", options: {}, I: GenerateNextJobIdentifierReq, O: GenerateNextJobIdentifierRes },
    { name: "CreateJob", options: {}, I: CreateJobReq, O: CreateJobRes },
    { name: "UpdateCustomerShouldReceiveJobStatements", options: {}, I: UpdateCustomerShouldReceiveJobStatementsReq, O: UpdateCustomerShouldReceiveJobStatementsRes },
    { name: "ConvertToJob", options: {}, I: ConvertToJobReq, O: ConvertToJobRes },
    { name: "ListCustomerTags", options: {}, I: ListCustomerTagsReq, O: ListCustomerTagsRes },
    { name: "AttachNewCustomerTag", options: {}, I: AttachNewCustomerTagReq, O: AttachNewCustomerTagRes },
    { name: "AttachCustomerTag", options: {}, I: AttachCustomerTagReq, O: AttachCustomerTagRes },
    { name: "DetachCustomerTag", options: {}, I: DetachCustomerTagReq, O: DetachCustomerTagRes }
]);
